var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCrmLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4217_57369)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 62,
    height: 42,
    transform: "translate(0 11)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4099 33.6276C33.1121 33.6276 32.8363 33.6975 32.5807 33.8374C32.3251 33.9772 32.1305 34.1631 31.997 34.395C31.8579 34.149 31.6627 33.9594 31.4096 33.8263C31.1565 33.6932 30.8694 33.627 30.547 33.627C30.2939 33.627 30.0622 33.6754 29.8519 33.7717C29.641 33.8687 29.4691 34.0012 29.335 34.1705V33.6852H28.2942V37.6991H29.335V35.4821C29.335 35.168 29.4181 34.9275 29.5843 34.7612C29.7505 34.5944 29.9772 34.5116 30.2649 34.5116C30.5527 34.5116 30.7705 34.595 30.9342 34.7612C31.0979 34.9281 31.1798 35.168 31.1798 35.4821V37.6991H32.2205V35.4821C32.2205 35.168 32.3037 34.9275 32.4699 34.7612C32.6361 34.5944 32.8602 34.5116 33.1429 34.5116C33.4256 34.5116 33.6485 34.595 33.8122 34.7612C33.9759 34.9275 34.0578 35.168 34.0578 35.4821V37.6991H35.0986V35.3446C35.0986 34.8036 34.9437 34.3821 34.6339 34.0803C34.3241 33.7785 33.9161 33.6276 33.4105 33.6276H33.4099Z",
    fill: "#42A100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.3366 33.6279C43.0785 33.6279 42.8423 33.6776 42.6264 33.7764C42.4104 33.8752 42.2335 34.012 42.095 34.1856V33.6856H41.0542V37.6995H42.095V35.4824C42.095 35.1634 42.1781 34.9187 42.3443 34.7469C42.5105 34.5757 42.7372 34.4898 43.0249 34.4898C43.3127 34.4898 43.5305 34.5757 43.6942 34.7469C43.8579 34.9187 43.9398 35.1634 43.9398 35.4824V37.6995H44.9806V35.345C44.9806 34.8039 44.8294 34.3825 44.5272 34.0807C44.225 33.7788 43.8283 33.6279 43.3372 33.6279H43.3366Z",
    fill: "#42A100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.5342 36.49L51.4708 33.6865H50.3035L51.9543 37.5986L51.0622 39.5978H52.1703L54.7203 33.6865H53.6128L52.5342 36.49Z",
    fill: "#42A100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.135 33.8781C38.8126 33.707 38.4531 33.6211 38.0571 33.6211C37.661 33.6211 37.3009 33.707 36.9785 33.8781C36.6561 34.0493 36.4024 34.2922 36.2167 34.6063C36.0309 34.9204 35.9377 35.2823 35.9377 35.6928C35.9377 36.1032 36.0284 36.4657 36.2091 36.7792C36.3898 37.0933 36.6391 37.3356 36.9565 37.5074C37.2738 37.6791 37.6308 37.7644 38.0275 37.7644C38.4241 37.7644 38.7918 37.6785 39.1167 37.5074C39.4416 37.3362 39.6991 37.0933 39.8899 36.7792C40.0807 36.4651 40.1764 36.1032 40.1764 35.6928C40.1764 35.2823 40.0832 34.9198 39.8975 34.6063C39.7117 34.2922 39.4574 34.0499 39.1356 33.8781H39.135ZM38.9568 36.3449C38.8573 36.5234 38.7251 36.6577 38.5589 36.7467C38.3927 36.8362 38.2157 36.8804 38.0275 36.8804C37.7303 36.8804 37.4835 36.778 37.2877 36.5725C37.0918 36.3669 36.9936 36.0737 36.9936 35.6921C36.9936 35.3106 37.0944 35.0173 37.2946 34.8118C37.4954 34.6063 37.7448 34.5039 38.042 34.5039C38.3391 34.5039 38.591 34.6063 38.7969 34.8118C39.0028 35.0173 39.1054 35.3106 39.1054 35.6921C39.1054 35.948 39.0557 36.1657 38.9568 36.3442V36.3449Z",
    fill: "#42A100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.9315 33.8671C48.6218 33.7027 48.2711 33.6211 47.8794 33.6211C47.4878 33.6211 47.1138 33.7058 46.8015 33.8745C46.4892 34.0438 46.2462 34.2849 46.073 34.599C45.8992 34.913 45.813 35.2774 45.813 35.6928C45.813 36.1081 45.9011 36.4657 46.0768 36.7792C46.2525 37.0933 46.498 37.3356 46.8128 37.5074C47.1276 37.6791 47.4834 37.7644 47.8801 37.7644C48.3705 37.7644 48.7848 37.6399 49.1217 37.3914C49.4585 37.143 49.6871 36.8252 49.8055 36.4387H48.6828C48.5191 36.7626 48.244 36.924 47.8574 36.924C47.5898 36.924 47.3638 36.8418 47.1805 36.678C46.9973 36.5136 46.8928 36.2866 46.8682 35.997H49.8797C49.8993 35.8811 49.9093 35.751 49.9093 35.6056C49.9093 35.2143 49.8237 34.8676 49.6531 34.5658C49.4818 34.264 49.2413 34.0309 48.9322 33.8665L48.9315 33.8671ZM46.8758 35.3161C46.9155 35.0456 47.0231 34.8345 47.1994 34.6824C47.3751 34.5302 47.5923 34.4542 47.8498 34.4542C48.1225 34.4542 48.3529 34.5327 48.5412 34.6897C48.7294 34.8468 48.8264 35.0554 48.8314 35.3167H46.8758V35.3161Z",
    fill: "#42A100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4099 41.2057C33.1121 41.2057 32.8363 41.2756 32.5807 41.4155C32.3251 41.5554 32.1305 41.7412 31.997 41.9731C31.8579 41.7271 31.6627 41.5376 31.4096 41.4045C31.1565 41.2713 30.8694 41.2051 30.547 41.2051C30.2939 41.2051 30.0622 41.2535 29.8519 41.3499C29.641 41.4468 29.4691 41.5793 29.335 41.7486V41.2634H28.2942V45.2772H29.335V43.0602C29.335 42.7461 29.4181 42.5056 29.5843 42.3394C29.7505 42.1725 29.9772 42.0897 30.2649 42.0897C30.5527 42.0897 30.7705 42.1731 30.9342 42.3394C31.0979 42.5062 31.1798 42.7461 31.1798 43.0602V45.2772H32.2205V43.0602C32.2205 42.7461 32.3037 42.5056 32.4699 42.3394C32.6361 42.1725 32.8602 42.0897 33.1429 42.0897C33.4256 42.0897 33.6485 42.1731 33.8122 42.3394C33.9759 42.5062 34.0578 42.7461 34.0578 43.0602V45.2772H35.0986V42.9228C35.0986 42.3817 34.9437 41.9602 34.6339 41.6584C34.3241 41.3566 33.9161 41.2057 33.4105 41.2057H33.4099Z",
    fill: "#42A100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.1286 41.2648H43.7749L42.3922 42.9671V39.917H41.3508V45.278H42.3922V43.5683L43.79 45.278H45.1431L43.314 43.2788L45.1286 41.2648Z",
    fill: "#42A100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.3329 39.5977C46.1497 39.5977 45.9967 39.6547 45.8758 39.7676C45.7543 39.8811 45.6938 40.0222 45.6938 40.1915C45.6938 40.3608 45.7543 40.5019 45.8758 40.6154C45.9973 40.7289 46.1497 40.7859 46.3329 40.7859C46.5161 40.7859 46.6685 40.7289 46.79 40.6154C46.9115 40.5019 46.972 40.3608 46.972 40.1915C46.972 40.0222 46.9109 39.8811 46.79 39.7676C46.6685 39.6541 46.5161 39.5977 46.3329 39.5977Z",
    fill: "#42A100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.8455 41.2646H45.8047V45.2785H46.8455V41.2646Z",
    fill: "#42A100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.267 41.2061C50.0095 41.2061 49.7728 41.2557 49.5568 41.3545C49.3415 41.4533 49.1639 41.5901 49.0254 41.7637V41.2637H47.9846V45.2776H49.0254V43.0605C49.0254 42.7415 49.1085 42.4968 49.2747 42.325C49.4409 42.1539 49.6676 42.068 49.9554 42.068C50.2431 42.068 50.4609 42.1539 50.6246 42.325C50.7883 42.4968 50.8702 42.7415 50.8702 43.0605V45.2776H51.911V42.9231C51.911 42.3821 51.7599 41.9606 51.4576 41.6588C51.1554 41.357 50.7588 41.2061 50.2676 41.2061H50.267Z",
    fill: "#42A100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.1723 41.8366C39.0331 41.6532 38.8486 41.501 38.6182 41.3802C38.3877 41.2593 38.1189 41.1992 37.8116 41.1992C37.4597 41.1992 37.1411 41.2839 36.8559 41.4526C36.5706 41.6219 36.3452 41.863 36.179 42.1771C36.0128 42.4912 35.9297 42.8507 35.9297 43.2568C35.9297 43.6629 36.0128 44.031 36.179 44.3469C36.3452 44.6634 36.5706 44.9082 36.8559 45.0824C37.1411 45.2567 37.4572 45.3431 37.8041 45.3431C38.1113 45.3431 38.3827 45.2818 38.6182 45.1585C38.8537 45.0352 39.0382 44.8794 39.1723 44.691V45.2781H40.2206V41.2642H39.1723V41.8366ZM39.0237 43.9046C38.9242 44.0806 38.7907 44.2162 38.622 44.3101C38.4532 44.4046 38.2725 44.4512 38.0792 44.4512C37.8859 44.4512 37.7134 44.4033 37.5478 44.3064C37.3816 44.2101 37.2481 44.0708 37.1461 43.8899C37.0441 43.7089 36.9938 43.4972 36.9938 43.2562C36.9938 43.0151 37.0448 42.8059 37.1461 42.6292C37.2475 42.4531 37.3803 42.3188 37.544 42.2268C37.7078 42.1347 37.8859 42.0887 38.0792 42.0887C38.2725 42.0887 38.4532 42.136 38.622 42.2298C38.7907 42.3237 38.9242 42.4593 39.0237 42.6353C39.1225 42.812 39.1723 43.023 39.1723 43.269C39.1723 43.515 39.1225 43.7267 39.0237 43.9027V43.9046Z",
    fill: "#42A100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.9845 41.8366C55.8504 41.6483 55.6672 41.4949 55.4342 41.3765C55.2013 41.2581 54.9312 41.1992 54.6239 41.1992C54.2719 41.1992 53.9533 41.2839 53.6681 41.4526C53.3829 41.6219 53.1575 41.863 52.9913 42.1771C52.8251 42.4912 52.7419 42.8507 52.7419 43.2568C52.7419 43.6629 52.8251 44.031 52.9913 44.3469C53.1575 44.6634 53.3842 44.9082 53.6719 45.0824C53.959 45.2567 54.2763 45.3432 54.6239 45.3432C54.9261 45.3432 55.195 45.2806 55.4305 45.1548C55.6659 45.0291 55.8504 44.872 55.9845 44.6837V45.307C55.9845 45.6646 55.8901 45.9308 55.7018 46.1075C55.5136 46.2836 55.268 46.3719 54.9658 46.3719C54.7076 46.3719 54.4885 46.3173 54.3078 46.2087C54.1265 46.1002 54.0094 45.9542 53.9546 45.7707H52.9214C52.9711 46.2296 53.1827 46.5915 53.5573 46.8572C53.9313 47.1228 54.4111 47.2559 54.996 47.2559C55.4323 47.2559 55.8038 47.17 56.1111 46.9989C56.4183 46.8271 56.6488 46.5952 56.8024 46.3032C56.956 46.0112 57.0329 45.6787 57.0329 45.307V41.2642H55.9845V41.8366ZM55.8359 43.9046C55.7364 44.0806 55.603 44.2162 55.4342 44.3101C55.2655 44.4046 55.0848 44.4512 54.8915 44.4512C54.6982 44.4512 54.5257 44.4033 54.3601 44.3064C54.1939 44.2101 54.0604 44.0708 53.9584 43.8899C53.8564 43.7089 53.806 43.4972 53.806 43.2562C53.806 43.0151 53.857 42.8059 53.9584 42.6292C54.0598 42.4531 54.1926 42.3188 54.3563 42.2268C54.52 42.1347 54.6982 42.0887 54.8915 42.0887C55.0848 42.0887 55.2655 42.136 55.4342 42.2298C55.603 42.3237 55.7364 42.4593 55.8359 42.6353C55.9348 42.812 55.9845 43.023 55.9845 43.269C55.9845 43.515 55.9348 43.7267 55.8359 43.9027V43.9046Z",
    fill: "#42A100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4099 48.8629C33.1127 48.8629 32.8363 48.9329 32.5807 49.0727C32.3251 49.2126 32.1311 49.3985 31.997 49.6304C31.8579 49.3844 31.6621 49.1948 31.4096 49.0617C31.1565 48.9286 30.8694 48.8623 30.547 48.8623C30.2945 48.8623 30.0622 48.9108 29.8519 49.0071C29.641 49.104 29.4691 49.2365 29.335 49.4058V48.9206H28.2942V52.9345H29.335V50.7174C29.335 50.4033 29.4181 50.1628 29.5843 49.9966C29.7505 49.8297 29.9772 49.7469 30.2649 49.7469C30.5527 49.7469 30.7705 49.8303 30.9342 49.9966C31.0979 50.1635 31.1798 50.4033 31.1798 50.7174V52.9345H32.2205V50.7174C32.2205 50.4033 32.3037 50.1628 32.4699 49.9966C32.6361 49.8297 32.8602 49.7469 33.1429 49.7469C33.4256 49.7469 33.6485 49.8303 33.8122 49.9966C33.9759 50.1635 34.0578 50.4033 34.0578 50.7174V52.9345H35.0986V50.58C35.0986 50.0389 34.9437 49.6175 34.6339 49.3157C34.3241 49.0138 33.9161 48.8629 33.4105 48.8629H33.4099Z",
    fill: "#42A100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.1131 49.719C43.3215 49.719 43.4959 49.7687 43.6375 49.8674C43.7786 49.9662 43.8793 50.103 43.9385 50.2766H45.0611C44.9472 49.8276 44.723 49.4785 44.3881 49.2294C44.0531 48.981 43.6306 48.8564 43.12 48.8564C42.7233 48.8564 42.3714 48.9423 42.0641 49.1135C41.7569 49.2846 41.5163 49.5263 41.3426 49.838C41.1688 50.1496 41.0825 50.5128 41.0825 50.9281C41.0825 51.3434 41.1694 51.7072 41.3426 52.0182C41.5163 52.3299 41.7562 52.5716 42.0641 52.7427C42.3714 52.9145 42.7233 52.9998 43.12 52.9998C43.6256 52.9998 44.0468 52.8715 44.3843 52.6157C44.7211 52.3599 44.9465 52.0145 45.0611 51.5796H43.9385C43.8094 51.9464 43.5343 52.1299 43.1131 52.1299C42.8159 52.1299 42.5804 52.025 42.4066 51.8146C42.2328 51.6041 42.1466 51.3084 42.1466 50.9269C42.1466 50.5453 42.2335 50.2423 42.4066 50.0324C42.5804 49.822 42.8159 49.7171 43.1131 49.7171V49.719Z",
    fill: "#42A100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.0915 49.0627C48.8485 48.9296 48.5708 48.8634 48.2585 48.8634C47.9859 48.8634 47.7378 48.913 47.5149 49.0118C47.292 49.1106 47.1132 49.2474 46.9797 49.421V47.5732H45.939V52.9343H46.9797V50.7172C46.9797 50.3982 47.0628 50.1535 47.2291 49.9817C47.3953 49.8105 47.622 49.7247 47.9097 49.7247C48.1974 49.7247 48.4153 49.8105 48.579 49.9817C48.7427 50.1535 48.8245 50.3982 48.8245 50.7172V52.9343H49.8653V50.5798C49.8653 50.2173 49.7973 49.9075 49.6607 49.6486C49.5241 49.3903 49.3345 49.1946 49.0915 49.0615V49.0627Z",
    fill: "#42A100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.4933 47.2549C51.3101 47.2549 51.1571 47.3119 51.0362 47.4248C50.9147 47.5383 50.8542 47.6794 50.8542 47.8487C50.8542 48.018 50.9147 48.1591 51.0362 48.2726C51.1577 48.3861 51.3101 48.4432 51.4933 48.4432C51.6765 48.4432 51.8289 48.3861 51.9504 48.2726C52.0719 48.1591 52.1324 48.018 52.1324 47.8487C52.1324 47.6794 52.0713 47.5383 51.9504 47.4248C51.8289 47.3113 51.6765 47.2549 51.4933 47.2549Z",
    fill: "#42A100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.0065 48.9209H50.9651V52.9348H52.0065V48.9209Z",
    fill: "#42A100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.4266 48.8633C55.1691 48.8633 54.9323 48.913 54.7164 49.0117C54.5004 49.1105 54.3235 49.2473 54.185 49.4209V48.9209H53.1436V52.9348H54.185V50.7178C54.185 50.3988 54.2681 50.154 54.4343 49.9822C54.6005 49.8111 54.8272 49.7252 55.1149 49.7252C55.4027 49.7252 55.6205 49.8111 55.7842 49.9822C55.9479 50.154 56.0298 50.3988 56.0298 50.7178V52.9348H57.0705V50.5804C57.0705 50.0393 56.9194 49.6178 56.6172 49.316C56.315 49.0142 55.9183 48.8633 55.4278 48.8633H55.4266Z",
    fill: "#42A100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.1723 49.4938C39.0331 49.3104 38.8486 49.1583 38.6182 49.0374C38.3877 48.9166 38.1189 48.8564 37.8116 48.8564C37.4597 48.8564 37.1411 48.9411 36.8559 49.1098C36.5706 49.2791 36.3452 49.5202 36.179 49.8343C36.0128 50.1484 35.9297 50.5079 35.9297 50.914C35.9297 51.3201 36.0128 51.6882 36.179 52.0041C36.3452 52.3207 36.5706 52.5654 36.8559 52.7397C37.1411 52.9139 37.4572 53.0004 37.8041 53.0004C38.1113 53.0004 38.3827 52.939 38.6182 52.8157C38.8537 52.6924 39.0382 52.5366 39.1723 52.3483V52.9354H40.2206V48.9215H39.1723V49.4938ZM39.0237 51.5618C38.9248 51.7379 38.7907 51.8734 38.622 51.9673C38.4532 52.0618 38.2725 52.1084 38.0792 52.1084C37.8859 52.1084 37.7134 52.0606 37.5478 51.9636C37.3816 51.8673 37.2481 51.7281 37.1461 51.5471C37.0448 51.3661 36.9938 51.1545 36.9938 50.9134C36.9938 50.6723 37.0448 50.4631 37.1461 50.2864C37.2475 50.1104 37.3803 49.976 37.544 49.884C37.7078 49.792 37.8859 49.746 38.0792 49.746C38.2725 49.746 38.4532 49.7932 38.622 49.8871C38.7907 49.9809 38.9242 50.1165 39.0237 50.2926C39.1232 50.4692 39.1723 50.6803 39.1723 50.9263C39.1723 51.1723 39.1225 51.3839 39.0237 51.56V51.5618Z",
    fill: "#42A100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62 50.8416C62 50.4502 61.9143 50.1036 61.7431 49.8018C61.5718 49.5 61.3313 49.2668 61.0215 49.1024C60.7117 48.938 60.361 48.8564 59.9694 48.8564C59.5778 48.8564 59.2038 48.9411 58.8915 49.1098C58.5792 49.2791 58.3362 49.5202 58.1624 49.8343C57.9886 50.1484 57.9023 50.5128 57.9023 50.9281C57.9023 51.3434 57.9905 51.7011 58.1662 52.0145C58.3418 52.3286 58.5874 52.571 58.9022 52.7427C59.217 52.9145 59.5727 52.9998 59.9694 52.9998C60.4599 52.9998 60.8742 52.8752 61.211 52.6268C61.5479 52.3783 61.7764 52.0606 61.8954 51.6741H60.7728C60.6091 51.998 60.334 52.1593 59.9474 52.1593C59.6798 52.1593 59.4537 52.0771 59.2705 51.9133C59.0867 51.7489 58.9828 51.5219 58.9582 51.2324H61.9697C61.9893 51.1164 61.9993 50.9864 61.9993 50.841L62 50.8416ZM58.9664 50.552C59.0061 50.2815 59.1137 50.0705 59.29 49.9183C59.4657 49.7662 59.6829 49.6901 59.9404 49.6901C60.2131 49.6901 60.4435 49.7687 60.6318 49.9257C60.82 50.0828 60.917 50.2913 60.922 50.5527H58.9664V50.552Z",
    fill: "#42A100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.4696 16.3447C27.1379 16.3447 26.0581 17.3968 26.0581 18.6943C26.0581 19.9918 27.1379 21.0438 28.4696 21.0438C29.8012 21.0438 30.881 19.9918 30.881 18.6943C30.881 17.3968 29.8012 16.3447 28.4696 16.3447ZM28.4696 16.6962C28.7454 16.6962 29.0079 16.7502 29.2472 16.8484L28.6767 17.8109C28.61 17.7962 28.5407 17.7876 28.4696 17.7876C28.0471 17.7876 27.6907 18.0624 27.5774 18.4385H26.4718C26.5826 17.4588 27.4345 16.6962 28.4696 16.6962ZM28.9298 18.6943C28.9298 18.9421 28.7239 19.1427 28.4696 19.1427C28.2152 19.1427 28.0093 18.9421 28.0093 18.6943C28.0093 18.4464 28.2152 18.2458 28.4696 18.2458C28.7239 18.2458 28.9298 18.4464 28.9298 18.6943ZM26.4818 18.9495H27.5774C27.6907 19.3255 28.0471 19.6004 28.4696 19.6004C28.5376 19.6004 28.6037 19.593 28.6679 19.5795L29.2012 20.4795C28.9745 20.566 28.7277 20.6138 28.4696 20.6138C27.4622 20.6138 26.6279 19.8918 26.4818 18.9495ZM29.6615 20.2328L29.1288 19.3341C29.2963 19.1703 29.4002 18.944 29.4002 18.6943C29.4002 18.4446 29.2988 18.2244 29.1351 18.0612L29.7005 17.1066C30.1746 17.4649 30.48 18.025 30.48 18.655C30.48 19.285 30.1576 19.8758 29.6608 20.2328H29.6615Z",
    fill: "url(#paint0_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6674 19.2012L32.2858 19.1356C32.2934 19.07 32.2997 19.0043 32.3041 18.9374L32.6913 18.9387C32.8172 18.9387 32.9192 18.8399 32.9199 18.7172C32.9199 18.5945 32.8185 18.4951 32.6926 18.4945L32.306 18.4933C32.3016 18.4123 32.2934 18.332 32.2839 18.2528L32.6642 18.1853C32.7883 18.1633 32.8701 18.0479 32.8475 17.9271C32.8248 17.8062 32.7064 17.7265 32.5824 17.7486L32.2033 17.816C32.1876 17.7529 32.1706 17.6903 32.1511 17.6283L32.5125 17.4995C32.6309 17.4572 32.6913 17.3296 32.6479 17.2148C32.6044 17.1001 32.4735 17.0406 32.3557 17.083L31.9949 17.2118C31.9647 17.1443 31.9326 17.078 31.8986 17.013L32.2304 16.8241C32.3393 16.7621 32.3759 16.6265 32.3123 16.5204C32.2487 16.4143 32.1095 16.3787 32.0006 16.4407L31.6688 16.6296C31.6235 16.5634 31.5762 16.4996 31.5271 16.4364L31.818 16.1922C31.9131 16.1125 31.9244 15.972 31.8419 15.8793C31.7601 15.7867 31.6159 15.7757 31.5208 15.856L31.2299 16.1002C31.1808 16.0505 31.1305 16.0026 31.0788 15.9554L31.3219 15.6665C31.4018 15.5714 31.3873 15.4315 31.2898 15.3542C31.1922 15.2763 31.0486 15.2904 30.9693 15.3855L30.7262 15.6744C30.6702 15.6346 30.6129 15.5965 30.5544 15.5597L30.7426 15.2346C30.8043 15.1279 30.7659 14.9923 30.6564 14.9322C30.5468 14.872 30.4077 14.9095 30.3459 15.0162L30.1583 15.3401C30.084 15.3045 30.0085 15.2714 29.9317 15.2407L30.0557 14.8886C30.0966 14.7727 30.033 14.6463 29.914 14.6064C29.795 14.5665 29.6653 14.6285 29.6244 14.7444L29.5004 15.0966C29.428 15.0769 29.3549 15.0591 29.2806 15.0438L29.3385 14.6763C29.3574 14.5555 29.2724 14.442 29.1484 14.423C29.0244 14.4046 28.9079 14.4874 28.8884 14.6083L28.8304 14.9763C28.787 14.9726 28.7429 14.969 28.6988 14.9665V14.5941C28.6988 14.4715 28.5968 14.3721 28.4709 14.3721C28.345 14.3721 28.243 14.4715 28.243 14.5941V14.9665C28.1706 14.9708 28.0982 14.9769 28.0264 14.9849L27.9597 14.6181C27.9376 14.4972 27.8193 14.4169 27.6958 14.4383C27.5718 14.4598 27.4893 14.5751 27.5114 14.6954L27.5781 15.0622C27.5082 15.0782 27.439 15.0966 27.3703 15.1162L27.2394 14.7665C27.1966 14.6512 27.0656 14.5923 26.9472 14.634C26.8288 14.6757 26.7684 14.8033 26.8112 14.9187L26.9422 15.2683C26.8761 15.2959 26.8119 15.326 26.7476 15.3573L26.5562 15.0346C26.4933 14.9285 26.3541 14.8923 26.2452 14.9536C26.1363 15.015 26.0991 15.1506 26.1621 15.2567L26.3535 15.5794C26.2937 15.618 26.2345 15.6579 26.1772 15.699L25.931 15.4137C25.8504 15.3199 25.7062 15.3076 25.6099 15.3867C25.5136 15.4659 25.501 15.6057 25.5822 15.6996L25.829 15.9861C25.7767 16.0339 25.7264 16.0836 25.6773 16.1339L25.3826 15.8935C25.2863 15.8149 25.1427 15.8272 25.0615 15.9211C24.9809 16.0149 24.9935 16.1548 25.0898 16.2339L25.3839 16.4744C25.341 16.5302 25.3007 16.5879 25.2611 16.6462L24.928 16.4591C24.8191 16.3977 24.6799 16.4339 24.617 16.5407C24.554 16.6474 24.5912 16.7824 24.7007 16.8437L25.0338 17.0308C25.0017 17.0928 24.9715 17.156 24.9431 17.2204L24.5823 17.0922C24.464 17.0504 24.3336 17.1099 24.2902 17.2247C24.2474 17.34 24.3085 17.467 24.4262 17.5093L24.7882 17.6375C24.7681 17.7038 24.7498 17.7713 24.7335 17.8394L24.3538 17.7743C24.2297 17.7529 24.112 17.8338 24.09 17.9541C24.0679 18.0749 24.151 18.1896 24.2745 18.2111L24.6547 18.2768C24.6472 18.3424 24.6409 18.408 24.6371 18.4749L24.2505 18.4737C24.1246 18.4737 24.0226 18.5724 24.022 18.6951C24.022 18.8178 24.1233 18.9172 24.2493 18.9178L24.6365 18.919C24.6415 19 24.6491 19.0798 24.6592 19.1595L24.2776 19.2276C24.1536 19.2497 24.0717 19.365 24.0944 19.4859C24.117 19.6067 24.2354 19.6865 24.3595 19.6644L24.7404 19.5963C24.7561 19.6595 24.7737 19.7221 24.7926 19.7834L24.4287 19.9135C24.3103 19.9558 24.2499 20.0834 24.2933 20.1981C24.3368 20.3134 24.4677 20.3723 24.5855 20.33L24.95 20.2C24.9803 20.2668 25.0124 20.3331 25.0464 20.3981L24.7108 20.5895C24.6019 20.6515 24.5653 20.787 24.6289 20.8932C24.6925 20.9993 24.8317 21.0349 24.9406 20.9729L25.2762 20.7815C25.3215 20.8472 25.3687 20.911 25.4179 20.9735L25.1226 21.2214C25.0275 21.3011 25.0162 21.4416 25.0986 21.5342C25.1805 21.6269 25.3247 21.6379 25.4197 21.5575L25.7157 21.3091C25.7648 21.3582 25.8145 21.406 25.8662 21.4526L25.6187 21.7471C25.5387 21.8422 25.5532 21.9821 25.6508 22.0594C25.7484 22.1373 25.892 22.1232 25.9713 22.0281L26.2194 21.7336C26.2754 21.7729 26.3321 21.8109 26.39 21.8471L26.198 22.179C26.1363 22.2857 26.1747 22.4213 26.2842 22.4814C26.3938 22.5415 26.5329 22.5041 26.5946 22.3974L26.7867 22.0661C26.8603 22.1011 26.9359 22.1342 27.0121 22.1643L26.8855 22.5244C26.8446 22.6403 26.9082 22.7667 27.0272 22.8065C27.1462 22.8464 27.2759 22.7845 27.3168 22.6685L27.444 22.3078C27.5158 22.3274 27.5888 22.3452 27.6625 22.3606L27.6027 22.7372C27.5838 22.8581 27.6688 22.9716 27.7928 22.9906C27.9168 23.009 28.0333 22.9262 28.0528 22.8053L28.1127 22.428C28.1561 22.4317 28.1995 22.4354 28.243 22.4379V22.8194C28.243 22.9421 28.345 23.0415 28.4709 23.0415C28.5968 23.0415 28.6988 22.9421 28.6988 22.8194V22.4379C28.7712 22.4336 28.8424 22.4274 28.9135 22.4195L28.9815 22.7955C29.0036 22.9164 29.122 22.9967 29.2454 22.9752C29.3694 22.9538 29.4519 22.8384 29.4298 22.7182L29.3618 22.3428C29.4311 22.3268 29.5004 22.309 29.5684 22.2894L29.7025 22.647C29.7453 22.7624 29.8762 22.8213 29.9946 22.7796C30.113 22.7378 30.1734 22.6102 30.1306 22.4949L29.9971 22.1373C30.0626 22.1097 30.1268 22.0802 30.1904 22.0489L30.3862 22.3784C30.4492 22.4845 30.5884 22.5207 30.6973 22.4593C30.8062 22.398 30.8434 22.2624 30.7804 22.1563L30.5846 21.8268C30.6438 21.7888 30.7023 21.7489 30.7596 21.7078L31.0108 21.9992C31.0914 22.0931 31.2356 22.1054 31.3319 22.0262C31.4283 21.9477 31.4409 21.8072 31.3596 21.7134L31.1084 21.4214C31.1601 21.3735 31.2104 21.3244 31.2595 21.2741L31.5592 21.5189C31.6556 21.5974 31.7991 21.5851 31.8803 21.4913C31.9609 21.3974 31.9483 21.2576 31.852 21.1784L31.5536 20.9349C31.5964 20.8791 31.6367 20.822 31.6757 20.7643L32.0132 20.9539C32.1221 21.0152 32.2613 20.979 32.3242 20.8723C32.3872 20.7656 32.35 20.6306 32.2405 20.5693L31.9036 20.3797C31.9358 20.3177 31.966 20.2552 31.9943 20.1914L32.3589 20.3208C32.4772 20.3625 32.6076 20.3036 32.651 20.1883C32.6938 20.073 32.6328 19.946 32.515 19.9036L32.1505 19.7742C32.1706 19.708 32.1889 19.6405 32.2059 19.573L32.588 19.6386C32.7121 19.6601 32.8298 19.5791 32.8519 19.4583C32.8739 19.3374 32.7908 19.2227 32.6674 19.2012ZM28.4715 21.914C26.6507 21.914 25.1748 20.476 25.1748 18.7019C25.1748 16.9277 26.6507 15.4898 28.4715 15.4898C30.2924 15.4898 31.7683 16.9277 31.7683 18.7019C31.7683 20.476 30.2924 21.914 28.4715 21.914Z",
    fill: "url(#paint1_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5775 19.1525H23.4509C23.4409 19.1157 23.427 19.0814 23.4088 19.0488L23.4975 18.963C23.5504 18.9114 23.5511 18.828 23.4975 18.7765C23.4446 18.7249 23.359 18.7243 23.3061 18.7765L23.2186 18.8617C23.1846 18.8433 23.1487 18.828 23.1109 18.8176V18.6973C23.1109 18.6243 23.0505 18.5654 22.9756 18.5654C22.9006 18.5654 22.8402 18.6243 22.8402 18.6973V18.8176C22.8031 18.828 22.7678 18.8421 22.7344 18.8605L22.6469 18.7752C22.594 18.7237 22.5084 18.7231 22.4555 18.7752C22.4026 18.8268 22.402 18.9102 22.4555 18.9617L22.5436 19.0482C22.5254 19.0807 22.5109 19.1151 22.5008 19.1513H22.3743C22.2994 19.1513 22.2389 19.2096 22.2383 19.2826C22.2383 19.3556 22.2987 19.4145 22.3737 19.4151H22.5021C22.5128 19.4507 22.5273 19.4844 22.5455 19.5157L22.4542 19.6046C22.4014 19.6562 22.4007 19.7396 22.4542 19.7911C22.5071 19.8427 22.5928 19.8433 22.6457 19.7911L22.7382 19.7016C22.7703 19.7187 22.8049 19.7328 22.8415 19.7427V19.8703C22.8415 19.9433 22.9019 20.0022 22.9768 20.0022C23.0518 20.0022 23.1122 19.9433 23.1122 19.8703V19.7427C23.1475 19.7328 23.1815 19.7193 23.2129 19.7028L23.3049 19.793C23.3578 19.8445 23.4434 19.8451 23.4963 19.793C23.5492 19.7414 23.5498 19.658 23.4963 19.6065L23.405 19.5169C23.4232 19.4856 23.4383 19.4519 23.4491 19.4169H23.5775C23.6524 19.4169 23.7129 19.3586 23.7135 19.2856C23.7135 19.2126 23.6531 19.1537 23.5781 19.1531L23.5775 19.1525ZM22.9756 19.5525C22.8207 19.5525 22.6954 19.4304 22.6954 19.2789C22.6954 19.1274 22.8207 19.0053 22.9756 19.0053C23.1305 19.0053 23.2564 19.1274 23.2564 19.2789C23.2564 19.4304 23.1311 19.5525 22.9756 19.5525Z",
    fill: "url(#paint2_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1891 21.6066H15.0625C15.0524 21.5698 15.0386 21.5355 15.0203 21.5029L15.1091 21.4171C15.162 21.3655 15.1626 21.2821 15.1091 21.2306C15.0562 21.179 14.9706 21.1784 14.9177 21.2306L14.8302 21.3158C14.7962 21.2974 14.7603 21.2821 14.7225 21.2717V21.1514C14.7225 21.0784 14.6621 21.0195 14.5871 21.0195C14.5122 21.0195 14.4518 21.0784 14.4518 21.1514V21.2717C14.4146 21.2821 14.3794 21.2962 14.346 21.3146L14.2585 21.2293C14.2056 21.1778 14.12 21.1772 14.0671 21.2293C14.0142 21.2809 14.0136 21.3643 14.0671 21.4158L14.1552 21.5023C14.137 21.5348 14.1225 21.5692 14.1124 21.6054H13.9859C13.9109 21.6054 13.8505 21.6637 13.8499 21.7367C13.8499 21.8097 13.9103 21.8686 13.9852 21.8692H14.1137C14.1244 21.9048 14.1389 21.9385 14.1571 21.9698L14.0658 22.0587C14.0129 22.1103 14.0123 22.1937 14.0658 22.2452C14.1193 22.2968 14.2043 22.2974 14.2572 22.2452L14.3498 22.1557C14.3819 22.1728 14.4165 22.1869 14.453 22.1968V22.3244C14.453 22.3974 14.5135 22.4563 14.5884 22.4563C14.6633 22.4563 14.7238 22.3974 14.7238 22.3244V22.1968C14.759 22.1869 14.793 22.1735 14.8245 22.1569L14.9164 22.2471C14.9693 22.2986 15.055 22.2992 15.1078 22.2471C15.1607 22.1955 15.1614 22.1121 15.1078 22.0606L15.0166 21.971C15.0348 21.9397 15.0499 21.906 15.0606 21.871H15.1891C15.264 21.871 15.3244 21.8127 15.3251 21.7397C15.3251 21.6667 15.2646 21.6078 15.1897 21.6072L15.1891 21.6066ZM14.5865 22.0066C14.4316 22.0066 14.3063 21.8845 14.3063 21.733C14.3063 21.5815 14.4316 21.4594 14.5865 21.4594C14.7414 21.4594 14.8673 21.5815 14.8673 21.733C14.8673 21.8845 14.742 22.0066 14.5865 22.0066Z",
    fill: "url(#paint3_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5301 21.2052H11.4036C11.3935 21.1684 11.3797 21.1341 11.3614 21.1016L11.4502 21.0157C11.5031 20.9642 11.5037 20.8807 11.4502 20.8292C11.3973 20.7777 11.3117 20.7771 11.2588 20.8292L11.1712 20.9145C11.1372 20.8961 11.1014 20.8807 11.0636 20.8703V20.7501C11.0636 20.6771 11.0031 20.6182 10.9282 20.6182C10.8533 20.6182 10.7928 20.6771 10.7928 20.7501V20.8703C10.7557 20.8807 10.7204 20.8948 10.6871 20.9132L10.5995 20.828C10.5467 20.7764 10.461 20.7758 10.4081 20.828C10.3553 20.8795 10.3546 20.9629 10.4081 21.0145L10.4963 21.101C10.478 21.1335 10.4635 21.1678 10.4535 21.204H10.3269C10.252 21.204 10.1915 21.2623 10.1909 21.3353C10.1909 21.4083 10.2514 21.4672 10.3263 21.4678H10.4547C10.4654 21.5034 10.4799 21.5371 10.4982 21.5684L10.4069 21.6574C10.354 21.7089 10.3534 21.7923 10.4069 21.8439C10.4598 21.8954 10.5454 21.896 10.5983 21.8439L10.6908 21.7543C10.723 21.7715 10.7576 21.7856 10.7941 21.7954V21.923C10.7941 21.996 10.8545 22.0549 10.9295 22.0549C11.0044 22.0549 11.0648 21.996 11.0648 21.923V21.7954C11.1001 21.7856 11.1341 21.7721 11.1656 21.7555L11.2575 21.8457C11.3104 21.8972 11.396 21.8978 11.4489 21.8457C11.5018 21.7942 11.5024 21.7107 11.4489 21.6592L11.3576 21.5696C11.3759 21.5384 11.391 21.5046 11.4017 21.4696H11.5301C11.6051 21.4696 11.6655 21.4114 11.6661 21.3384C11.6668 21.2654 11.6057 21.2065 11.5308 21.2059L11.5301 21.2052ZM10.9282 21.6052C10.7733 21.6052 10.648 21.4831 10.648 21.3316C10.648 21.1801 10.7733 21.058 10.9282 21.058C11.0831 21.058 11.209 21.1801 11.209 21.3316C11.209 21.4831 11.0837 21.6052 10.9282 21.6052Z",
    fill: "url(#paint4_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9466 13.4367H27.8201C27.81 13.3999 27.7962 13.3655 27.7779 13.333L27.8667 13.2471C27.9196 13.1956 27.9202 13.1122 27.8667 13.0606C27.8138 13.0091 27.7282 13.0085 27.6753 13.0606L27.5878 13.1459C27.5538 13.1275 27.5179 13.1122 27.4801 13.1017V12.9815C27.4801 12.9085 27.4196 12.8496 27.3447 12.8496C27.2698 12.8496 27.2093 12.9085 27.2093 12.9815V13.1017C27.1722 13.1122 27.1369 13.1263 27.1036 13.1447L27.016 13.0594C26.9632 13.0079 26.8775 13.0073 26.8246 13.0594C26.7718 13.1109 26.7711 13.1944 26.8246 13.2459L26.9128 13.3324C26.8945 13.3649 26.8801 13.3993 26.87 13.4355H26.7434C26.6685 13.4355 26.6081 13.4937 26.6074 13.5667C26.6074 13.6397 26.6679 13.6986 26.7428 13.6993H26.8712C26.8819 13.7348 26.8964 13.7686 26.9147 13.7999L26.8234 13.8888C26.7705 13.9403 26.7699 14.0238 26.8234 14.0753C26.8763 14.1268 26.9619 14.1274 27.0148 14.0753L27.1073 13.9857C27.1395 14.0029 27.1741 14.017 27.2106 14.0268V14.1544C27.2106 14.2274 27.271 14.2863 27.346 14.2863C27.4209 14.2863 27.4813 14.2274 27.4813 14.1544V14.0268C27.5166 14.017 27.5506 14.0035 27.5821 13.987L27.674 14.0771C27.7269 14.1287 27.8125 14.1293 27.8654 14.0771C27.9183 14.0256 27.9189 13.9422 27.8654 13.8907L27.7741 13.8011C27.7924 13.7698 27.8075 13.7361 27.8182 13.7011H27.9466C28.0216 13.7011 28.082 13.6428 28.0826 13.5698C28.0826 13.4968 28.0222 13.4379 27.9473 13.4373L27.9466 13.4367ZM27.3441 13.8367C27.1892 13.8367 27.0639 13.7146 27.0639 13.5631C27.0639 13.4115 27.1892 13.2895 27.3441 13.2895C27.499 13.2895 27.6249 13.4115 27.6249 13.5631C27.6249 13.7146 27.4996 13.8367 27.3441 13.8367Z",
    fill: "url(#paint5_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5775 14.0842H23.4509C23.4409 14.0473 23.427 14.013 23.4088 13.9805L23.4975 13.8946C23.5504 13.8431 23.5511 13.7596 23.4975 13.7081C23.4446 13.6566 23.359 13.656 23.3061 13.7081L23.2186 13.7934C23.1846 13.775 23.1487 13.7596 23.1109 13.7492V13.629C23.1109 13.556 23.0505 13.4971 22.9756 13.4971C22.9006 13.4971 22.8402 13.556 22.8402 13.629V13.7492C22.8031 13.7596 22.7678 13.7737 22.7344 13.7921L22.6469 13.7069C22.594 13.6553 22.5084 13.6547 22.4555 13.7069C22.4026 13.7584 22.402 13.8418 22.4555 13.8934L22.5436 13.9799C22.5254 14.0124 22.5109 14.0467 22.5008 14.0829H22.3743C22.2994 14.0829 22.2389 14.1412 22.2383 14.2142C22.2383 14.2872 22.2987 14.3461 22.3737 14.3467H22.5021C22.5128 14.3823 22.5273 14.416 22.5455 14.4473L22.4542 14.5363C22.4014 14.5878 22.4007 14.6712 22.4542 14.7228C22.5071 14.7743 22.5928 14.7749 22.6457 14.7228L22.7382 14.6332C22.7703 14.6504 22.8049 14.6645 22.8415 14.6743V14.8019C22.8415 14.8749 22.9019 14.9338 22.9768 14.9338C23.0518 14.9338 23.1122 14.8749 23.1122 14.8019V14.6743C23.1475 14.6645 23.1815 14.651 23.2129 14.6344L23.3049 14.7246C23.3578 14.7761 23.4434 14.7768 23.4963 14.7246C23.5492 14.6731 23.5498 14.5896 23.4963 14.5381L23.405 14.4485C23.4232 14.4173 23.4383 14.3835 23.4491 14.3486H23.5775C23.6524 14.3486 23.7129 14.2903 23.7135 14.2173C23.7135 14.1443 23.6531 14.0854 23.5781 14.0848L23.5775 14.0842ZM22.9756 14.4847C22.8207 14.4847 22.6954 14.3627 22.6954 14.2111C22.6954 14.0596 22.8207 13.9375 22.9756 13.9375C23.1305 13.9375 23.2564 14.0596 23.2564 14.2111C23.2564 14.3627 23.1311 14.4847 22.9756 14.4847Z",
    fill: "url(#paint6_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3138 45.0552H18.1331C18.1205 45.0111 18.1041 44.9693 18.0821 44.9301L18.2093 44.8074C18.2621 44.7559 18.2628 44.6724 18.2093 44.6209L18.1696 44.5822C18.1167 44.5307 18.0311 44.5301 17.9782 44.5822L17.8523 44.7043C17.8113 44.6816 17.7679 44.6638 17.7219 44.651V44.4786C17.7219 44.4056 17.6615 44.3467 17.5866 44.3467H17.5305C17.4556 44.3467 17.3951 44.4056 17.3951 44.4786V44.651C17.3504 44.6632 17.3076 44.6804 17.2673 44.7025L17.142 44.5798C17.0892 44.5283 17.0035 44.5277 16.9506 44.5798L16.911 44.6184C16.8581 44.67 16.8574 44.7534 16.911 44.8049L17.0375 44.9289C17.0155 44.9675 16.9985 45.0092 16.9859 45.0534H16.8052C16.7303 45.0528 16.6698 45.1117 16.6692 45.1847V45.2393C16.6692 45.3123 16.7296 45.3712 16.8039 45.3718H16.9872C16.9997 45.4147 17.0174 45.4552 17.0394 45.4932L16.9091 45.6196C16.8562 45.6711 16.8556 45.7546 16.9091 45.8061L16.9487 45.8448C17.0016 45.8963 17.0873 45.8969 17.1402 45.8448L17.2717 45.7172C17.3108 45.738 17.3523 45.7546 17.3964 45.7668V45.9484C17.3964 46.0214 17.4569 46.0803 17.5318 46.0803H17.5878C17.6627 46.0803 17.7232 46.0214 17.7232 45.9484V45.7668C17.766 45.7552 17.8069 45.7392 17.8453 45.719L17.9763 45.8472C18.0292 45.8987 18.1148 45.8993 18.1677 45.8472L18.2074 45.8086C18.2603 45.757 18.2609 45.6736 18.2074 45.6221L18.0777 45.4951C18.0997 45.457 18.118 45.4166 18.1306 45.3742H18.3131C18.3881 45.3748 18.4485 45.3159 18.4491 45.2429V45.1883C18.4491 45.1153 18.3887 45.0565 18.3144 45.0558L18.3138 45.0552ZM17.5589 45.5374C17.3719 45.5374 17.2201 45.3896 17.2201 45.2074C17.2201 45.0252 17.3719 44.8773 17.5589 44.8773C17.7459 44.8773 17.8976 45.0252 17.8976 45.2074C17.8976 45.3896 17.7459 45.5374 17.5589 45.5374Z",
    fill: "url(#paint7_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2667 46.4435H10.1402C10.1301 46.4067 10.1162 46.3724 10.098 46.3399L10.1867 46.254C10.2396 46.2024 10.2403 46.119 10.1867 46.0675C10.1339 46.0159 10.0482 46.0153 9.99534 46.0675L9.90782 46.1527C9.87382 46.1343 9.83793 46.119 9.80015 46.1086V45.9883C9.80015 45.9153 9.73971 45.8564 9.66478 45.8564C9.58986 45.8564 9.52941 45.9153 9.52941 45.9883V46.1086C9.49227 46.119 9.45701 46.1331 9.42364 46.1515L9.33612 46.0662C9.28323 46.0147 9.1976 46.0141 9.14471 46.0662C9.09182 46.1178 9.09119 46.2012 9.14471 46.2527L9.23286 46.3392C9.2146 46.3718 9.20012 46.4061 9.19005 46.4423H9.06349C8.98856 46.4423 8.92812 46.5006 8.92749 46.5736C8.92749 46.6466 8.98794 46.7055 9.06286 46.7061H9.1913C9.20201 46.7417 9.21649 46.7754 9.23475 46.8067L9.14345 46.8956C9.09056 46.9472 9.08993 47.0306 9.14345 47.0821C9.19634 47.1337 9.28197 47.1343 9.33486 47.0821L9.42741 46.9926C9.45953 47.0098 9.49415 47.0239 9.53067 47.0337V47.1613C9.53067 47.2343 9.59112 47.2932 9.66604 47.2932C9.74097 47.2932 9.80141 47.2343 9.80141 47.1613V47.0337C9.83667 47.0239 9.87067 47.0104 9.90215 46.9938L9.99408 47.084C10.047 47.1355 10.1326 47.1361 10.1855 47.084C10.2384 47.0325 10.239 46.949 10.1855 46.8975L10.0942 46.8079C10.1124 46.7766 10.1276 46.7429 10.1383 46.7079H10.2667C10.3416 46.7079 10.4021 46.6497 10.4027 46.5766C10.4027 46.5036 10.3423 46.4448 10.2673 46.4441L10.2667 46.4435ZM9.66478 46.8435C9.5099 46.8435 9.3846 46.7214 9.3846 46.5699C9.3846 46.4184 9.5099 46.2963 9.66478 46.2963C9.81967 46.2963 9.9456 46.4184 9.9456 46.5699C9.9456 46.7214 9.8203 46.8435 9.66478 46.8435Z",
    fill: "url(#paint8_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.30406 43.3722H4.17751C4.16743 43.3354 4.15358 43.3011 4.13532 43.2686L4.2241 43.1827C4.27699 43.1311 4.27762 43.0477 4.2241 42.9962C4.17121 42.9447 4.08558 42.944 4.03269 42.9962L3.94517 43.0815C3.91117 43.0631 3.87528 43.0477 3.83751 43.0373V42.9171C3.83751 42.8441 3.77706 42.7852 3.70214 42.7852C3.62721 42.7852 3.56677 42.8441 3.56677 42.9171V43.0373C3.52962 43.0477 3.49436 43.0618 3.46099 43.0802L3.37347 42.995C3.32058 42.9434 3.23495 42.9428 3.18207 42.995C3.12918 43.0465 3.12855 43.1299 3.18207 43.1815L3.27021 43.268C3.25195 43.3005 3.23747 43.3348 3.2274 43.371H3.10084C3.02592 43.371 2.96547 43.4293 2.96484 43.5023C2.96484 43.5753 3.02529 43.6342 3.10021 43.6348H3.22866C3.23936 43.6704 3.25384 43.7041 3.2721 43.7354L3.18081 43.8244C3.12792 43.8759 3.12729 43.9593 3.18081 44.0109C3.23369 44.0624 3.31932 44.063 3.37221 44.0109L3.46477 43.9213C3.49688 43.9385 3.53151 43.9526 3.56803 43.9624V44.09C3.56803 44.163 3.62847 44.2219 3.7034 44.2219C3.77832 44.2219 3.83877 44.163 3.83877 44.09V43.9624C3.87403 43.9526 3.90803 43.9391 3.93951 43.9225L4.03143 44.0127C4.08432 44.0642 4.16995 44.0648 4.22284 44.0127C4.27573 43.9612 4.27636 43.8777 4.22284 43.8262L4.13154 43.7366C4.1498 43.7053 4.16491 43.6716 4.17562 43.6366H4.30406C4.37899 43.6366 4.43943 43.5784 4.44006 43.5054C4.44006 43.4324 4.37962 43.3735 4.30469 43.3729L4.30406 43.3722ZM3.70214 43.7722C3.54725 43.7722 3.42195 43.6501 3.42195 43.4986C3.42195 43.3471 3.54725 43.225 3.70214 43.225C3.85703 43.225 3.98295 43.3471 3.98295 43.4986C3.98295 43.6501 3.85765 43.7722 3.70214 43.7722Z",
    fill: "url(#paint9_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.25024 46.7265C6.35287 46.7253 6.43472 46.6431 6.43346 46.5437C6.4322 46.4437 6.34783 46.364 6.24583 46.3652L5.92913 46.3695C5.92346 46.3247 5.91654 46.2799 5.90646 46.2364L6.20743 46.1308C6.30376 46.0971 6.3535 45.9934 6.31887 45.8996C6.28424 45.8057 6.17783 45.7573 6.0815 45.791L5.78369 45.8959C5.75409 45.8382 5.72261 45.7818 5.68609 45.7284L5.92661 45.5235C6.00343 45.4579 6.01161 45.3438 5.94424 45.2683C5.87687 45.1935 5.75976 45.1855 5.68232 45.2511L5.44243 45.4554C5.40591 45.4229 5.3675 45.3922 5.32721 45.3634L5.48524 45.0892C5.53561 45.0021 5.5035 44.8923 5.4141 44.8432C5.32469 44.7941 5.21199 44.8254 5.16162 44.9125L5.00484 45.1843C4.95573 45.164 4.90473 45.1475 4.8531 45.1321L4.90599 44.8193C4.92236 44.7205 4.85436 44.6279 4.75299 44.6119C4.65225 44.596 4.55654 44.6622 4.54017 44.761L4.48728 45.0739C4.46525 45.0726 4.44384 45.0708 4.42117 45.0708C4.3941 45.0708 4.36766 45.0732 4.34058 45.0745L4.28203 44.7573C4.26377 44.6592 4.16743 44.5935 4.06669 44.6113C3.96595 44.6291 3.89858 44.723 3.91684 44.8211L3.97477 45.1358C3.91369 45.1542 3.85451 45.1769 3.79658 45.2021L3.62218 44.9236C3.56866 44.8383 3.4547 44.8113 3.36718 44.8634C3.27966 44.9156 3.25196 45.0266 3.30547 45.1119L3.47925 45.3898C3.4377 45.4223 3.3974 45.456 3.35899 45.4922L3.09392 45.2867C3.01396 45.2248 2.89685 45.2377 2.83325 45.3156C2.76966 45.3935 2.78288 45.5076 2.86285 45.5695L3.12792 45.775C3.10148 45.8168 3.07692 45.8603 3.05425 45.9051L2.72874 45.7984C2.63177 45.7665 2.52663 45.8174 2.49389 45.9118C2.46114 46.0063 2.5134 46.1088 2.61037 46.1407L2.93274 46.2462C2.92329 46.2897 2.91637 46.3339 2.91133 46.3781L2.56629 46.3824C2.46366 46.3836 2.38181 46.4658 2.38307 46.5652C2.38433 46.6652 2.4687 46.7449 2.5707 46.7437L2.91322 46.7394C2.91888 46.7817 2.92518 46.8234 2.93462 46.8639L2.60911 46.978C2.51277 47.0118 2.46303 47.1155 2.49766 47.2093C2.53229 47.3032 2.6387 47.3516 2.73503 47.3179L3.0574 47.2044C3.08511 47.2596 3.11596 47.313 3.14996 47.3639L2.88992 47.5854C2.81311 47.651 2.80492 47.7651 2.87229 47.8406C2.93966 47.9154 3.05677 47.9234 3.13422 47.8577L3.39173 47.6387C3.42636 47.67 3.46225 47.6995 3.50003 47.7271L3.33129 48.0203C3.28092 48.1074 3.31303 48.2172 3.40244 48.2663C3.49184 48.3154 3.60455 48.2841 3.65492 48.197L3.81988 47.9105C3.8671 47.9301 3.91558 47.9479 3.96532 47.9633L3.90992 48.2902C3.89355 48.389 3.96155 48.4816 4.06292 48.4976C4.16429 48.5135 4.25936 48.4473 4.27573 48.3485L4.32988 48.0264C4.35947 48.0283 4.38906 48.0307 4.41928 48.0307C4.43754 48.0307 4.45517 48.0289 4.47343 48.0283L4.53325 48.3522C4.55151 48.4503 4.64784 48.516 4.74858 48.4982C4.84932 48.4804 4.91669 48.3865 4.89843 48.2884L4.8405 47.9718C4.90221 47.9547 4.96265 47.9344 5.02058 47.9099L5.1931 48.1853C5.24661 48.2706 5.36058 48.2976 5.4481 48.2455C5.53561 48.1933 5.56332 48.0823 5.5098 47.997L5.34043 47.7258C5.38387 47.6939 5.42543 47.6596 5.46447 47.6234L5.72135 47.8222C5.80132 47.8841 5.91843 47.8712 5.98202 47.7933C6.04561 47.7154 6.03239 47.6013 5.95243 47.5394L5.70121 47.3443C5.72954 47.3007 5.75535 47.2559 5.77928 47.2099L6.08654 47.3105C6.1835 47.3424 6.28865 47.2915 6.32139 47.197C6.35413 47.1026 6.30187 47.0001 6.20491 46.9682L5.90394 46.8695C5.91402 46.8241 5.9222 46.7774 5.92787 46.7302L6.24961 46.7259L6.25024 46.7265ZM4.05284 46.5498C4.05284 46.3517 4.2178 46.191 4.42117 46.191C4.62454 46.191 4.78951 46.3517 4.78951 46.5498C4.78951 46.748 4.62454 46.9087 4.42117 46.9087C4.2178 46.9087 4.05284 46.748 4.05284 46.5498Z",
    fill: "url(#paint10_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.46983 27.6475C5.80369 27.5125 5.15139 27.929 5.01287 28.5781C4.87436 29.2271 5.30187 29.8627 5.96802 29.9976C6.63416 30.1326 7.28646 29.7161 7.42497 29.067C7.56349 28.418 7.13598 27.7824 6.46983 27.6475ZM6.40813 27.8389C6.74057 27.9063 7.00061 28.1235 7.13157 28.4026L6.6159 28.5683C6.54916 28.4695 6.44402 28.3953 6.31557 28.3695C6.18902 28.3437 6.06372 28.3695 5.96298 28.4327L5.53232 28.0585C5.76528 27.8646 6.0845 27.7738 6.4075 27.8395L6.40813 27.8389ZM6.17076 29.0468C6.04357 29.021 5.96172 28.8995 5.98817 28.7756C6.01461 28.6517 6.13928 28.5719 6.26646 28.5977C6.39365 28.6235 6.4755 28.7449 6.44905 28.8689C6.42261 28.9928 6.29794 29.0725 6.17076 29.0468ZM5.19295 28.6149C5.22191 28.4805 5.27669 28.3578 5.35224 28.2517L5.78731 28.6296C5.77283 28.6609 5.76087 28.6934 5.75394 28.7284C5.70987 28.9345 5.81376 29.1363 5.99509 29.2308L5.87987 29.7694C5.38876 29.6136 5.08591 29.1192 5.19358 28.6149H5.19295ZM7.2046 29.0222C7.10009 29.513 6.64235 29.843 6.14368 29.8167L6.25765 29.2842C6.46227 29.2682 6.64046 29.1228 6.68453 28.9173C6.69146 28.8842 6.69461 28.8511 6.69461 28.8186L7.21153 28.6523C7.23231 28.7719 7.23168 28.8971 7.20523 29.0228L7.2046 29.0222Z",
    fill: "url(#paint11_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.20718 32.3082C7.60211 32.1856 7.009 32.5641 6.88307 33.1542C6.75715 33.7437 7.14563 34.3216 7.75133 34.4443C8.3564 34.567 8.94951 34.1885 9.07543 33.5984C9.20136 33.0088 8.81288 32.4309 8.20718 32.3082ZM8.15114 32.4819C8.45273 32.5432 8.68947 32.7401 8.80847 32.9941L8.34003 33.1444C8.27958 33.0548 8.18388 32.9873 8.0674 32.9634C7.95218 32.9401 7.83884 32.9634 7.74692 33.0211L7.35592 32.6806C7.5681 32.5046 7.85773 32.4217 8.15114 32.4812V32.4819ZM7.93581 33.5799C7.81996 33.5566 7.74629 33.4462 7.77022 33.334C7.79414 33.2217 7.90747 33.1493 8.0227 33.1726C8.13855 33.1959 8.21221 33.3063 8.18829 33.4186C8.16436 33.5315 8.05103 33.6033 7.93581 33.5799ZM7.0474 33.1867C7.07322 33.0646 7.12359 32.9536 7.19222 32.8567L7.58762 33.2002C7.5744 33.2284 7.5637 33.2585 7.5574 33.2898C7.51773 33.4769 7.61218 33.6609 7.77651 33.7462L7.67199 34.2357C7.22559 34.094 6.95044 33.645 7.04803 33.1867H7.0474ZM8.87521 33.5573C8.78014 34.0032 8.36458 34.3032 7.91125 34.2793L8.01451 33.7953C8.20088 33.7805 8.36269 33.6487 8.40236 33.4616C8.40866 33.4315 8.4118 33.4014 8.41118 33.372L8.88088 33.2211C8.89977 33.3297 8.89914 33.4431 8.87521 33.5579V33.5573Z",
    fill: "url(#paint12_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.64799 18.155C7.06621 18.0372 6.4964 18.401 6.37551 18.9678C6.25462 19.5346 6.62799 20.0898 7.20977 20.2076C7.79154 20.3254 8.36136 19.9616 8.48224 19.3948C8.60313 18.8279 8.22976 18.2727 7.64799 18.155ZM7.59447 18.3224C7.88473 18.3813 8.11202 18.5709 8.22662 18.8144L7.7758 18.9592C7.71725 18.8727 7.62532 18.8083 7.51325 18.7856C7.40243 18.7629 7.29351 18.7856 7.20536 18.8408L6.82947 18.5138C7.03347 18.3445 7.31177 18.2648 7.59384 18.3224H7.59447ZM7.38732 19.3776C7.27651 19.3549 7.20473 19.2494 7.22803 19.1408C7.25132 19.0328 7.35962 18.9629 7.47106 18.9856C7.58188 19.0083 7.65365 19.1138 7.63036 19.2224C7.60706 19.3303 7.49877 19.4003 7.38732 19.3776ZM6.53292 19.0003C6.5581 18.8831 6.60596 18.7758 6.67207 18.6831L7.05173 19.0132C7.03914 19.0402 7.02906 19.069 7.02214 19.0991C6.98373 19.2788 7.0744 19.4555 7.23306 19.5383L7.13232 20.0088C6.70292 19.8726 6.43847 19.4408 6.53292 19.0003ZM8.29021 19.3561C8.19891 19.7849 7.7991 20.0733 7.3634 20.0499L7.46288 19.5849C7.64169 19.5708 7.79721 19.4445 7.83562 19.2641C7.84191 19.2353 7.84443 19.2064 7.84443 19.1776L8.29587 19.0328C8.31413 19.1371 8.3135 19.2463 8.29021 19.3561Z",
    fill: "url(#paint13_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.88904 39.1332C4.39415 39.0326 3.90934 39.3424 3.80608 39.8252C3.70282 40.3074 4.02078 40.7797 4.5163 40.8804C5.01119 40.981 5.496 40.6712 5.59926 40.1884C5.70252 39.7062 5.38456 39.2338 4.88904 39.1332ZM4.84308 39.2755C5.08989 39.3258 5.28319 39.4872 5.38078 39.6945L4.99733 39.8178C4.94759 39.7442 4.86952 39.6896 4.77445 39.67C4.68063 39.651 4.58745 39.67 4.51252 39.7172L4.19267 39.4387C4.36582 39.2946 4.60319 39.2271 4.84308 39.2755ZM4.66678 40.1736C4.57234 40.1546 4.51189 40.0645 4.53141 39.9724C4.55093 39.8804 4.64348 39.8215 4.73793 39.8405C4.83237 39.8596 4.89282 39.9497 4.8733 40.0418C4.85378 40.1338 4.76122 40.1927 4.66678 40.1736ZM3.94019 39.8522C3.9616 39.7522 4.00252 39.6614 4.05856 39.5823L4.38219 39.8639C4.37149 39.8872 4.36267 39.9111 4.357 39.9369C4.32426 40.0896 4.40234 40.2387 4.53645 40.3092L4.45082 40.711C4.08563 40.5951 3.86086 40.2276 3.94082 39.8528L3.94019 39.8522ZM5.43493 40.1552C5.35685 40.5203 5.01685 40.7656 4.64663 40.7454L4.73163 40.3479C4.88337 40.3356 5.01622 40.2295 5.04833 40.0767C5.05337 40.0522 5.05589 40.0276 5.05526 40.0031L5.43933 39.8798C5.45444 39.9688 5.45444 40.0614 5.4343 40.1552H5.43493Z",
    fill: "url(#paint14_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.04845 48.1647C6.79156 47.9377 6.39427 47.9561 6.16131 48.2064C5.92834 48.4567 5.94723 48.8438 6.20412 49.0708C6.46101 49.2978 6.8583 49.2793 7.09126 49.0291C7.32423 48.7788 7.30534 48.3917 7.04845 48.1647ZM6.23119 48.2825C6.34768 48.1579 6.51264 48.1027 6.67256 48.1187L6.61401 48.3825C6.5523 48.3855 6.49186 48.4113 6.44653 48.4598C6.40245 48.5076 6.38167 48.5677 6.38419 48.6272L6.10401 48.715C6.07694 48.5647 6.11849 48.4052 6.23119 48.2837V48.2825ZM6.71475 48.6966C6.67004 48.7444 6.59449 48.7481 6.54538 48.7045C6.49627 48.661 6.49249 48.5874 6.53719 48.5395C6.5819 48.4917 6.65745 48.488 6.70656 48.5315C6.75567 48.5751 6.75945 48.6487 6.71475 48.6966ZM6.26708 49.0033C6.21419 48.9561 6.17327 48.9008 6.14431 48.8413L6.42764 48.753C6.43771 48.7671 6.44967 48.7806 6.4629 48.7929C6.54412 48.8646 6.66186 48.872 6.75127 48.8186L6.96534 49.0076C6.76764 49.1775 6.46667 49.1794 6.26708 49.0027V49.0033ZM7.05538 48.907L6.84382 48.7199C6.88915 48.6279 6.87089 48.515 6.78967 48.4426C6.77645 48.4309 6.7626 48.4211 6.74749 48.4131L6.80604 48.1487C6.86523 48.1708 6.92127 48.2033 6.97164 48.2475C7.16619 48.4193 7.19641 48.7009 7.05538 48.907Z",
    fill: "url(#paint15_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.30741 29.891C7.0417 29.837 6.78167 30.0033 6.72626 30.2622C6.67085 30.5211 6.84148 30.7744 7.10719 30.8284C7.37289 30.8824 7.63292 30.7161 7.68833 30.4573C7.74374 30.1984 7.57311 29.945 7.30741 29.891ZM7.28285 29.9671C7.41507 29.9941 7.51896 30.0806 7.57122 30.1916L7.36533 30.2579C7.33889 30.2186 7.2967 30.1892 7.2457 30.1787C7.19533 30.1683 7.14559 30.1787 7.1053 30.2039L6.93341 30.0548C7.02659 29.9775 7.15378 29.9413 7.28222 29.9671H7.28285ZM7.18841 30.4493C7.13741 30.4389 7.1053 30.3904 7.116 30.3413C7.1267 30.2916 7.17644 30.2603 7.22681 30.2708C7.27781 30.2812 7.30993 30.3297 7.29922 30.3787C7.28852 30.4278 7.23878 30.4597 7.18841 30.4493ZM6.79867 30.2769C6.81 30.2235 6.83204 30.1745 6.86226 30.1321L7.03604 30.283C7.03037 30.2953 7.02533 30.3082 7.02219 30.3223C7.00456 30.4045 7.04674 30.4843 7.11852 30.5217L7.07256 30.737C6.87674 30.675 6.75585 30.4775 6.79867 30.2769ZM7.60018 30.4395C7.55863 30.6352 7.37604 30.7671 7.17707 30.756L7.22241 30.5431C7.30363 30.5364 7.37478 30.4793 7.39241 30.3978C7.39493 30.3843 7.39618 30.3714 7.39618 30.3585L7.60207 30.2922C7.61026 30.3401 7.61026 30.3898 7.59955 30.4401L7.60018 30.4395Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.15775 19.0043C8.89205 18.9503 8.63201 19.1166 8.5766 19.3755C8.5212 19.6343 8.69183 19.8877 8.95753 19.9417C9.22323 19.9957 9.48327 19.8294 9.53867 19.5705C9.59408 19.3117 9.42345 19.0583 9.15775 19.0043ZM9.13319 19.0804C9.26542 19.1074 9.3693 19.1939 9.42156 19.3049L9.21567 19.3712C9.18923 19.3319 9.14705 19.3025 9.09605 19.292C9.04568 19.2816 8.99594 19.292 8.95564 19.3172L8.78375 19.1681C8.87694 19.0908 9.00412 19.0546 9.13256 19.0804H9.13319ZM9.03875 19.5619C8.98775 19.5515 8.95564 19.5031 8.96634 19.454C8.97705 19.4043 9.02679 19.373 9.07716 19.3834C9.12816 19.3939 9.16027 19.4423 9.14956 19.4914C9.13886 19.5411 9.08912 19.5724 9.03875 19.5619ZM8.64901 19.3896C8.66034 19.3362 8.68238 19.2871 8.7126 19.2448L8.88638 19.3957C8.88071 19.408 8.87568 19.4209 8.87253 19.435C8.8549 19.5172 8.89708 19.5969 8.96886 19.6343L8.9229 19.8497C8.72708 19.7877 8.6062 19.5902 8.64901 19.3896ZM9.45053 19.5521C9.40897 19.7478 9.22638 19.8797 9.02742 19.8687L9.07275 19.6558C9.1546 19.6491 9.22512 19.592 9.24275 19.5104C9.2459 19.4969 9.24653 19.484 9.24653 19.4712L9.45242 19.4049C9.4606 19.4528 9.4606 19.5024 9.4499 19.5527L9.45053 19.5521Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.12308 19.6694C5.85738 19.6154 5.59734 19.7816 5.54194 20.0405C5.48653 20.2994 5.65716 20.5527 5.92286 20.6067C6.18856 20.6607 6.4486 20.4945 6.50401 20.2356C6.55941 19.9767 6.38878 19.7233 6.12308 19.6694ZM6.09853 19.746C6.23075 19.773 6.33464 19.8595 6.38689 19.9706L6.18101 20.0368C6.15456 19.9976 6.11238 19.9681 6.06138 19.9577C6.01101 19.9473 5.96127 19.9577 5.92097 19.9828L5.74908 19.8338C5.84227 19.7565 5.96945 19.7203 6.0979 19.746H6.09853ZM6.00408 20.2276C5.95308 20.2172 5.92097 20.1687 5.93167 20.1196C5.94238 20.0699 5.99212 20.0387 6.04249 20.0491C6.09286 20.0595 6.1256 20.108 6.1149 20.1571C6.10419 20.2067 6.05445 20.238 6.00408 20.2276ZM5.61434 20.0552C5.62568 20.0018 5.64771 19.9528 5.67793 19.9104L5.85171 20.0614C5.84605 20.0736 5.84101 20.0865 5.83786 20.1006C5.82023 20.1828 5.86242 20.2626 5.93419 20.3L5.88823 20.5153C5.69242 20.4534 5.57153 20.2558 5.61434 20.0552ZM6.41586 20.2178C6.3743 20.4135 6.19171 20.5454 5.99275 20.5343L6.03808 20.3215C6.11993 20.3147 6.19045 20.2577 6.20808 20.1761C6.2106 20.1626 6.21186 20.1497 6.21186 20.1368L6.41775 20.0706C6.42593 20.1184 6.42593 20.1681 6.41523 20.2184L6.41586 20.2178Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.369 20.7416C12.1379 20.6588 11.881 20.7747 11.796 20.9999C11.711 21.2256 11.83 21.4753 12.0611 21.5581C12.2928 21.6409 12.549 21.525 12.634 21.2998C12.719 21.0741 12.6 20.8244 12.369 20.7416ZM12.3362 20.8066C12.4515 20.8477 12.532 20.9391 12.5642 21.0459L12.3709 21.0784C12.3526 21.0397 12.3186 21.0078 12.2739 20.9919C12.2298 20.9759 12.1839 20.979 12.1442 20.9962L12.0107 20.8404C12.1045 20.7833 12.2235 20.7661 12.3356 20.806L12.3362 20.8066ZM12.1858 21.2275C12.1417 21.2115 12.119 21.1643 12.1354 21.1207C12.1518 21.0778 12.2009 21.0557 12.2449 21.0716C12.289 21.0876 12.3117 21.1354 12.2953 21.1784C12.2789 21.2213 12.2305 21.2434 12.1858 21.2275ZM11.859 21.0226C11.8766 20.9759 11.903 20.9348 11.9358 20.9005L12.0712 21.0588C12.0642 21.0692 12.0579 21.0802 12.0535 21.0925C12.0233 21.1722 12.0598 21.2587 12.1341 21.2974L12.0926 21.4912C12.0882 21.49 12.0838 21.4894 12.08 21.4882C11.8873 21.4195 11.7878 21.2109 11.859 21.0232V21.0226ZM12.1883 21.5078L12.2292 21.317C12.294 21.3115 12.3532 21.2716 12.3765 21.2078C12.3809 21.1962 12.3835 21.1845 12.3853 21.1729L12.5793 21.1403C12.5799 21.1839 12.5736 21.2287 12.5572 21.2729C12.4993 21.4262 12.3469 21.5164 12.1883 21.5084V21.5078Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1946 15.0221C15.9503 14.9724 15.711 15.1251 15.66 15.3632C15.609 15.6012 15.7658 15.8343 16.0101 15.884C16.2544 15.9337 16.4936 15.7809 16.5446 15.5429C16.5956 15.3049 16.4389 15.0718 16.1946 15.0221ZM16.1725 15.092C16.294 15.1165 16.3898 15.1963 16.4382 15.2987L16.2493 15.3595C16.2248 15.3233 16.1864 15.2963 16.1392 15.2865C16.0926 15.2773 16.0472 15.2865 16.0101 15.3098L15.8521 15.1724C15.9377 15.1012 16.0548 15.0681 16.1732 15.092H16.1725ZM16.085 15.5349C16.0384 15.5257 16.0082 15.4809 16.0183 15.4355C16.0283 15.3901 16.0737 15.3607 16.1203 15.3705C16.1669 15.3803 16.1971 15.4245 16.187 15.4699C16.1776 15.5153 16.1316 15.5447 16.085 15.5349ZM15.7268 15.3767C15.7375 15.3276 15.7576 15.2828 15.7853 15.2435L15.9446 15.3822C15.9396 15.3938 15.9352 15.4055 15.932 15.4184C15.9156 15.4938 15.954 15.5674 16.0208 15.6018L15.9786 15.7999C15.7985 15.7429 15.6871 15.5613 15.7268 15.3767ZM16.464 15.5263C16.4256 15.7061 16.2582 15.8275 16.0749 15.8177L16.1165 15.6214C16.1914 15.6153 16.2569 15.5631 16.2726 15.4877C16.2752 15.4754 16.2764 15.4632 16.2764 15.4515L16.4659 15.3908C16.4735 15.4343 16.4735 15.4803 16.4634 15.5263H16.464Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.39191 41.6114C2.13503 41.5592 1.88255 41.72 1.82966 41.9709C1.77614 42.2212 1.9411 42.4672 2.19862 42.5187C2.45551 42.5708 2.70799 42.4101 2.76088 42.1592C2.81439 41.9089 2.64943 41.6629 2.39191 41.6114ZM2.36799 41.6856C2.49643 41.7114 2.59654 41.7954 2.64754 41.9034L2.44858 41.9672C2.42277 41.9292 2.38247 41.9003 2.33273 41.8905C2.28362 41.8807 2.23577 41.8905 2.19673 41.915L2.03051 41.7703C2.12054 41.6954 2.24332 41.6605 2.36862 41.6856H2.36799ZM2.27606 42.1518C2.22695 42.142 2.19547 42.0948 2.20554 42.0469C2.21562 41.9991 2.2641 41.9684 2.31321 41.9782C2.36232 41.988 2.3938 42.0353 2.38373 42.0831C2.37365 42.131 2.32517 42.1617 2.27606 42.1518ZM1.89892 41.985C1.91025 41.9328 1.93103 41.8856 1.96062 41.8445L2.12873 41.9905C2.12306 42.0022 2.11866 42.015 2.11551 42.0285C2.09851 42.1077 2.1388 42.1856 2.20869 42.2218L2.16399 42.4304C1.97447 42.3702 1.85736 42.1794 1.89892 41.9844V41.985ZM2.67525 42.1426C2.63495 42.3322 2.45802 42.4598 2.26536 42.4494L2.30943 42.2432C2.38814 42.2371 2.4574 42.1819 2.47439 42.1021C2.47691 42.0893 2.47817 42.0764 2.47817 42.0641L2.67776 41.9997C2.68595 42.0457 2.68595 42.0942 2.67525 42.1426Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.62559 40.8653C5.392 40.8181 5.16282 40.9641 5.11433 41.1917C5.06585 41.4193 5.2157 41.6426 5.4493 41.6898C5.68289 41.737 5.91207 41.591 5.96055 41.3635C6.00903 41.1359 5.85918 40.9126 5.62559 40.8653ZM5.60355 40.9328C5.72003 40.9567 5.8107 41.0328 5.85666 41.131L5.67659 41.1886C5.65329 41.1543 5.61615 41.1279 5.57144 41.1187C5.52674 41.1095 5.4833 41.1187 5.44804 41.1408L5.29756 41.0101C5.37941 40.942 5.49022 40.9095 5.60418 40.9322L5.60355 40.9328ZM5.52044 41.3567C5.47574 41.3475 5.44741 41.3052 5.45622 41.2616C5.46567 41.2181 5.50911 41.1905 5.55381 41.199C5.59852 41.2082 5.62685 41.2506 5.61804 41.2941C5.60859 41.3377 5.56515 41.3653 5.52044 41.3567ZM5.1773 41.2052C5.18737 41.1579 5.20689 41.115 5.23333 41.0776L5.3857 41.2101C5.38067 41.2211 5.37626 41.2322 5.37374 41.2444C5.35863 41.3168 5.39515 41.3868 5.45874 41.4199L5.41844 41.6082C5.24656 41.5536 5.13952 41.3812 5.1773 41.2046V41.2052ZM5.88311 41.3481C5.84659 41.5205 5.68603 41.6352 5.511 41.626L5.55067 41.4395C5.62244 41.434 5.68478 41.3837 5.70052 41.3113C5.70304 41.2997 5.70366 41.288 5.70366 41.277L5.88437 41.2187C5.89192 41.2604 5.89192 41.3046 5.88248 41.3487L5.88311 41.3481Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.30061 47.5518C2.04372 47.4997 1.79124 47.6604 1.73835 47.9113C1.68483 48.1616 1.84979 48.4076 2.10731 48.4591C2.3642 48.5113 2.61668 48.3505 2.66957 48.0996C2.72308 47.8493 2.55812 47.6033 2.30061 47.5518ZM2.27668 47.626C2.40512 47.6518 2.50523 47.7358 2.55623 47.8438L2.35727 47.9076C2.33146 47.8696 2.29116 47.8408 2.24142 47.8309C2.19231 47.8211 2.14446 47.8309 2.10542 47.8555L1.9392 47.7107C2.02924 47.6359 2.15264 47.6009 2.27731 47.626H2.27668ZM2.18538 48.0923C2.13627 48.0825 2.10479 48.0352 2.11487 47.9874C2.12494 47.9395 2.17342 47.9088 2.22253 47.9187C2.27164 47.9285 2.30312 47.9757 2.29305 48.0236C2.28298 48.0714 2.23449 48.1021 2.18538 48.0923ZM1.80824 47.9254C1.81957 47.8733 1.84035 47.826 1.86994 47.7849L2.03805 47.9309C2.03238 47.9426 2.02798 47.9555 2.02483 47.969C2.00783 48.0481 2.04812 48.126 2.11801 48.1622L2.07331 48.3708C1.88379 48.3107 1.76668 48.1199 1.80824 47.9248V47.9254ZM2.58457 48.0831C2.54427 48.2726 2.36735 48.4002 2.17468 48.3898L2.21875 48.1837C2.29746 48.1775 2.36672 48.1223 2.38372 48.0426C2.38623 48.0297 2.38749 48.0168 2.38749 48.0045L2.58709 47.9401C2.59527 47.9861 2.59464 48.0346 2.58457 48.0831Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.57492 50.209C7.3174 50.1569 7.06555 50.3176 7.01203 50.5685C6.95851 50.8188 7.12347 51.0648 7.38099 51.1163C7.63788 51.1685 7.89036 51.0078 7.94325 50.7569C7.99677 50.5066 7.8318 50.2606 7.57429 50.209H7.57492ZM7.55099 50.2827C7.67943 50.3084 7.77955 50.3925 7.83055 50.5004L7.63158 50.5642C7.60577 50.5262 7.56547 50.4974 7.51573 50.4875C7.46662 50.4777 7.41877 50.4875 7.37973 50.5121L7.21351 50.3673C7.30355 50.2925 7.42695 50.2575 7.55162 50.2827H7.55099ZM7.45907 50.7489C7.40995 50.7391 7.37847 50.6918 7.38855 50.644C7.39862 50.5961 7.4471 50.5655 7.49621 50.5753C7.54532 50.5851 7.57681 50.6323 7.56673 50.6802C7.55666 50.728 7.50818 50.7587 7.45907 50.7489ZM7.08192 50.582C7.09325 50.5299 7.11403 50.4826 7.14362 50.4415L7.31173 50.5875C7.30607 50.5992 7.30166 50.6121 7.29851 50.6256C7.28151 50.7047 7.32181 50.7826 7.3917 50.8188L7.34699 51.0274C7.15747 50.9673 7.04036 50.7765 7.08192 50.5814V50.582ZM7.85825 50.7397C7.81795 50.9292 7.64103 51.0568 7.44836 51.0464L7.49244 50.8403C7.57114 50.8342 7.6404 50.7789 7.6574 50.6992C7.65992 50.6863 7.66118 50.6734 7.66118 50.6612L7.86077 50.5967C7.86895 50.6428 7.86832 50.6912 7.85825 50.7397Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2272 46.9997C16.9804 46.9494 16.7386 47.104 16.687 47.3445C16.6354 47.585 16.794 47.8205 17.0408 47.8708C17.2877 47.9211 17.5294 47.7666 17.5811 47.5261C17.6327 47.2856 17.474 47.05 17.2272 46.9997ZM17.2045 47.0709C17.328 47.096 17.4243 47.1764 17.4728 47.2795L17.2814 47.3408C17.2568 47.304 17.2178 47.277 17.1699 47.2672C17.1233 47.2574 17.0767 47.2672 17.0396 47.2905L16.8797 47.1519C16.9659 47.0801 17.0843 47.0464 17.2039 47.0709H17.2045ZM17.1164 47.5181C17.0692 47.5083 17.039 47.4635 17.049 47.4175C17.0591 47.3715 17.1051 47.342 17.1523 47.3519C17.1995 47.3617 17.2297 47.4065 17.2197 47.4525C17.2096 47.4985 17.1636 47.5279 17.1164 47.5181ZM16.7544 47.358C16.7651 47.3083 16.7852 47.2629 16.8135 47.2236L16.9747 47.3641C16.9691 47.3758 16.9647 47.3874 16.9621 47.4003C16.9458 47.4764 16.9848 47.5506 17.0515 47.5856L17.0087 47.7862C16.8268 47.7285 16.7147 47.5451 16.7544 47.358ZM17.4992 47.5095C17.4602 47.6917 17.2908 47.8138 17.1063 47.804L17.1485 47.6058C17.2241 47.5997 17.2902 47.5469 17.3065 47.4703C17.3091 47.458 17.3103 47.4457 17.3103 47.4334L17.5017 47.3721C17.5093 47.4163 17.5093 47.4629 17.4992 47.5095Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3109 32.0069C17.0533 31.9547 16.8015 32.1155 16.7486 32.3664C16.6951 32.6167 16.86 32.8627 17.1176 32.9142C17.3751 32.9663 17.6269 32.8056 17.6805 32.5547C17.734 32.3044 17.569 32.0584 17.3115 32.0069H17.3109ZM17.2869 32.0805C17.4154 32.1063 17.5155 32.1903 17.5665 32.2983L17.3675 32.3621C17.3417 32.324 17.3014 32.2952 17.2517 32.2854C17.2026 32.2756 17.1547 32.2854 17.1157 32.3099L16.9495 32.1652C17.0395 32.0903 17.1629 32.0554 17.2876 32.0805H17.2869ZM17.1956 32.5467C17.1465 32.5369 17.115 32.4897 17.1251 32.4418C17.1352 32.394 17.1837 32.3633 17.2328 32.3731C17.2819 32.3829 17.3134 32.4302 17.3033 32.478C17.2932 32.5259 17.2447 32.5565 17.1956 32.5467ZM16.8179 32.3799C16.8292 32.3277 16.85 32.2805 16.8796 32.2394L17.0477 32.3854C17.042 32.397 17.0376 32.4099 17.0345 32.4234C17.0175 32.5026 17.0577 32.5805 17.1276 32.6167L17.0829 32.8252C16.8934 32.7651 16.7763 32.5743 16.8179 32.3793V32.3799ZM17.5948 32.5375C17.5545 32.7271 17.3776 32.8547 17.1849 32.8443L17.229 32.6381C17.3077 32.632 17.377 32.5768 17.394 32.497C17.3965 32.4842 17.3977 32.4713 17.3977 32.459L17.5973 32.3946C17.6055 32.4406 17.6049 32.4891 17.5948 32.5375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1306 23.8709L9.86046 23.8586L9.8548 23.985C9.85731 23.9138 9.85731 23.842 9.85354 23.769C9.84976 23.7034 9.84346 23.6384 9.83465 23.5739L9.8485 23.6745L10.1167 23.6402C10.1847 23.6316 10.2326 23.5709 10.2231 23.5046L10.2212 23.4899C10.2124 23.4236 10.1501 23.377 10.0821 23.3862L9.81387 23.4206L9.82646 23.512C9.81261 23.4261 9.79435 23.3414 9.77168 23.2586L10.0235 23.1807C10.089 23.1605 10.1249 23.0924 10.1041 23.0292L10.0997 23.0151C10.0789 22.9513 10.0091 22.9163 9.9442 22.9366L9.69109 23.0151C9.67598 22.977 9.66024 22.9396 9.64387 22.9022L9.88313 22.7869C9.9442 22.7574 9.96939 22.6844 9.93917 22.6249L9.93224 22.6114C9.90202 22.5519 9.82709 22.5274 9.76602 22.5568L9.5255 22.6734C9.49402 22.62 9.46128 22.5672 9.42602 22.5169L9.63758 22.3642C9.69235 22.3243 9.70431 22.2489 9.66339 22.1949L9.65457 22.1832C9.61365 22.1298 9.5362 22.1182 9.4808 22.1581L9.26735 22.312C9.22706 22.2654 9.18487 22.2206 9.14143 22.1771L9.32276 21.9881C9.36935 21.9397 9.36683 21.863 9.31709 21.8176L9.30576 21.8078C9.25602 21.7624 9.17732 21.7648 9.13073 21.8133L8.94876 22.0029C8.90028 21.963 8.84991 21.9256 8.79828 21.8894L8.81465 21.8998L8.96261 21.6796C9.00039 21.6237 8.98402 21.5489 8.92673 21.5121L8.91413 21.5041C8.85684 21.4673 8.78002 21.4833 8.74225 21.5391L8.59428 21.7593L8.61254 21.771C8.54706 21.7329 8.47969 21.698 8.41106 21.6661L8.51432 21.4244C8.54076 21.363 8.51054 21.2919 8.44758 21.2667L8.43373 21.2612C8.37077 21.2354 8.29773 21.2649 8.27191 21.3262L8.16866 21.5685C8.11199 21.5489 8.05406 21.5311 7.99488 21.5158L8.05217 21.2618C8.06666 21.1968 8.02447 21.1324 7.95773 21.1176L7.94325 21.1146C7.87651 21.1005 7.8104 21.1416 7.79529 21.2066L7.73736 21.4606C7.67251 21.4501 7.60703 21.4422 7.54155 21.4366L7.55099 21.179C7.55351 21.1121 7.49999 21.0563 7.43136 21.0538H7.41625C7.34762 21.0508 7.29033 21.1029 7.28781 21.1698L7.27836 21.4281C7.25003 21.4281 7.22107 21.4287 7.19273 21.4299C7.16755 21.4311 7.14236 21.4336 7.11718 21.4354L7.08129 21.1814C7.07184 21.1152 7.00951 21.0692 6.94151 21.0784L6.9264 21.0802C6.8584 21.0894 6.81118 21.1502 6.82062 21.2164L6.85588 21.4698C6.80425 21.479 6.75325 21.4894 6.70288 21.5017L6.62607 21.2606C6.60592 21.1968 6.53603 21.1612 6.47055 21.1808L6.45607 21.1851C6.39059 21.2048 6.35407 21.2728 6.37422 21.3366L6.45103 21.5765C6.39059 21.598 6.3314 21.6219 6.27348 21.6477L6.15511 21.4262C6.12363 21.3673 6.0487 21.344 5.98763 21.3747L5.9744 21.3814C5.91396 21.4121 5.89003 21.4851 5.92152 21.5446L6.03989 21.7655C5.99329 21.7918 5.94733 21.8194 5.90326 21.8489L5.75089 21.6526C5.70933 21.5992 5.63189 21.5888 5.57711 21.6293L5.56515 21.6379C5.51037 21.6783 5.49967 21.7538 5.54122 21.8072L5.69359 22.0035C5.64133 22.0464 5.59033 22.0918 5.54185 22.1384L5.35674 21.974C5.30637 21.9292 5.22767 21.9323 5.1817 21.982L5.17163 21.993C5.12567 22.0421 5.12882 22.1188 5.17982 22.1636L5.3643 22.328C5.32526 22.374 5.28874 22.4219 5.25285 22.4709L5.04256 22.3415C4.98463 22.3059 4.90782 22.3225 4.8713 22.3789L4.86311 22.3912C4.82659 22.4476 4.84359 22.5225 4.90152 22.558L5.11119 22.6875C5.08348 22.7353 5.05704 22.7838 5.03248 22.8335L4.80582 22.7415C4.74285 22.7157 4.66982 22.7452 4.64337 22.8065L4.63771 22.82C4.61126 22.8813 4.64148 22.9525 4.70445 22.9783L4.93174 23.0709C4.91222 23.1249 4.89459 23.1801 4.87885 23.2359L4.64022 23.1832C4.57348 23.1684 4.50674 23.2095 4.49163 23.2746L4.48848 23.2887C4.47337 23.3537 4.51556 23.4187 4.5823 23.4335L4.82156 23.4862C4.81148 23.5457 4.8033 23.6058 4.797 23.6666L4.55397 23.6555C4.48534 23.6525 4.42741 23.704 4.42426 23.7709V23.7856C4.42048 23.8524 4.47337 23.9089 4.542 23.912L4.7863 23.923C4.7863 23.9567 4.78693 23.9899 4.78882 24.0236C4.79008 24.0512 4.79322 24.0788 4.79511 24.1064L4.5546 24.1377C4.4866 24.1463 4.43874 24.207 4.44819 24.2733L4.45008 24.288C4.45889 24.3543 4.52123 24.4009 4.58923 24.3917L4.831 24.3604C4.84234 24.4199 4.85619 24.4788 4.87193 24.5365L4.64148 24.6076C4.576 24.6279 4.54011 24.696 4.56089 24.7591L4.5653 24.7733C4.58608 24.8371 4.65597 24.872 4.72082 24.8518L4.95252 24.78C4.96763 24.818 4.98337 24.8561 5.00037 24.8935L4.78378 24.9978C4.72271 25.0272 4.69752 25.1002 4.72774 25.1597L4.73467 25.1732C4.76489 25.2327 4.83982 25.2573 4.90089 25.2278L5.11937 25.1223C5.15085 25.1757 5.18296 25.2278 5.21822 25.2781L5.02367 25.4186C4.96889 25.4585 4.95693 25.5339 4.99785 25.5879L5.00667 25.5996C5.04759 25.653 5.12504 25.6646 5.18044 25.6247L5.37689 25.483C5.4197 25.5327 5.46441 25.5806 5.511 25.6266L5.34478 25.8002C5.29819 25.8487 5.3007 25.9253 5.35044 25.9707L5.36178 25.9805C5.41152 26.0259 5.49022 26.0235 5.53681 25.975L5.70492 25.8002C5.74963 25.8364 5.79685 25.8707 5.84407 25.9045L5.70996 26.1045C5.67218 26.1603 5.68855 26.2351 5.74585 26.2719L5.75844 26.2799C5.81574 26.3167 5.89255 26.3008 5.93033 26.2449L6.06633 26.0431C6.1274 26.0769 6.18974 26.1088 6.25396 26.1376L6.15952 26.3591C6.13307 26.4204 6.16329 26.4916 6.22626 26.5167L6.24011 26.5222C6.30307 26.548 6.37611 26.5186 6.40192 26.4572L6.49762 26.2327C6.55555 26.2523 6.61474 26.2701 6.67455 26.2854L6.62103 26.5216C6.60655 26.5866 6.64874 26.6511 6.71548 26.6658L6.72996 26.6688C6.7967 26.683 6.86281 26.6419 6.87792 26.5768L6.93207 26.3376C6.99755 26.3474 7.06429 26.3541 7.13103 26.3591L7.12221 26.6044C7.1197 26.6713 7.17321 26.7271 7.24184 26.7296H7.25696C7.32558 26.7326 7.38288 26.6805 7.3854 26.6136L7.39421 26.3652C7.4131 26.3652 7.43136 26.3652 7.45025 26.364C7.48866 26.3621 7.52707 26.3591 7.56547 26.3554L7.60136 26.613C7.61081 26.6793 7.67314 26.7253 7.74114 26.7167L7.75625 26.7149C7.82425 26.7057 7.87147 26.6449 7.86266 26.5787L7.82614 26.3186C7.87714 26.3087 7.92751 26.2971 7.97725 26.2842L8.05721 26.5351C8.07736 26.5989 8.14725 26.6345 8.21273 26.6149L8.22721 26.6106C8.29269 26.5909 8.32921 26.5228 8.30906 26.459L8.2291 26.2075L8.2014 26.2161C8.27569 26.1891 8.34873 26.1591 8.41988 26.1259L8.39973 26.1364L8.52439 26.3701C8.55588 26.429 8.6308 26.4523 8.69187 26.4216L8.7051 26.4149C8.76554 26.3842 8.78947 26.3112 8.75799 26.2517L8.63332 26.018L8.5565 26.0566C8.62765 26.018 8.69691 25.9756 8.76365 25.9309L8.92169 26.1345C8.96324 26.1879 9.04069 26.1983 9.09547 26.1578L9.10743 26.1492C9.16221 26.1088 9.17291 26.0333 9.13135 25.9799L8.97143 25.7738C9.02306 25.7303 9.07406 25.6855 9.12191 25.6382L9.31458 25.8094C9.36495 25.8542 9.44365 25.8511 9.48961 25.8014L9.49969 25.7904C9.54565 25.7413 9.5425 25.6646 9.4915 25.6198L9.29632 25.4462C9.33221 25.4027 9.3662 25.3579 9.39958 25.3119L9.62372 25.4505C9.68165 25.4861 9.75846 25.4695 9.79498 25.4131L9.80317 25.4008C9.83968 25.3444 9.82268 25.2695 9.76476 25.234L9.53935 25.0947C9.56769 25.045 9.59413 24.9941 9.61932 24.9426L9.86739 25.0432C9.93035 25.0689 10.0034 25.0395 10.0298 24.9781L10.0355 24.9647C10.0619 24.9033 10.0317 24.8321 9.96876 24.8064L9.7188 24.7052L9.71124 24.7223C9.73328 24.6622 9.7528 24.6009 9.7698 24.5383L9.76854 24.5432L10.0324 24.6015C10.0991 24.6162 10.1658 24.5751 10.1809 24.5101L10.1841 24.496C10.1992 24.4309 10.157 24.3659 10.0903 24.3512L9.82646 24.2929L9.81324 24.3506C9.83213 24.2524 9.84472 24.1518 9.85102 24.05L9.84787 24.1168L10.118 24.1291C10.1866 24.1322 10.2445 24.0807 10.2477 24.0138V23.9991C10.2515 23.9322 10.1986 23.8758 10.1299 23.8727L10.1306 23.8709ZM7.41247 25.6235C6.4334 25.6726 5.59852 24.9383 5.54878 23.9843C5.49841 23.0304 6.25207 22.217 7.23114 22.1685C8.21021 22.1194 9.0451 22.8537 9.09484 23.8077C9.14521 24.7616 8.39154 25.575 7.41247 25.6235Z",
    fill: "url(#paint16_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.26823 23.5483C7.87219 23.468 7.48497 23.7158 7.40249 24.1011C7.32001 24.4869 7.57438 24.8642 7.96978 24.9446C8.36582 25.0249 8.75304 24.7771 8.83552 24.3918C8.918 24.006 8.66363 23.6287 8.26823 23.5483ZM7.91815 24.809C7.62601 24.7164 7.44656 24.4225 7.51016 24.1231C7.52716 24.0434 7.5599 23.9704 7.6046 23.9072L7.86338 24.1317C7.85456 24.1501 7.84764 24.1698 7.84323 24.19C7.81741 24.3121 7.87912 24.4311 7.98678 24.4875L7.91815 24.809ZM7.98238 24.2188C7.99812 24.1452 8.07178 24.098 8.14734 24.1133C8.22289 24.1287 8.27138 24.2004 8.25563 24.2741C8.23989 24.3477 8.16623 24.3949 8.09067 24.3796C8.01512 24.3642 7.96664 24.2925 7.98238 24.2188ZM8.70519 24.3648C8.64285 24.6562 8.37086 24.8526 8.07493 24.8366L8.14293 24.5188C8.26445 24.509 8.37023 24.4244 8.39667 24.3017C8.40108 24.282 8.40234 24.2624 8.40234 24.2428L8.7096 24.144C8.72219 24.2152 8.72156 24.2894 8.70582 24.3642L8.70519 24.3648ZM8.35512 24.0949C8.31545 24.036 8.25312 23.9925 8.17693 23.9765C8.10201 23.9612 8.02771 23.9765 7.9679 24.0146L7.71227 23.7919C7.85078 23.6765 8.0403 23.6226 8.23234 23.6618C8.42941 23.7017 8.5843 23.8311 8.66237 23.9968L8.35575 24.0955L8.35512 24.0949Z",
    fill: "url(#paint17_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.24246 24.6299H7.16816C7.1625 24.6085 7.15431 24.5882 7.14361 24.5692L7.19587 24.5189C7.22672 24.4888 7.22735 24.4397 7.19587 24.4091C7.16501 24.379 7.11464 24.3784 7.08316 24.4091L7.03153 24.4588C7.01202 24.4477 6.99061 24.4391 6.96794 24.433V24.3625C6.96794 24.3195 6.93205 24.2852 6.88861 24.2852C6.84516 24.2852 6.80928 24.3201 6.80928 24.3625V24.433C6.78724 24.4391 6.76646 24.4477 6.74694 24.4582L6.69594 24.4078C6.66509 24.3778 6.61472 24.3772 6.58387 24.4078C6.55302 24.4379 6.55239 24.487 6.58387 24.5177L6.6355 24.5686C6.62479 24.5876 6.61661 24.6078 6.61031 24.6293H6.53602C6.49194 24.6293 6.45668 24.6637 6.45605 24.7066C6.45605 24.7495 6.49131 24.7839 6.53539 24.7845H6.61094C6.61724 24.8054 6.62542 24.825 6.63613 24.8434L6.58261 24.8956C6.55176 24.9256 6.55113 24.9747 6.58261 25.0054C6.61409 25.036 6.66383 25.036 6.69531 25.0054L6.74946 24.9526C6.76835 24.963 6.7885 24.971 6.80991 24.9765V25.0514C6.80991 25.0943 6.84579 25.1287 6.88924 25.1287C6.93268 25.1287 6.96857 25.0937 6.96857 25.0514V24.9765C6.98935 24.971 7.0095 24.963 7.02776 24.9532L7.0819 25.006C7.11276 25.036 7.16313 25.0366 7.19461 25.006C7.22546 24.9759 7.22609 24.9268 7.19461 24.8968L7.14109 24.8446C7.15179 24.8262 7.16061 24.8066 7.1669 24.7857H7.24246C7.28653 24.7857 7.32179 24.7514 7.32242 24.7084C7.32242 24.6655 7.28716 24.6311 7.24309 24.6305L7.24246 24.6299ZM6.88924 24.8649C6.79857 24.8649 6.72491 24.7931 6.72491 24.7048C6.72491 24.6164 6.79857 24.5447 6.88924 24.5447C6.9799 24.5447 7.05357 24.6164 7.05357 24.7048C7.05357 24.7931 6.9799 24.8649 6.88924 24.8649Z",
    fill: "url(#paint18_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4865 23.6831L14.3114 23.6598L14.3058 23.6979C14.3121 23.6328 14.3152 23.5672 14.3133 23.5003L14.3152 23.5439L14.4915 23.5371C14.5362 23.5353 14.5708 23.4985 14.5696 23.4549V23.4451C14.5677 23.4015 14.5299 23.3678 14.4852 23.3696L14.3089 23.3764L14.3121 23.4592C14.3095 23.4126 14.3058 23.366 14.2988 23.3187C14.2932 23.2764 14.285 23.2347 14.2755 23.193L14.29 23.2574L14.4625 23.2206C14.506 23.2114 14.5337 23.169 14.5242 23.1267L14.5224 23.1175C14.5129 23.0752 14.4695 23.0482 14.426 23.0574L14.2535 23.0942L14.2667 23.1531C14.2529 23.0979 14.2359 23.0439 14.217 22.9911L14.3763 22.9267C14.4178 22.9102 14.4374 22.8642 14.4204 22.8237L14.4166 22.8151C14.3996 22.7746 14.3524 22.7556 14.3108 22.7721L14.1509 22.8366C14.1389 22.8126 14.1263 22.7887 14.1137 22.7654L14.263 22.6771C14.3014 22.6544 14.3133 22.6059 14.29 22.5685L14.285 22.5605C14.2617 22.5231 14.212 22.5114 14.1735 22.5341L14.0237 22.6231C14.0004 22.5899 13.9758 22.5574 13.95 22.5261L14.0791 22.4151C14.1125 22.3863 14.1163 22.3366 14.0867 22.3035L14.0804 22.2961C14.0508 22.2636 13.9998 22.2599 13.9658 22.2887L13.8354 22.4004C13.8065 22.3722 13.7769 22.3452 13.746 22.3194L13.8537 22.1869C13.8814 22.1525 13.8751 22.1029 13.8405 22.0759L13.8329 22.0697C13.7977 22.0427 13.7467 22.0489 13.719 22.0826L13.6113 22.2157C13.5773 22.1924 13.5427 22.1709 13.5074 22.1501L13.5187 22.1562L13.6025 22.0047C13.6239 21.9667 13.6088 21.9182 13.5697 21.898L13.5609 21.8937C13.5219 21.8728 13.4721 21.8875 13.4514 21.9256L13.3676 22.0771L13.3802 22.0838C13.3355 22.063 13.2896 22.0433 13.243 22.0262L13.2965 21.8636C13.3103 21.8219 13.2864 21.7777 13.2442 21.7642L13.2348 21.7612C13.192 21.7477 13.1466 21.771 13.1328 21.8121L13.0793 21.9753C13.0408 21.9654 13.0024 21.9575 12.9634 21.9501L12.9867 21.782C12.9924 21.7391 12.9615 21.6992 12.9168 21.6931L12.9067 21.6918C12.8627 21.6863 12.8217 21.7164 12.8154 21.7599L12.7921 21.9286C12.7493 21.9256 12.7065 21.9237 12.6631 21.9237L12.6543 21.7556C12.6517 21.7121 12.614 21.6783 12.5693 21.6808H12.5592C12.5145 21.6832 12.4798 21.7207 12.4824 21.7642L12.4912 21.9329C12.4729 21.9348 12.454 21.9366 12.4358 21.9391C12.4194 21.9415 12.403 21.944 12.3867 21.947L12.3489 21.7832C12.3388 21.7409 12.296 21.7139 12.2519 21.7237L12.2425 21.7256C12.199 21.7354 12.1713 21.7771 12.1814 21.82L12.2186 21.9826C12.1858 21.9912 12.1531 22.001 12.121 22.0114L12.0574 21.8587C12.0404 21.8182 11.9931 21.7992 11.9516 21.8151L11.9421 21.8188C11.9006 21.8354 11.8804 21.8814 11.8974 21.9219L11.961 22.074C11.9226 22.0912 11.8861 22.1102 11.8496 22.1298L11.7602 21.9924C11.7363 21.9556 11.6859 21.9446 11.6481 21.9679L11.6399 21.9728C11.6021 21.9961 11.5908 22.0452 11.6147 22.082L11.7041 22.2194C11.6752 22.239 11.6475 22.2593 11.6198 22.2808L11.5096 22.1611C11.48 22.1286 11.4284 22.1262 11.395 22.155L11.3874 22.1611C11.3541 22.19 11.3516 22.2403 11.3812 22.2728L11.4913 22.3924C11.4599 22.4231 11.429 22.455 11.4 22.4881L11.2703 22.3912C11.2351 22.3648 11.1841 22.3709 11.157 22.4059L11.1507 22.4133C11.1236 22.4476 11.1299 22.4973 11.1658 22.5237L11.2955 22.6206C11.2729 22.6525 11.2514 22.6856 11.2313 22.7194L11.0871 22.6464C11.0474 22.6261 10.9983 22.6415 10.9776 22.6801L10.9732 22.6887C10.9524 22.7274 10.9681 22.7752 11.0078 22.7954L11.152 22.8685C11.1369 22.901 11.1224 22.9341 11.1092 22.9678L10.9562 22.92C10.9133 22.9065 10.868 22.9298 10.8542 22.9709L10.851 22.9801C10.8372 23.0218 10.8611 23.066 10.9033 23.0795L11.0569 23.1273C11.0468 23.1635 11.0386 23.2003 11.0317 23.2378L10.8737 23.2163C10.8296 23.2101 10.7887 23.2402 10.7824 23.2838L10.7811 23.2936C10.7748 23.3365 10.8057 23.3764 10.8504 23.3825L11.009 23.404C11.0059 23.4433 11.004 23.4825 11.0034 23.5224L10.8447 23.5285C10.8 23.5304 10.7654 23.5672 10.7666 23.6107V23.6206C10.7685 23.6641 10.8063 23.6978 10.851 23.6966L11.0109 23.6905C11.0128 23.7126 11.0153 23.734 11.0185 23.7561C11.021 23.7739 11.0242 23.7917 11.0273 23.8095L10.8724 23.8426C10.829 23.8518 10.8013 23.8942 10.8107 23.9365L10.8126 23.9457C10.822 23.988 10.8655 24.015 10.9089 24.0058L11.0644 23.9727C11.0752 24.0107 11.0877 24.0481 11.101 24.0849L10.9549 24.1438C10.9133 24.1604 10.8938 24.2064 10.9108 24.2469L10.9146 24.2561C10.9316 24.2966 10.9788 24.3156 11.0204 24.299L11.1671 24.2401C11.179 24.2641 11.1916 24.288 11.2049 24.3113L11.0701 24.3911C11.0317 24.4138 11.0197 24.4622 11.043 24.4996L11.0481 24.5076C11.0714 24.545 11.1211 24.5567 11.1595 24.534L11.2955 24.4536C11.3188 24.4868 11.3427 24.5187 11.3686 24.5493L11.2502 24.6512C11.2168 24.68 11.213 24.7297 11.2426 24.7628L11.2489 24.7702C11.2785 24.8027 11.3295 24.8064 11.3635 24.7775L11.4832 24.6751C11.514 24.7052 11.5455 24.734 11.5789 24.761L11.4806 24.8831C11.4529 24.9174 11.4592 24.9671 11.4939 24.9941L11.5014 25.0002C11.5367 25.0272 11.5877 25.0211 11.6154 24.9873L11.7149 24.8647C11.7463 24.8861 11.7784 24.9058 11.8112 24.9248L11.735 25.0622C11.7136 25.1008 11.7287 25.1487 11.7677 25.1689L11.7766 25.1732C11.8162 25.1941 11.8653 25.18 11.8861 25.1413L11.9629 25.0027C12.0045 25.0217 12.0467 25.0389 12.0901 25.0542L12.041 25.2039C12.0271 25.2456 12.0511 25.2898 12.0933 25.3033L12.1027 25.3063C12.1455 25.3198 12.1909 25.2965 12.2047 25.2548L12.2544 25.1039C12.2935 25.1137 12.3325 25.1217 12.3728 25.1284L12.3514 25.2849C12.3457 25.3278 12.3766 25.3677 12.4213 25.3738L12.4314 25.3751C12.4754 25.3806 12.5164 25.3505 12.5227 25.307L12.5441 25.1487C12.5875 25.1518 12.631 25.1524 12.675 25.1518L12.6832 25.3119C12.6851 25.3554 12.7235 25.3892 12.7682 25.3867H12.7783C12.823 25.3843 12.8576 25.3468 12.8551 25.3033L12.8469 25.1413C12.8589 25.1401 12.8708 25.1389 12.8834 25.1376C12.9086 25.1346 12.9332 25.1303 12.9577 25.126L12.9955 25.2916C13.0056 25.334 13.0484 25.3609 13.0925 25.3511L13.1019 25.3493C13.1454 25.3395 13.1731 25.2978 13.163 25.2548L13.1246 25.0873C13.1573 25.0781 13.1894 25.0677 13.2209 25.0567L13.287 25.2156C13.304 25.256 13.3513 25.2757 13.3928 25.2591L13.4023 25.2554C13.4438 25.2389 13.464 25.1929 13.447 25.1524L13.3802 24.9929L13.3626 24.9996C13.4098 24.9781 13.4551 24.9548 13.4998 24.9291L13.4873 24.937L13.5817 25.0824C13.6056 25.1192 13.656 25.1303 13.6931 25.107L13.7013 25.1021C13.7391 25.0788 13.7504 25.0297 13.7265 24.9929L13.6321 24.8475L13.5842 24.8769C13.6283 24.8481 13.6711 24.8168 13.712 24.7837L13.8266 24.9076C13.8568 24.9401 13.9078 24.9426 13.9412 24.9137L13.9488 24.9076C13.9821 24.8788 13.9847 24.8285 13.9551 24.7959L13.8392 24.6702C13.8707 24.6389 13.9009 24.607 13.9293 24.5739L14.0646 24.6751C14.0999 24.7015 14.1509 24.6953 14.178 24.6604L14.1843 24.653C14.2113 24.6187 14.205 24.569 14.1691 24.5426L14.0325 24.4401C14.0533 24.4101 14.0734 24.3788 14.0917 24.3475L14.2453 24.4254C14.285 24.4457 14.3341 24.4303 14.3549 24.3917L14.3593 24.3831C14.3801 24.3444 14.3643 24.2966 14.3247 24.2763L14.1698 24.1978C14.1855 24.1641 14.2 24.1297 14.2132 24.0941L14.3807 24.1463C14.4235 24.1598 14.4688 24.1365 14.4827 24.0954L14.4858 24.0862C14.4997 24.0445 14.4758 24.0003 14.4336 23.9868L14.2655 23.934L14.2617 23.9457C14.2724 23.9052 14.2818 23.8641 14.2894 23.823V23.8261L14.4638 23.8494C14.5079 23.8555 14.5488 23.8254 14.5551 23.7819L14.5564 23.7721C14.5627 23.7291 14.5318 23.6893 14.4871 23.6831H14.4865ZM12.8482 22.4225C13.3229 22.4991 13.7127 22.8605 13.7989 23.3427L13.3695 23.3414C13.2996 23.0979 13.1 22.9077 12.8482 22.8451V22.4225ZM12.4698 22.4237V22.85C12.2242 22.9175 12.0316 23.1065 11.9648 23.347L11.5153 23.3457C11.5971 22.8832 11.9717 22.5041 12.4698 22.4237ZM12.4786 24.653C11.9931 24.5788 11.594 24.2082 11.514 23.7138L11.9636 23.715C12.0303 23.9604 12.2274 24.153 12.4786 24.2187V24.653ZM12.6681 23.885C12.4685 23.885 12.3067 23.7273 12.3067 23.5328C12.3067 23.3384 12.4685 23.1807 12.6681 23.1807C12.8677 23.1807 13.0295 23.3384 13.0295 23.5328C13.0295 23.7273 12.8677 23.885 12.6681 23.885ZM12.857 24.6493V24.2193C13.1101 24.153 13.3084 23.958 13.3739 23.7107L13.804 23.712C13.7297 24.18 13.3563 24.5653 12.857 24.6499V24.6493Z",
    fill: "url(#paint19_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.14589 20.0114L5.06152 20.1537L5.24475 20.2561L5.33352 20.1058C5.35997 20.0543 5.38326 20.0009 5.40782 19.9482L5.21641 19.8623C5.19312 19.912 5.17108 19.9629 5.14589 20.0114Z",
    fill: "url(#paint20_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.32153 19.6222L5.51924 19.6946C5.55638 19.5848 5.59731 19.4762 5.63068 19.3651L5.42731 19.3105C5.39583 19.4154 5.35616 19.5185 5.32153 19.6222Z",
    fill: "url(#paint21_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.53767 18.7334L5.5169 18.8966C5.51312 18.9236 5.5106 18.9512 5.50619 18.9782L5.4873 19.0585L5.69445 19.099L5.71397 19.0144C5.71901 18.9861 5.72153 18.9573 5.72593 18.9285L5.74797 18.7561L5.5383 18.7334H5.53767Z",
    fill: "url(#paint22_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.9609 21.3314L3.8186 21.4198L3.93194 21.5934L4.08179 21.5001C4.1309 21.4676 4.17623 21.4296 4.22345 21.3946L4.09438 21.2314C4.04968 21.2646 4.00686 21.3002 3.9609 21.3314Z",
    fill: "url(#paint23_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.30151 21.0661L4.44192 21.2201C4.52692 21.1397 4.61633 21.063 4.69755 20.979L4.54392 20.8379C4.46711 20.9176 4.38211 20.99 4.30151 21.0661Z",
    fill: "url(#paint24_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.82113 20.5126C4.78839 20.5574 4.75754 20.6028 4.71851 20.6427L4.88221 20.7727C4.92313 20.7304 4.95588 20.6826 4.9905 20.6353L5.09376 20.4942L4.91873 20.3789L4.82051 20.5126H4.82113Z",
    fill: "url(#paint25_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.283 21.9644L2.11426 21.9766L2.13189 22.1815L2.30944 22.168L2.48448 22.138L2.44859 21.9355L2.283 21.9644Z",
    fill: "url(#paint26_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.71045 21.8846L2.76145 22.084C2.87541 22.0515 2.99063 22.0233 3.10334 21.9865L3.03408 21.792C2.92767 21.827 2.81812 21.8533 2.71045 21.8846Z",
    fill: "url(#paint27_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.43449 21.6286L3.35957 21.666C3.33438 21.6782 3.30731 21.6868 3.28149 21.6973L3.3646 21.8862C3.39168 21.8752 3.42064 21.866 3.44709 21.8531L3.52642 21.8138L3.68509 21.7347L3.58497 21.5537L3.43449 21.6286Z",
    fill: "url(#paint28_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.414911 21.7359L0.338096 21.7021L0.255615 21.8917L0.336837 21.9273C0.364541 21.9383 0.392874 21.9463 0.420578 21.9561L0.589318 22.0119L0.65354 21.8163L0.493614 21.7635C0.46717 21.7543 0.440096 21.7469 0.414281 21.7365L0.414911 21.7359Z",
    fill: "url(#paint29_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.07613 21.9216L0.911801 21.8848L0.862061 22.0848L1.03584 22.1234C1.0648 22.1289 1.09376 22.1375 1.12273 22.1412L1.21087 22.1522L1.24236 21.9486L1.15861 21.9388C1.13091 21.9357 1.10384 21.9271 1.07613 21.9216Z",
    fill: "url(#paint30_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.50601 21.9814L1.48901 22.1863C1.60738 22.1931 1.72638 22.1931 1.84475 22.1968L1.84286 21.9913C1.73079 21.9876 1.61809 21.9882 1.50538 21.9814H1.50601Z",
    fill: "url(#paint31_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.5363 17.8815L5.74597 17.8563C5.73023 17.7416 5.70567 17.6281 5.68552 17.5146L5.479 17.5582C5.49789 17.6662 5.52119 17.7735 5.5363 17.8821V17.8815Z",
    fill: "url(#paint32_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.36507 17.1491C5.38207 17.2013 5.39592 17.2546 5.41166 17.3068L5.6144 17.2491C5.59803 17.1933 5.58292 17.1375 5.56466 17.0822L5.49918 16.9209L5.30273 16.9957L5.36444 17.1485L5.36507 17.1491Z",
    fill: "url(#paint33_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.05595 16.4922C5.07924 16.5296 5.09939 16.5682 5.11954 16.6069L5.19635 16.7535L5.38713 16.6646L5.30591 16.51C5.28387 16.4689 5.26246 16.4272 5.23791 16.3873L5.45954 16.2603L4.81543 15.8916L4.8211 16.6271L5.05658 16.4922H5.05595Z",
    fill: "url(#paint34_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.1305 26.8719L6.06313 26.8418L5.99072 27.008L6.06187 27.0393C6.0858 27.0491 6.11098 27.0559 6.13554 27.0645L6.28413 27.1136L6.3408 26.9412L6.20039 26.8952C6.17709 26.8872 6.15317 26.8804 6.1305 26.8712V26.8719Z",
    fill: "url(#paint35_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.71121 27.0354L6.56702 27.0029L6.52295 27.1784L6.67532 27.2121C6.70113 27.217 6.72569 27.225 6.75213 27.2281L6.82958 27.2379L6.85728 27.0594L6.78361 27.0508C6.75906 27.0477 6.73513 27.041 6.71121 27.0361V27.0354Z",
    fill: "url(#paint36_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.84367 25.976L4.79834 25.9189L4.65479 26.0337L4.70327 26.0938C4.72027 26.1134 4.73853 26.1312 4.75678 26.1496L4.86445 26.26L4.99667 26.1337L4.89467 26.0288C4.87767 26.011 4.86004 25.9944 4.8443 25.976H4.84367Z",
    fill: "url(#paint37_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.16721 26.291L5.04443 26.4266L5.1628 26.5266C5.20058 26.5616 5.24654 26.5873 5.2881 26.618L5.39828 26.4726C5.35925 26.4432 5.3158 26.4192 5.27991 26.3861L5.16847 26.291H5.16721Z",
    fill: "url(#paint38_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.48975 26.7553L5.76112 26.9074L5.84549 26.7461L5.5886 26.6025L5.48975 26.7553Z",
    fill: "url(#paint39_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.14976 24.6708C4.14347 24.6474 4.13528 24.6247 4.13024 24.6014L4.11702 24.5303L3.93506 24.5665L3.94891 24.6413C3.95458 24.6658 3.96276 24.6904 3.96969 24.7149L4.0125 24.8615L4.19006 24.8094L4.14976 24.6708Z",
    fill: "url(#paint40_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.2669 25.0254L4.09375 25.0898C4.13279 25.1843 4.16679 25.2806 4.21779 25.3695L4.38464 25.2904C4.33553 25.2064 4.30405 25.115 4.2669 25.026V25.0254Z",
    fill: "url(#paint41_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.33105 25.583L4.49979 25.84L4.65091 25.7357L4.49161 25.4922L4.33105 25.583Z",
    fill: "url(#paint42_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.17487 22.9901L3.99669 22.9404C3.9715 23.0392 3.94946 23.1386 3.92554 23.2373L4.1075 23.2711C4.13017 23.1772 4.15094 23.0834 4.17487 22.9901Z",
    fill: "url(#paint43_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.05608 23.6416L4.07433 23.498L3.89048 23.4766L3.87097 23.6281L3.86719 23.7802L4.05293 23.7857L4.05608 23.6416Z",
    fill: "url(#paint44_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.05157 24.0137L3.86646 24.021C3.87464 24.1223 3.88157 24.2241 3.89164 24.3247L4.07549 24.3014L4.05219 24.0137H4.05157Z",
    fill: "url(#paint45_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.96315 21.6544L4.82904 21.5293L4.62378 21.7593L4.76859 21.8722L4.96315 21.6544Z",
    fill: "url(#paint46_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.63022 22.0575L4.47722 21.9551C4.413 22.0354 4.36451 22.1256 4.31226 22.214L4.47407 22.3029C4.52381 22.2201 4.56977 22.1342 4.63022 22.0581V22.0575Z",
    fill: "url(#paint47_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.2751 22.701L4.30532 22.6353L4.36639 22.5041L4.19891 22.4268L4.13469 22.5654L4.10258 22.6353L4.07739 22.7077L4.2518 22.7697L4.2751 22.701Z",
    fill: "url(#paint48_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.29734 20.8274L6.23878 20.6562L5.94727 20.7673L6.02156 20.9329L6.29734 20.8274Z",
    fill: "url(#paint49_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.68111 21.1032C5.72141 21.0756 5.768 21.0578 5.81145 21.0345L5.72456 20.875C5.67923 20.8995 5.63011 20.9186 5.5873 20.9474L5.45508 21.0296L5.55582 21.1811L5.68048 21.1032H5.68111Z",
    fill: "url(#paint50_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.1899 21.4449C5.20879 21.4296 5.22894 21.4148 5.24783 21.4001L5.36431 21.3112L5.25287 21.167L5.12946 21.2609C5.10931 21.2768 5.0879 21.2921 5.06839 21.3081L5.01172 21.3608L5.13638 21.4946L5.1899 21.4449Z",
    fill: "url(#paint51_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.57935 20.6686C7.67757 20.6778 7.77579 20.692 7.87338 20.703L7.90234 20.5245C7.79909 20.5122 7.6952 20.4975 7.59194 20.4883L7.57935 20.6686Z",
    fill: "url(#paint52_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.34452 20.6641V20.4831C7.24 20.4764 7.13612 20.4917 7.03223 20.4979L7.04923 20.6776C7.14808 20.6721 7.24567 20.6567 7.34515 20.6641H7.34452Z",
    fill: "url(#paint53_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.59904 20.7445C6.62297 20.739 6.64753 20.7359 6.67208 20.7316L6.81815 20.7059L6.78856 20.5273L6.6343 20.5543C6.60849 20.5592 6.58267 20.5629 6.55749 20.5684L6.48193 20.5893L6.5279 20.7641L6.59904 20.7445Z",
    fill: "url(#paint54_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.18182 20.9873L9.08423 21.1413C9.1283 21.1634 9.16797 21.1922 9.20764 21.2204L9.32852 21.3045L9.43997 21.1597L9.31278 21.0713C9.2706 21.0413 9.22841 21.0118 9.18182 20.9879V20.9873Z",
    fill: "url(#paint55_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.61133 20.9058C8.70074 20.9462 8.79266 20.9831 8.88018 21.0266L8.96581 20.8665C8.87325 20.8199 8.77629 20.7812 8.68185 20.7383L8.61133 20.9051V20.9058Z",
    fill: "url(#paint56_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.14985 20.5742L8.10767 20.7503L8.25185 20.7828L8.39226 20.8288L8.45081 20.657L8.30222 20.6086L8.14985 20.5742Z",
    fill: "url(#paint57_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0273 21.7021L9.88501 21.8181C9.94482 21.8948 10.009 21.9678 10.0651 22.0475L10.2175 21.9445C10.1583 21.861 10.0903 21.7831 10.0273 21.7028V21.7021Z",
    fill: "url(#paint58_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.63519 21.3145L9.51367 21.4506L9.62575 21.5451C9.66163 21.5782 9.69437 21.6144 9.72837 21.6494L9.86186 21.5243C9.82534 21.4881 9.79071 21.4494 9.75293 21.4144L9.63519 21.3145Z",
    fill: "url(#paint59_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.02778 27.6414L7.772 27.2139L7.02148 26.7832L7.02778 27.6414Z",
    fill: "url(#paint60_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.2609 14.3897L32.0752 14.4038L32.0941 14.6302L32.2899 14.6154L32.4838 14.5817L32.4442 14.3584L32.2609 14.3897Z",
    fill: "url(#paint61_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.7332 14.3007L32.7892 14.5209C32.9151 14.4847 33.0423 14.4541 33.1663 14.413L33.0902 14.1982C32.973 14.2369 32.8522 14.2657 32.7332 14.3001V14.3007Z",
    fill: "url(#paint62_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.1993 14.1361L30.1143 14.0986L30.0237 14.3078L30.1131 14.3471C30.1433 14.3594 30.1748 14.3679 30.2056 14.379L30.392 14.4403L30.4632 14.2238L30.2869 14.1661C30.2573 14.1563 30.2277 14.1477 30.1987 14.1361H30.1993Z",
    fill: "url(#paint63_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.9285 14.3422L30.7472 14.3018L30.6924 14.5226L30.8838 14.5655C30.9159 14.5717 30.9474 14.5815 30.9801 14.5852L31.0777 14.5968L31.1123 14.3723L31.0198 14.3613C30.9889 14.3576 30.9593 14.3484 30.9285 14.3422Z",
    fill: "url(#paint64_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.4033 14.4082L31.385 14.6346C31.516 14.6425 31.6469 14.6419 31.7779 14.6462L31.776 14.4192C31.652 14.4156 31.5279 14.4156 31.4039 14.4088L31.4033 14.4082Z",
    fill: "url(#paint65_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.5826 13.0112L28.5253 12.9395L28.3452 13.0836L28.4057 13.1591C28.4271 13.1836 28.4504 13.2057 28.4724 13.229L28.6078 13.3676L28.774 13.2088L28.6455 13.0775C28.6248 13.0554 28.6021 13.0339 28.582 13.0112H28.5826Z",
    fill: "url(#paint66_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.9887 13.4062L28.8345 13.5762L28.9831 13.7019C29.0309 13.7461 29.0882 13.778 29.1405 13.8167L29.2784 13.6338C29.2292 13.597 29.1745 13.567 29.1298 13.5253L28.9894 13.4062H28.9887Z",
    fill: "url(#paint67_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.394 13.9899L29.7347 14.1807L29.8411 13.9788L29.5181 13.7979L29.394 13.9899Z",
    fill: "url(#paint68_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.7111 11.371C27.7029 11.3422 27.6935 11.3133 27.6866 11.2839L27.6702 11.1943L27.4417 11.2403L27.4593 11.3348C27.4668 11.3661 27.4769 11.3962 27.4851 11.4275L27.5386 11.6115L27.7615 11.5458L27.7105 11.3716L27.7111 11.371Z",
    fill: "url(#paint69_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.8573 11.817L27.6394 11.898C27.6885 12.0164 27.7313 12.1379 27.7956 12.2489L28.0046 12.1489C27.9429 12.0434 27.9032 11.9287 27.8566 11.8164L27.8573 11.817Z",
    fill: "url(#paint70_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.9385 12.5174L28.1507 12.8407L28.3408 12.7094L28.1406 12.4033L27.9385 12.5174Z",
    fill: "url(#paint71_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.3876 13.6383L33.5193 13.7101L33.6893 13.9401L33.5319 14.0187L33.4488 14.0598C33.4211 14.0733 33.3915 14.0825 33.3625 14.0941L33.4545 14.3027C33.4847 14.2904 33.5162 14.2806 33.5451 14.2665L33.6327 14.2229L33.8077 14.1358L33.7302 13.9966L34.0331 14.4064L34.387 13.6377L34.3876 13.6383Z",
    fill: "url(#paint72_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.8826 17.4691L33.8732 17.2881L33.6409 17.3004L33.6503 17.4918L33.6793 17.6813L33.9097 17.6488L33.8826 17.4691Z",
    fill: "url(#paint73_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.0543 18.2829C34.0178 18.1676 33.992 18.0492 33.9599 17.9326L33.7319 17.9811C33.7653 18.1044 33.7936 18.2295 33.832 18.3516L34.0543 18.2835V18.2829Z",
    fill: "url(#paint74_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.1658 15.5537C34.1771 15.5255 34.1859 15.4966 34.1992 15.469L34.2401 15.3874L34.0279 15.293L33.9851 15.3789C33.9719 15.4077 33.9618 15.4384 33.9498 15.4684L33.8818 15.6482L34.1016 15.7236L34.1658 15.5537Z",
    fill: "url(#paint75_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.9454 16.2618C33.9498 16.2317 33.9599 16.2029 33.9675 16.1734L34.0141 15.998L33.7893 15.9385L33.7402 16.1237C33.7326 16.155 33.7219 16.1851 33.7175 16.217L33.7024 16.3115L33.9316 16.3513L33.9454 16.2618Z",
    fill: "url(#paint76_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.8869 16.6339L33.6552 16.6094C33.6439 16.7364 33.6401 16.8646 33.6326 16.9916L33.8655 16.9959C33.8731 16.875 33.8762 16.7542 33.8869 16.6339Z",
    fill: "url(#paint77_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.252 13.7491C35.2262 13.7687 35.2029 13.7914 35.1783 13.8123L35.0322 13.9405L35.1909 14.1067L35.3294 13.9853C35.3527 13.9656 35.3747 13.9442 35.3993 13.9251L35.4742 13.8712L35.3313 13.6914L35.252 13.7485V13.7491Z",
    fill: "url(#paint78_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.6783 14.2958C34.6317 14.3412 34.5971 14.3958 34.5562 14.4454L34.74 14.5853C34.779 14.5381 34.8111 14.4859 34.8559 14.4436L34.9818 14.3105L34.8118 14.1553L34.6789 14.2964L34.6783 14.2958Z",
    fill: "url(#paint79_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.5657 14.8148L34.3724 14.6885L34.1665 15.0155L34.3711 15.124L34.5657 14.8148Z",
    fill: "url(#paint80_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.923 13.3125L35.5862 13.5094L35.7153 13.6984L36.0345 13.5119L35.923 13.3125Z",
    fill: "url(#paint81_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.3038 18.8738L34.2276 18.718L34.1873 18.6364C34.1741 18.6088 34.1653 18.58 34.1546 18.5518L33.938 18.6352C33.9499 18.6652 33.9587 18.6959 33.9726 18.7248L34.0148 18.8113L34.0991 18.9842L34.2446 18.9131L33.8152 19.1965L34.5934 19.5627L34.5437 18.7149L34.3025 18.8738H34.3038Z",
    fill: "url(#paint82_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.46712 36.4868L3.3689 36.6414L3.56786 36.7598L3.67112 36.5966L3.75801 36.4248L3.54897 36.3242L3.46712 36.4868Z",
    fill: "url(#paint83_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.67236 36.0628L3.88832 36.1486C3.9324 36.0284 3.98214 35.91 4.02181 35.7885L3.79892 35.7217C3.76177 35.837 3.71392 35.9487 3.67236 36.0628Z",
    fill: "url(#paint84_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.118 37.9074C2.09218 37.9246 2.06763 37.943 2.04118 37.9589L1.95996 38.0037L2.07959 38.1988L2.16522 38.1515C2.19292 38.135 2.21937 38.1153 2.24644 38.0976L2.407 37.9871L2.26974 37.8037L2.11737 37.908L2.118 37.9074Z",
    fill: "url(#paint85_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.71162 37.4455C2.69021 37.4676 2.66503 37.4854 2.64236 37.5063L2.50195 37.6253L2.65243 37.7989L2.80103 37.6731C2.82558 37.6516 2.8514 37.6326 2.87406 37.6093L2.94143 37.5394L2.77584 37.3799L2.71225 37.4461L2.71162 37.4455Z",
    fill: "url(#paint86_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.97681 37.1719L3.15373 37.3197C3.23747 37.2216 3.31429 37.1179 3.39488 37.0173L3.20536 36.8848C3.12918 36.9799 3.05614 37.078 2.97681 37.1713V37.1719Z",
    fill: "url(#paint87_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.247263 38.5553C0.216412 38.559 0.18556 38.5639 0.154708 38.5663L0.0615234 38.5694L0.0747456 38.7964L0.172967 38.7933C0.205708 38.7909 0.237819 38.7859 0.27056 38.7823L0.465744 38.7577L0.432374 38.5332L0.247893 38.5565L0.247263 38.5553Z",
    fill: "url(#paint88_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.903256 38.4405L0.721924 38.4803L0.771664 38.7024L0.963071 38.6601C1.02792 38.6484 1.08837 38.6227 1.1507 38.6042L1.08081 38.3877C1.02163 38.4049 0.96433 38.43 0.902627 38.4405H0.903256Z",
    fill: "url(#paint89_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.35864 38.2947L1.44427 38.5057L1.80379 38.3499L1.69927 38.1475L1.35864 38.2947Z",
    fill: "url(#paint90_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.52758 35.102L4.09943 34.3701L3.64673 35.0952L3.93762 35.0971L3.90991 35.2676L3.89543 35.3572C3.89039 35.3872 3.88032 35.4161 3.87339 35.4449L4.10069 35.4958C4.10825 35.4645 4.11895 35.4345 4.12399 35.4026L4.13973 35.3081L4.17058 35.1192L4.00939 35.0977L4.52758 35.1014V35.102Z",
    fill: "url(#paint91_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8268 49.4622L15.5441 49.4168L15.5334 49.4788C15.5466 49.3739 15.5542 49.2671 15.5542 49.1585L15.5554 49.2291L15.8419 49.2254C15.9143 49.2242 15.9722 49.1665 15.9716 49.0953V49.08C15.9703 49.0095 15.9105 48.953 15.8381 48.9536L15.5516 48.9573L15.5535 49.0917C15.5516 49.0162 15.5472 48.9401 15.5384 48.8635C15.5309 48.7941 15.5189 48.726 15.5057 48.6586L15.5264 48.7641L15.8079 48.7107C15.879 48.6972 15.9256 48.6303 15.9118 48.5604L15.9086 48.5451C15.8948 48.4758 15.8261 48.4304 15.755 48.4439L15.4736 48.4972L15.4924 48.5929C15.4723 48.5027 15.4471 48.4144 15.4182 48.3285L15.6794 48.2304C15.7474 48.2052 15.7808 48.131 15.755 48.0647L15.7493 48.05C15.7235 47.9838 15.6473 47.9512 15.5793 47.9764L15.3168 48.0745C15.2985 48.0353 15.2796 47.9966 15.2595 47.958L15.505 47.8212C15.568 47.7862 15.59 47.7077 15.5542 47.6464L15.546 47.6329C15.5101 47.5715 15.4295 47.55 15.3665 47.5856L15.1197 47.7237C15.0832 47.6691 15.0448 47.6157 15.0045 47.5642L15.2186 47.3899C15.274 47.3445 15.2815 47.2642 15.2349 47.2096L15.2249 47.1979C15.1783 47.1439 15.0958 47.1366 15.0397 47.182L14.8238 47.358C14.7785 47.3108 14.7306 47.266 14.6821 47.2225L14.8616 47.0114C14.9082 46.9568 14.9 46.8765 14.8446 46.8311L14.832 46.8212C14.7759 46.7759 14.6935 46.7838 14.6469 46.8378L14.4668 47.0495C14.4126 47.0108 14.3572 46.974 14.3006 46.939L14.3188 46.9495L14.4611 46.7071C14.497 46.6458 14.4756 46.5679 14.4126 46.5323L14.3988 46.5243C14.3358 46.4894 14.2559 46.5102 14.2193 46.5716L14.077 46.8139L14.0972 46.8249C14.0254 46.7887 13.9524 46.7556 13.8768 46.7262L13.97 46.4642C13.9939 46.3973 13.9574 46.3243 13.8888 46.301L13.8737 46.2961C13.805 46.2728 13.7301 46.3084 13.7068 46.3753L13.613 46.6378C13.5513 46.6206 13.489 46.6059 13.426 46.5924L13.4707 46.3207C13.482 46.2507 13.4336 46.1851 13.3618 46.174L13.346 46.1716C13.2743 46.1606 13.2069 46.2078 13.1956 46.2777L13.1509 46.5501C13.0816 46.5434 13.0123 46.5384 12.9418 46.5372L12.9349 46.2642C12.933 46.1937 12.8726 46.1379 12.8002 46.1397H12.7844C12.712 46.1415 12.6547 46.2004 12.656 46.271L12.6629 46.5446C12.6327 46.547 12.6025 46.5489 12.5722 46.5519C12.5452 46.555 12.5193 46.5587 12.4923 46.5624L12.4381 46.2961C12.4243 46.2268 12.355 46.182 12.2839 46.1955L12.2681 46.1986C12.197 46.2121 12.1504 46.2796 12.1649 46.3489L12.219 46.6145C12.1649 46.6274 12.112 46.6415 12.0597 46.6581L11.9628 46.4078C11.9369 46.3415 11.8614 46.3084 11.7934 46.3329L11.7783 46.3385C11.7103 46.3636 11.6763 46.4372 11.7015 46.5035L11.7978 46.7525C11.7355 46.7789 11.6744 46.8084 11.6146 46.839L11.4754 46.6127C11.4383 46.5519 11.3577 46.5323 11.2954 46.5685L11.2815 46.5765C11.2192 46.6127 11.199 46.6912 11.2362 46.7519L11.3753 46.9783C11.3281 47.009 11.2815 47.0409 11.2362 47.0746L11.0624 46.8765C11.0152 46.8225 10.9321 46.8163 10.8773 46.8624L10.8653 46.8722C10.8099 46.9182 10.8036 46.9992 10.8508 47.0525L11.0246 47.2507C10.9717 47.2991 10.9214 47.3501 10.8729 47.4028L10.6664 47.2402C10.6097 47.1961 10.5272 47.204 10.4819 47.2593L10.4718 47.2715C10.4265 47.3267 10.4347 47.4071 10.4913 47.4513L10.6972 47.6138C10.6588 47.6648 10.6229 47.7181 10.5889 47.7715L10.3585 47.6476C10.2949 47.6132 10.2149 47.6359 10.1797 47.6979L10.1721 47.7114C10.1368 47.7733 10.1601 47.8513 10.2237 47.8856L10.4542 48.0095C10.4284 48.0617 10.4032 48.1144 10.3805 48.1684L10.135 48.085C10.0663 48.0617 9.9914 48.0966 9.96747 48.1635L9.96243 48.1782C9.93851 48.2451 9.9744 48.3181 10.043 48.3414L10.2892 48.4255C10.2716 48.4837 10.2571 48.5432 10.2439 48.6034L9.98825 48.5623C9.91647 48.5506 9.8491 48.5978 9.83714 48.6678L9.83462 48.6831C9.82266 48.753 9.87114 48.8187 9.94292 48.8303L10.1992 48.8714C10.1922 48.9352 10.1872 48.999 10.1853 49.0634L9.9278 49.0671C9.8554 49.0684 9.79747 49.126 9.7981 49.1972V49.2125C9.79936 49.2831 9.85918 49.3395 9.93158 49.3389L10.1904 49.3352C10.1929 49.3708 10.1954 49.4058 10.1998 49.4413C10.203 49.4708 10.208 49.4996 10.2118 49.5285L9.95929 49.5763C9.88814 49.5898 9.84155 49.6567 9.8554 49.726L9.85855 49.7413C9.8724 49.8106 9.94103 49.856 10.0122 49.8425L10.2659 49.7947C10.2823 49.8567 10.2999 49.9186 10.3207 49.9787L10.0821 50.0683C10.0147 50.0934 9.98069 50.1677 10.0065 50.2339L10.0122 50.2487C10.038 50.3149 10.1142 50.3474 10.1822 50.3223L10.4227 50.2321C10.4409 50.2714 10.4605 50.3106 10.4806 50.3493L10.2584 50.4732C10.1954 50.5082 10.1734 50.5867 10.2099 50.648L10.2181 50.6615C10.254 50.7229 10.3345 50.7443 10.3975 50.7088L10.6217 50.5836C10.6582 50.6376 10.6959 50.691 10.7362 50.7419L10.5398 50.902C10.4844 50.9474 10.4768 51.0278 10.5234 51.0824L10.5335 51.0946C10.5801 51.1486 10.6632 51.156 10.7186 51.1106L10.9169 50.9486C10.9654 50.9983 11.0158 51.0462 11.0681 51.0922L10.9031 51.2854C10.8565 51.34 10.8647 51.4204 10.9201 51.4658L10.9327 51.4756C10.9887 51.521 11.0712 51.513 11.1178 51.459L11.284 51.2639C11.3338 51.2995 11.3854 51.3333 11.4376 51.3652L11.3086 51.5848C11.2727 51.6461 11.2941 51.724 11.3571 51.7596L11.3709 51.7676C11.4339 51.8026 11.5138 51.7817 11.5504 51.7204L11.6807 51.4989C11.7474 51.5308 11.8154 51.5608 11.8847 51.5872L11.7991 51.8277C11.7751 51.8946 11.8116 51.9676 11.8803 51.9909L11.8954 51.9958C11.964 52.0191 12.0389 51.9835 12.0629 51.9167L12.1498 51.6737C12.2127 51.6909 12.2763 51.7056 12.3405 51.7185L12.299 51.9713C12.2876 52.0412 12.3361 52.1068 12.4079 52.1179L12.4236 52.1203C12.4954 52.1314 12.5628 52.0841 12.5741 52.0142L12.6157 51.7584C12.6856 51.7645 12.7561 51.7676 12.8272 51.7688L12.8335 52.0283C12.8354 52.0989 12.8952 52.1547 12.9683 52.1528H12.984C13.0564 52.151 13.1137 52.0921 13.1125 52.0216L13.1055 51.7584C13.125 51.7565 13.1446 51.7553 13.1647 51.7535C13.2056 51.7492 13.2459 51.7437 13.2856 51.7375L13.3404 52.0075C13.3542 52.0768 13.4235 52.1222 13.4946 52.1081L13.5104 52.105C13.5815 52.0915 13.6281 52.024 13.6136 51.9547L13.5582 51.6817C13.6111 51.6682 13.664 51.6529 13.7156 51.6357L13.8164 51.8958C13.8422 51.9621 13.9178 51.9952 13.9858 51.9706L14.0009 51.9651C14.0689 51.94 14.1029 51.8664 14.0777 51.8001L13.9763 51.5388L13.9473 51.5492C14.0248 51.5161 14.0997 51.4799 14.1721 51.4406L14.1513 51.4529L14.2987 51.6921C14.3358 51.7529 14.4164 51.7725 14.4787 51.7363L14.4926 51.7283C14.5549 51.6921 14.5751 51.6136 14.5379 51.5529L14.3906 51.3136L14.3119 51.3596C14.3849 51.3142 14.4555 51.2658 14.5228 51.2136L14.7029 51.4191C14.7501 51.4731 14.8326 51.4793 14.888 51.4332L14.9 51.4228C14.9554 51.3768 14.9617 51.2964 14.9145 51.2425L14.7325 51.0345C14.7847 50.9854 14.8351 50.9351 14.883 50.8817L15.0977 51.0511C15.1543 51.0952 15.2368 51.0873 15.2822 51.032L15.2922 51.0198C15.3376 50.9646 15.3294 50.8842 15.2727 50.84L15.0555 50.6689C15.0907 50.6204 15.1241 50.5713 15.1556 50.521L15.4018 50.6535C15.4654 50.6879 15.5453 50.6652 15.5806 50.6032L15.5882 50.5897C15.6234 50.5278 15.6001 50.4499 15.5365 50.4155L15.2891 50.2824C15.3155 50.2278 15.3407 50.1726 15.3634 50.1168L15.6322 50.2082C15.7009 50.2315 15.7758 50.1965 15.7997 50.1296L15.8047 50.1149C15.8287 50.0481 15.7928 49.9751 15.7242 49.9517L15.4534 49.8597L15.4465 49.8781C15.466 49.8131 15.4824 49.7468 15.4962 49.68V49.6855L15.7783 49.7309C15.8501 49.7425 15.9174 49.6953 15.9294 49.6254L15.9319 49.61C15.9439 49.5401 15.8954 49.4745 15.8236 49.4628L15.8268 49.4622ZM13.0772 50.9738C12.0452 51.0854 11.1153 50.3609 11.0007 49.3548C10.8861 48.3494 11.6297 47.4433 12.6623 47.3316C13.6942 47.22 14.6242 47.9445 14.7388 48.9506C14.8534 49.956 14.1098 50.8621 13.0772 50.9738Z",
    fill: "url(#paint92_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8857 47.6699C12.049 47.6699 11.3708 48.3306 11.3708 49.1459C11.3708 49.9612 12.049 50.6219 12.8857 50.6219C13.7225 50.6219 14.4006 49.9612 14.4006 49.1459C14.4006 48.3306 13.7225 47.6699 12.8857 47.6699ZM12.8857 50.0238C12.3883 50.0238 11.9847 49.6305 11.9847 49.1459C11.9847 48.6613 12.3883 48.268 12.8857 48.268C13.3831 48.268 13.7867 48.6613 13.7867 49.1459C13.7867 49.6305 13.3831 50.0238 12.8857 50.0238Z",
    fill: "url(#paint93_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0205 14.8556L21.7705 14.825L21.7554 14.9421C21.7629 14.8759 21.7686 14.8096 21.7705 14.7421C21.7724 14.6808 21.7705 14.6201 21.768 14.5599L21.773 14.6544L22.0242 14.6415C22.0878 14.6385 22.1369 14.5851 22.1338 14.5231V14.5096C22.13 14.4477 22.0752 14.3998 22.0116 14.4029L21.7604 14.4158L21.7648 14.5017C21.7585 14.4207 21.7478 14.3409 21.7333 14.2624L21.9732 14.2084C22.0356 14.1943 22.074 14.1342 22.0595 14.0735L22.0563 14.06C22.0419 13.9992 21.9802 13.9618 21.9178 13.9759L21.6773 14.0305C21.6666 13.9943 21.6546 13.9581 21.6421 13.9226L21.8731 13.8324C21.9323 13.8091 21.9613 13.744 21.9373 13.6864L21.9323 13.6735C21.9084 13.6158 21.8416 13.5876 21.7825 13.6109L21.5501 13.7017C21.5249 13.6496 21.4985 13.5986 21.4702 13.549L21.6779 13.4226C21.7321 13.3895 21.7485 13.3201 21.7151 13.2674L21.7075 13.2557C21.6735 13.203 21.6024 13.187 21.5482 13.2195L21.3386 13.3471C21.3046 13.3011 21.2693 13.2563 21.2322 13.2128L21.4148 13.0508C21.462 13.0091 21.4651 12.9379 21.4223 12.8919L21.4129 12.8815C21.3701 12.8355 21.297 12.8324 21.2498 12.8741L21.0666 13.0367C21.0244 12.9962 20.9809 12.9576 20.9356 12.9208L20.9501 12.9318L21.1043 12.738C21.1434 12.6889 21.1346 12.6183 21.0842 12.5803L21.0729 12.5717C21.0225 12.5337 20.9501 12.5423 20.9111 12.5913L20.7568 12.7852L20.7732 12.7975C20.7152 12.7576 20.6554 12.7202 20.5937 12.6852L20.7077 12.4687C20.7366 12.4134 20.7146 12.3453 20.6573 12.3171L20.6447 12.311C20.5881 12.2828 20.5182 12.3042 20.4892 12.3601L20.3752 12.5772C20.3236 12.5551 20.2714 12.5343 20.2185 12.5159L20.2915 12.2846C20.3104 12.2251 20.2758 12.1625 20.2147 12.1441L20.2015 12.1404C20.1404 12.122 20.0762 12.1558 20.0573 12.2153L19.9842 12.4472C19.9251 12.4331 19.8652 12.4208 19.8042 12.411L19.8325 12.1723C19.8401 12.1104 19.7941 12.0546 19.7311 12.0478L19.7173 12.046C19.6537 12.0386 19.5964 12.0834 19.5895 12.1447L19.5611 12.3834C19.5347 12.3815 19.5082 12.3797 19.4812 12.3791C19.4572 12.3785 19.4339 12.3791 19.4107 12.3791L19.3968 12.1404C19.393 12.0785 19.3389 12.0313 19.2753 12.0343H19.2614C19.1978 12.0386 19.1487 12.0914 19.1525 12.1539L19.1664 12.3914C19.1179 12.3963 19.0694 12.4024 19.0222 12.4104L18.9693 12.1809C18.9554 12.1202 18.8937 12.0822 18.8314 12.0957L18.8175 12.0987C18.7552 12.1122 18.7162 12.1723 18.73 12.2331L18.7829 12.4613C18.725 12.4766 18.669 12.495 18.6129 12.5147L18.5197 12.3006C18.4952 12.2435 18.4272 12.2165 18.3686 12.2411L18.3554 12.2466C18.2968 12.2705 18.2691 12.3368 18.2943 12.3938L18.3869 12.6073C18.3415 12.6288 18.2968 12.6508 18.2534 12.6748L18.1268 12.4815C18.0928 12.4294 18.0211 12.4134 17.9675 12.4472L17.9556 12.4545C17.9021 12.4877 17.8857 12.5576 17.9203 12.6097L18.0469 12.803C17.9946 12.8392 17.9443 12.8772 17.8958 12.9171L17.7365 12.7508C17.693 12.7054 17.62 12.703 17.5734 12.7453L17.5633 12.7545C17.5167 12.7969 17.5142 12.868 17.5577 12.9134L17.7163 13.079C17.6767 13.1189 17.6389 13.1606 17.6024 13.2036L17.4173 13.068C17.3663 13.0306 17.2938 13.0404 17.2554 13.0901L17.2473 13.1011C17.2088 13.1508 17.2195 13.2214 17.2705 13.2588L17.4557 13.3944C17.4267 13.4367 17.3984 13.4796 17.3719 13.5238L17.1685 13.422C17.1119 13.3938 17.042 13.4152 17.013 13.4704L17.0067 13.4827C16.9778 13.5379 16.9998 13.606 17.0565 13.6342L17.2605 13.7367C17.2378 13.7858 17.2177 13.8354 17.1988 13.8864L16.9816 13.8207C16.9205 13.8023 16.8563 13.8354 16.8367 13.8949L16.8323 13.9078C16.8134 13.9673 16.8474 14.0299 16.9085 14.0489L17.1264 14.1152C17.1125 14.1698 17.0999 14.225 17.0898 14.2808L16.8651 14.2532C16.8021 14.2452 16.7442 14.2894 16.736 14.3508L16.7341 14.3642C16.7259 14.4256 16.7713 14.482 16.8342 14.49L17.0603 14.5176C17.0584 14.5489 17.0558 14.5796 17.0552 14.6115C17.0546 14.6372 17.0552 14.663 17.0552 14.6888L16.8292 14.7004C16.7656 14.7035 16.7165 14.7569 16.7196 14.8188V14.8323C16.7234 14.8943 16.7782 14.9421 16.8418 14.9391L17.0684 14.9274C17.0747 14.9832 17.0829 15.0391 17.093 15.0943L16.8739 15.144C16.8116 15.1581 16.7731 15.2182 16.7876 15.2789L16.7908 15.2924C16.8053 15.3531 16.867 15.3906 16.9293 15.3765L17.1497 15.3268C17.1604 15.3636 17.1723 15.3998 17.1856 15.4353L16.9765 15.5169C16.9173 15.5403 16.8884 15.6053 16.9123 15.6629L16.9173 15.6758C16.9413 15.7335 17.008 15.7617 17.0672 15.7384L17.2781 15.6562C17.3033 15.7077 17.3291 15.7586 17.3581 15.8077L17.1667 15.9237C17.1125 15.9568 17.0961 16.0261 17.1295 16.0789L17.1371 16.0905C17.1711 16.1433 17.2422 16.1592 17.2964 16.1267L17.4897 16.0095C17.5255 16.0586 17.5633 16.1065 17.603 16.1525L17.4355 16.3016C17.3883 16.3433 17.3851 16.4144 17.428 16.4604L17.4374 16.4703C17.4802 16.5163 17.5533 16.5193 17.6005 16.4776L17.7698 16.3273C17.8089 16.3641 17.8492 16.3997 17.8907 16.4341L17.751 16.6095C17.7119 16.6586 17.7207 16.7291 17.7711 16.7672L17.7824 16.7758C17.8328 16.8138 17.9052 16.8052 17.9443 16.7561L18.0853 16.5788C18.1394 16.615 18.1948 16.6488 18.2521 16.6801L18.1476 16.8788C18.1187 16.934 18.1407 17.0021 18.198 17.0303L18.2106 17.0365C18.2673 17.0647 18.3371 17.0432 18.3661 16.9874L18.4719 16.7862C18.5241 16.8083 18.5777 16.8291 18.6324 16.8475L18.5644 17.0629C18.5455 17.1224 18.5802 17.1849 18.6412 17.2033L18.6545 17.2076C18.7155 17.226 18.7798 17.1923 18.7987 17.1328L18.8673 16.915C18.9271 16.9291 18.9888 16.9402 19.0505 16.9494L19.0234 17.1764C19.0159 17.2383 19.0612 17.2941 19.1248 17.3009L19.1387 17.3027C19.2022 17.3101 19.2595 17.2653 19.2665 17.204L19.2935 16.9739C19.3112 16.9745 19.3282 16.9764 19.3452 16.9764C19.3811 16.9776 19.4169 16.977 19.4528 16.9764L19.4667 17.2181C19.4705 17.28 19.5246 17.3279 19.5882 17.3242H19.6021C19.6656 17.3199 19.7141 17.2671 19.711 17.2046L19.6971 16.9604C19.745 16.9549 19.7928 16.9475 19.8401 16.9389L19.8948 17.1776C19.9087 17.2383 19.9704 17.2763 20.0327 17.2628L20.0466 17.2598C20.1089 17.2463 20.1479 17.1862 20.1341 17.1254L20.0787 16.8862L20.0522 16.8917C20.1234 16.8721 20.1933 16.8494 20.2619 16.8236L20.2424 16.8316L20.3406 17.0573C20.3652 17.1144 20.4332 17.1414 20.4917 17.1168L20.5049 17.1113C20.5635 17.0868 20.5912 17.0211 20.566 16.9641L20.4678 16.7383L20.3935 16.769C20.4628 16.7383 20.5301 16.704 20.5956 16.6672L20.7266 16.8678C20.7606 16.9199 20.8323 16.9359 20.8859 16.9021L20.8978 16.8948C20.9513 16.8616 20.9677 16.7917 20.9331 16.7396L20.8002 16.5365C20.8519 16.5003 20.9022 16.4617 20.9501 16.4218L21.1157 16.5948C21.1591 16.6402 21.2322 16.6426 21.2788 16.6003L21.2888 16.5911C21.3354 16.5488 21.3379 16.4776 21.2945 16.4322L21.127 16.2574C21.1635 16.2194 21.1988 16.1807 21.2328 16.1402L21.4305 16.285C21.4815 16.3224 21.5539 16.3126 21.5923 16.2629L21.6005 16.2519C21.6389 16.2022 21.6282 16.1316 21.5778 16.0942L21.3795 15.9488C21.4097 15.9046 21.4381 15.8593 21.4651 15.8132L21.688 15.9249C21.7447 15.9531 21.8146 15.9316 21.8435 15.8764L21.8498 15.8642C21.8788 15.8089 21.8568 15.7409 21.8001 15.7126L21.5759 15.6004L21.5678 15.6157C21.5929 15.5611 21.6156 15.5059 21.6364 15.4495L21.6351 15.4544L21.8756 15.5274C21.9367 15.5458 22.0009 15.5126 22.0205 15.4531L22.0249 15.4403C22.0438 15.3808 22.0098 15.3176 21.9487 15.2992L21.7082 15.2262L21.6912 15.2789C21.7163 15.1887 21.7359 15.0967 21.7491 15.0029L21.7409 15.0648L21.9909 15.0955C22.0538 15.1035 22.1118 15.0593 22.1199 14.998L22.1218 14.9845C22.13 14.9231 22.0847 14.8667 22.0217 14.8587L22.0205 14.8556ZM17.9058 15.0703C17.6823 15.0703 17.501 14.8937 17.501 14.6759C17.501 14.4581 17.6823 14.2814 17.9058 14.2814C18.1294 14.2814 18.3107 14.4581 18.3107 14.6759C18.3107 14.8937 18.1294 15.0703 17.9058 15.0703ZM19.3855 12.8398C19.609 12.8398 19.7903 13.0165 19.7903 13.2343C19.7903 13.452 19.609 13.6287 19.3855 13.6287C19.162 13.6287 18.9806 13.452 18.9806 13.2343C18.9806 13.0165 19.162 12.8398 19.3855 12.8398ZM19.3855 16.512C19.162 16.512 18.9806 16.3353 18.9806 16.1175C18.9806 15.8997 19.162 15.7231 19.3855 15.7231C19.609 15.7231 19.7903 15.8997 19.7903 16.1175C19.7903 16.3353 19.609 16.512 19.3855 16.512ZM19.4258 15.3145C19.0644 15.3145 18.7716 15.0292 18.7716 14.6771C18.7716 14.325 19.0644 14.0397 19.4258 14.0397C19.7872 14.0397 20.0799 14.325 20.0799 14.6771C20.0799 15.0292 19.7872 15.3145 19.4258 15.3145ZM20.8645 15.0703C20.6409 15.0703 20.4596 14.8937 20.4596 14.6759C20.4596 14.4581 20.6409 14.2814 20.8645 14.2814C21.088 14.2814 21.2693 14.4581 21.2693 14.6759C21.2693 14.8937 21.088 15.0703 20.8645 15.0703Z",
    fill: "url(#paint94_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2056 15.3511C22.2056 15.5253 22.3416 15.6664 22.5153 15.6842V15.0186C22.3416 15.0357 22.2056 15.1774 22.2056 15.3517V15.3511Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8962 15.3507C22.8962 15.1765 22.7602 15.0354 22.5864 15.0176V15.6832C22.7602 15.666 22.8962 15.5243 22.8962 15.3501V15.3507Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8032 17.6475C17.8032 17.7917 17.9159 17.9088 18.0595 17.923V17.3721C17.9153 17.3862 17.8032 17.5034 17.8032 17.6475Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3742 17.6475C18.3742 17.5034 18.2615 17.3862 18.1179 17.3721V17.923C18.2621 17.9088 18.3742 17.7917 18.3742 17.6475Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9177 12.4041C26.9177 12.5587 27.0386 12.6838 27.1929 12.6992V12.1084C27.0386 12.1237 26.9177 12.2495 26.9177 12.4035V12.4041Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5298 12.4044C27.5298 12.2499 27.4089 12.1247 27.2546 12.1094V12.7001C27.4089 12.6848 27.5298 12.559 27.5298 12.4051V12.4044Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0959 18.0828C23.0959 18.2374 23.2168 18.3625 23.3711 18.3779V17.7871C23.2168 17.8024 23.0959 17.9282 23.0959 18.0822V18.0828Z",
    fill: "url(#paint95_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7085 18.0832C23.7085 17.9286 23.5876 17.8034 23.4333 17.7881V18.3788C23.5876 18.3635 23.7085 18.2378 23.7085 18.0838V18.0832Z",
    fill: "url(#paint96_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4243 19.2322C21.4243 19.3868 21.5452 19.5119 21.6995 19.5273V18.9365C21.5452 18.9519 21.4243 19.0776 21.4243 19.2316V19.2322Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0364 19.2326C22.0364 19.078 21.9155 18.9528 21.7612 18.9375V19.5283C21.9155 19.5129 22.0364 19.3872 22.0364 19.2332V19.2326Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.95838 13.6839C8.07046 13.7931 8.24675 13.7986 8.36701 13.7029L7.93823 13.2852C7.84064 13.4023 7.84631 13.5741 7.95838 13.6833V13.6839Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.39154 13.2625C8.27946 13.1533 8.10317 13.1478 7.98291 13.2429L8.41169 13.6606C8.50928 13.5435 8.50361 13.3717 8.39154 13.2625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.51099 17.8094C6.51099 17.964 6.63187 18.0891 6.78613 18.1044V17.5137C6.63187 17.529 6.51099 17.6548 6.51099 17.8087V17.8094Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.12354 17.8097C7.12354 17.6551 7.00265 17.53 6.84839 17.5146V18.1054C7.00265 18.0901 7.12354 17.9643 7.12354 17.8103V17.8097Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.33423 20.2849C8.33423 20.4395 8.45512 20.5647 8.60938 20.58V19.9893C8.45512 20.0046 8.33423 20.1304 8.33423 20.2843V20.2849Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.94629 20.2853C8.94629 20.1307 8.8254 20.0056 8.67114 19.9902V20.581C8.8254 20.5657 8.94629 20.4399 8.94629 20.2859V20.2853Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5825 21.1306C15.6939 21.2398 15.8708 21.2459 15.9911 21.1508L15.5636 20.7324C15.4653 20.8496 15.4704 21.0214 15.5825 21.1306Z",
    fill: "url(#paint97_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0163 20.7101C15.9049 20.6009 15.7279 20.5948 15.6077 20.6899L16.0352 21.1082C16.1334 20.9911 16.1284 20.8193 16.0163 20.7101Z",
    fill: "url(#paint98_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7693 25.4646C13.7693 25.6192 13.8902 25.7444 14.0444 25.7597V25.1689C13.8902 25.1843 13.7693 25.31 13.7693 25.464V25.4646Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3818 25.465C14.3818 25.3104 14.2609 25.1853 14.1067 25.1699V25.7607C14.2609 25.7453 14.3818 25.6196 14.3818 25.4656V25.465Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5266 24.8184C10.4126 24.9258 10.4038 25.0975 10.4995 25.2159L10.9358 24.8062C10.8175 24.7086 10.6405 24.7111 10.5266 24.8184Z",
    fill: "url(#paint99_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9515 25.2481C11.0655 25.1408 11.0743 24.969 10.9786 24.8506L10.5422 25.2604C10.6606 25.3579 10.8375 25.3555 10.9515 25.2481Z",
    fill: "url(#paint100_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1333 23.0408C26.1333 23.1954 26.2542 23.3205 26.4084 23.3359V22.7451C26.2542 22.7605 26.1333 22.8862 26.1333 23.0402V23.0408Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7458 23.0412C26.7458 22.8866 26.625 22.7614 26.4707 22.7461V23.3369C26.625 23.3215 26.7458 23.1958 26.7458 23.0418V23.0412Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8035 31.2634C15.9149 31.3732 16.0912 31.3793 16.2121 31.2848L15.7858 30.8652C15.6876 30.9818 15.692 31.1536 15.8035 31.2634Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2385 30.8436C16.127 30.7337 15.9507 30.7276 15.8298 30.8221L16.2561 31.2417C16.3543 31.1251 16.3499 30.9534 16.2385 30.8436Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.29321 33.5271C9.29321 33.6817 9.4141 33.8069 9.56836 33.8222V33.2314C9.4141 33.2468 9.29321 33.3725 9.29321 33.5265V33.5271Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.90576 33.5275C9.90576 33.3729 9.78487 33.2478 9.63062 33.2324V33.8232C9.78487 33.8078 9.90576 33.6821 9.90576 33.5281V33.5275Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7484 45.667C18.5897 45.667 18.4613 45.7848 18.4456 45.9351H19.0519C19.0361 45.7848 18.9071 45.667 18.749 45.667H18.7484Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7483 46.2642C18.907 46.2642 19.0354 46.1464 19.0512 45.9961H18.4448C18.4606 46.1464 18.5896 46.2642 18.7477 46.2642H18.7483Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6683 50.7705C15.5097 50.7705 15.3812 50.8883 15.3655 51.0386H15.9718C15.9561 50.8883 15.827 50.7705 15.669 50.7705H15.6683Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6682 51.3667C15.8269 51.3667 15.9553 51.2489 15.9711 51.0986H15.3647C15.3805 51.2489 15.5096 51.3667 15.6676 51.3667H15.6682Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.97326 51.0586C9.81459 51.0586 9.68615 51.1764 9.67041 51.3267H10.2767C10.261 51.1764 10.1319 51.0586 9.97389 51.0586H9.97326Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.97316 51.6548C10.1318 51.6548 10.2603 51.537 10.276 51.3867H9.66968C9.68542 51.537 9.81449 51.6548 9.97253 51.6548H9.97316Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.20209 49.9245C7.31353 50.0337 7.49045 50.0398 7.61071 49.9447L7.1832 49.5264C7.08498 49.6435 7.09001 49.8153 7.20209 49.9245Z",
    fill: "url(#paint101_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.63641 49.504C7.52497 49.3948 7.34804 49.3887 7.22778 49.4838L7.6553 49.9022C7.75352 49.785 7.74848 49.6132 7.63641 49.504Z",
    fill: "url(#paint102_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.90822 47.0215C6.74955 47.0215 6.62048 47.1387 6.60474 47.2883L7.21107 47.2902C7.19533 47.1399 7.06688 47.0221 6.90885 47.0215H6.90822Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.90685 47.6183C7.06552 47.6183 7.19459 47.5011 7.21033 47.3515L6.604 47.3496C6.61974 47.4999 6.74819 47.6177 6.90623 47.6183H6.90685Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.17028 42.2305C3.01162 42.2305 2.88317 42.3483 2.86743 42.4986H3.47376C3.45802 42.3483 3.32895 42.2305 3.17091 42.2305H3.17028Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.17018 42.8277C3.32885 42.8277 3.45729 42.7099 3.47303 42.5596H2.8667C2.88244 42.7099 3.01151 42.8277 3.16955 42.8277H3.17018Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1386 12.8212C23.8836 12.7697 23.6336 12.9292 23.5807 13.1776C23.5278 13.4261 23.6915 13.6696 23.9465 13.7211C24.2015 13.7727 24.4515 13.6132 24.5044 13.3647C24.5573 13.1163 24.3936 12.8727 24.1386 12.8212ZM24.1147 12.8942C24.2418 12.92 24.3413 13.0034 24.3917 13.1101L24.194 13.1733C24.1682 13.1353 24.1279 13.1071 24.0788 13.0973C24.0303 13.0874 23.9824 13.0973 23.944 13.1218L23.7791 12.9782C23.8685 12.904 23.9906 12.869 24.114 12.8942H24.1147ZM24.024 13.3567C23.9755 13.3469 23.944 13.3003 23.9541 13.2531C23.9642 13.2058 24.012 13.1752 24.0605 13.185C24.109 13.1948 24.1405 13.2414 24.1304 13.2887C24.1203 13.3359 24.0725 13.3666 24.024 13.3567ZM23.65 13.1917C23.6607 13.1402 23.6821 13.0936 23.7111 13.0525L23.8779 13.1972C23.8722 13.2089 23.8678 13.2218 23.8647 13.2347C23.8477 13.3132 23.888 13.3899 23.9572 13.4261L23.9132 13.6328C23.7249 13.5733 23.6091 13.3837 23.6506 13.1905L23.65 13.1917ZM24.42 13.3475C24.3797 13.5353 24.2047 13.6616 24.0139 13.6518L24.0574 13.4469C24.1354 13.4408 24.2041 13.3856 24.2204 13.3071C24.2229 13.2942 24.2242 13.2819 24.2242 13.269L24.4219 13.2052C24.4301 13.2512 24.4295 13.2991 24.4194 13.3469L24.42 13.3475Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.38418 13.3905C7.12918 13.339 6.87922 13.4985 6.82633 13.747C6.77344 13.9954 6.93715 14.2389 7.19215 14.2905C7.44715 14.342 7.69711 14.1825 7.75 13.9341C7.80288 13.6856 7.63918 13.4421 7.38418 13.3905ZM7.36026 13.4635C7.48744 13.4893 7.58692 13.5727 7.63729 13.6795L7.43959 13.7427C7.41378 13.7046 7.37348 13.6764 7.32437 13.6666C7.27589 13.6568 7.22804 13.6666 7.18963 13.6911L7.02467 13.5476C7.11407 13.4733 7.23622 13.4384 7.35963 13.4635H7.36026ZM7.26959 13.9261C7.22111 13.9163 7.18963 13.8696 7.1997 13.8224C7.20978 13.7752 7.25763 13.7445 7.30611 13.7543C7.35459 13.7641 7.38607 13.8108 7.376 13.858C7.36592 13.9052 7.31807 13.9359 7.26959 13.9261ZM6.89559 13.7604C6.9063 13.7089 6.9277 13.6623 6.95667 13.6212L7.12352 13.766C7.11785 13.7776 7.11344 13.7905 7.1103 13.8034C7.0933 13.8819 7.13359 13.9586 7.20285 13.9948L7.15878 14.2015C6.97052 14.142 6.85467 13.9525 6.89622 13.7592L6.89559 13.7604ZM7.66563 13.9169C7.62533 14.1046 7.45029 14.231 7.25952 14.2212L7.30296 14.0163C7.38103 14.0101 7.44966 13.9549 7.46603 13.8764C7.46855 13.8635 7.46981 13.8512 7.46981 13.8384L7.66751 13.7746C7.6757 13.8206 7.67507 13.8684 7.665 13.9163L7.66563 13.9169Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7979 45.5659C15.4019 45.4855 15.014 45.7334 14.9315 46.1192C14.8491 46.5051 15.1034 46.883 15.4995 46.9634C15.8955 47.0437 16.2834 46.7959 16.3658 46.41C16.4483 46.0242 16.1939 45.6463 15.7979 45.5659ZM15.7614 45.6794C15.9591 45.7193 16.1134 45.8487 16.1914 46.0143L15.8848 46.1131C15.8451 46.0542 15.7828 46.0101 15.7066 45.9947C15.6317 45.9794 15.5574 45.9947 15.4969 46.0328L15.2407 45.8101C15.3792 45.6947 15.5687 45.6407 15.7614 45.6794ZM15.6204 46.3978C15.5448 46.3824 15.4963 46.31 15.5121 46.2364C15.5278 46.1628 15.6021 46.1156 15.6777 46.1309C15.7532 46.1462 15.8017 46.2186 15.7859 46.2922C15.7702 46.3659 15.6959 46.4131 15.6204 46.3978ZM15.0392 46.1407C15.0562 46.061 15.0889 45.988 15.1337 45.9248L15.3924 46.1499C15.3836 46.1683 15.3767 46.188 15.3723 46.2082C15.3465 46.3303 15.4082 46.4499 15.5158 46.5057L15.4472 46.8272C15.1551 46.7346 14.975 46.4407 15.0392 46.1407ZM16.2349 46.383C16.1725 46.675 15.9005 46.8713 15.604 46.8554L15.672 46.5376C15.7935 46.5278 15.8993 46.4425 15.9257 46.3205C15.9301 46.3008 15.9314 46.2812 15.9314 46.2616L16.2386 46.1628C16.2512 46.234 16.2506 46.3082 16.2349 46.383Z",
    fill: "url(#paint103_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.8048 23.3418C27.0272 23.3418 26.395 23.9583 26.395 24.7153C26.395 25.4723 27.0278 26.0889 27.8048 26.0889C28.5817 26.0889 29.2145 25.4723 29.2145 24.7153C29.2145 23.9583 28.5817 23.3418 27.8048 23.3418ZM27.8048 25.8834C27.2142 25.8834 26.7231 25.465 26.6248 24.9166C26.6462 24.9233 26.6689 24.9276 26.6922 24.9276C27.1537 24.9276 27.6152 24.9276 28.0768 24.9276H28.0969C28.0969 24.9276 28.0988 24.9307 28.1 24.9325C28.0938 24.938 28.0862 24.9423 28.0805 24.9485C27.9867 25.0399 27.8923 25.1313 27.7991 25.2227C27.738 25.2828 27.7204 25.3699 27.7506 25.4417C27.7878 25.5294 27.8702 25.5779 27.9546 25.5785C28.0157 25.5785 28.0686 25.5552 28.112 25.5128C28.3261 25.3043 28.5402 25.0963 28.7536 24.8877C28.7719 24.8699 28.7908 24.8515 28.8052 24.8307C28.8625 24.7472 28.8518 24.6405 28.7832 24.5749C28.6667 24.4626 28.5509 24.3491 28.4344 24.2362C28.3255 24.1301 28.2165 24.0234 28.107 23.9172C28.0377 23.8504 27.9452 23.8338 27.8627 23.8749C27.789 23.9123 27.7437 23.9712 27.7368 24.054C27.7317 24.1166 27.7556 24.1694 27.8003 24.2129C27.8929 24.3043 27.9861 24.3945 28.0793 24.4853C28.0856 24.4914 28.0919 24.4982 28.1 24.5061C28.0944 24.5061 28.0931 24.5061 28.0912 24.5061C27.6266 24.5061 27.1613 24.5061 26.6966 24.5061C26.6796 24.5061 26.6626 24.5068 26.6456 24.5104C26.6381 24.5117 26.6311 24.5147 26.6242 24.5166C26.7212 23.9669 27.2129 23.5467 27.8048 23.5467C28.4659 23.5467 29.0036 24.0706 29.0036 24.7147C29.0036 25.3589 28.4659 25.8828 27.8048 25.8828V25.8834Z",
    fill: "url(#paint104_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0164 18.7451C16.794 18.7451 17.4262 18.1286 17.4262 17.3716C17.4262 16.6146 16.7934 15.998 16.0164 15.998C15.2395 15.998 14.6067 16.6146 14.6067 17.3716C14.6067 18.1286 15.2395 18.7451 16.0164 18.7451ZM16.0164 16.2036C16.607 16.2036 17.0981 16.6219 17.1963 17.1704C17.1749 17.1636 17.1523 17.1593 17.129 17.1593C16.6675 17.1593 16.2059 17.1593 15.7444 17.1593H15.7243C15.7243 17.1593 15.7224 17.1563 15.7211 17.1544C15.7274 17.1489 15.735 17.1446 15.7406 17.1385C15.8345 17.0471 15.9289 16.9557 16.0221 16.8643C16.0832 16.8041 16.1008 16.717 16.0706 16.6452C16.0334 16.5575 15.9509 16.5091 15.8666 16.5084C15.8055 16.5084 15.7526 16.5318 15.7092 16.5741C15.4951 16.7827 15.281 16.9906 15.0676 17.1992C15.0493 17.217 15.0304 17.2354 15.0159 17.2563C14.9587 17.3397 14.9694 17.4464 15.038 17.5121C15.1545 17.6243 15.2703 17.7378 15.3868 17.8507C15.4957 17.9568 15.6046 18.0636 15.7142 18.1697C15.7835 18.2366 15.876 18.2531 15.9585 18.212C16.0322 18.1746 16.0775 18.1157 16.0844 18.0329C16.0895 17.9703 16.0655 17.9176 16.0208 17.874C15.9283 17.7826 15.8351 17.6924 15.7419 17.6016C15.7356 17.5955 15.7293 17.5888 15.7211 17.5808C15.7268 17.5808 15.7281 17.5808 15.7299 17.5808C16.1946 17.5808 16.6599 17.5808 17.1246 17.5808C17.1416 17.5808 17.1586 17.5802 17.1756 17.5765C17.1831 17.5753 17.19 17.5722 17.197 17.5703C17.1 18.12 16.6083 18.5402 16.0164 18.5402C15.3553 18.5402 14.8176 18.0163 14.8176 17.3722C14.8176 16.7281 15.3553 16.2042 16.0164 16.2042V16.2036Z",
    fill: "url(#paint105_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.52057 13.9512C7.94132 13.9512 7.46973 14.4107 7.46973 14.975C7.46973 15.5394 7.94132 15.9989 8.52057 15.9989C9.09983 15.9989 9.57142 15.5394 9.57142 14.975C9.57142 14.4107 9.09983 13.9512 8.52057 13.9512ZM8.52057 15.8455C8.08046 15.8455 7.71465 15.5339 7.64161 15.1253C7.65736 15.1302 7.67436 15.1333 7.69198 15.1333C8.03576 15.1333 8.37954 15.1333 8.72331 15.1333H8.73842C8.73842 15.1333 8.74031 15.1358 8.74094 15.137C8.73591 15.1407 8.73087 15.1444 8.72646 15.1486C8.65657 15.2167 8.58606 15.2848 8.5168 15.3529C8.47146 15.3977 8.45824 15.4627 8.48091 15.5161C8.50861 15.5818 8.56968 15.6173 8.63265 15.6179C8.67798 15.6179 8.71765 15.6002 8.74976 15.5689C8.90905 15.4137 9.06835 15.2585 9.22764 15.1026C9.2415 15.0891 9.25535 15.0756 9.26605 15.0597C9.30824 14.9977 9.30068 14.918 9.24968 14.8689C9.16279 14.7849 9.07653 14.7008 8.99027 14.6168C8.90905 14.5376 8.82783 14.4579 8.74598 14.3794C8.69435 14.3297 8.62509 14.3174 8.56402 14.3481C8.50861 14.3757 8.47524 14.4199 8.4702 14.4818C8.46643 14.5284 8.48468 14.5677 8.51743 14.6002C8.58605 14.6683 8.65594 14.7352 8.7252 14.8033C8.73024 14.8082 8.73465 14.8131 8.74094 14.8192C8.73717 14.8192 8.73591 14.8192 8.73465 14.8192C8.38835 14.8192 8.04206 14.8192 7.69513 14.8192C7.68254 14.8192 7.66932 14.8198 7.65736 14.8223C7.65169 14.8235 7.64665 14.8254 7.64099 14.8272C7.71339 14.4174 8.07984 14.1045 8.52057 14.1045C9.01294 14.1045 9.41401 14.4947 9.41401 14.975C9.41401 15.4554 9.01357 15.8455 8.52057 15.8455Z",
    fill: "url(#paint106_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.458 33.1316C14.4618 33.5089 14.7792 33.8131 15.1664 33.8095C15.5536 33.8058 15.8659 33.4966 15.8621 33.1193C15.8583 32.742 15.541 32.4378 15.1538 32.4414C14.7666 32.4451 14.4543 32.7543 14.458 33.1316ZM15.757 33.1199C15.7595 33.4064 15.5479 33.6463 15.2684 33.6966C15.2715 33.6862 15.274 33.6751 15.2734 33.6641C15.2715 33.4402 15.269 33.2162 15.2671 32.9923V32.9825C15.2671 32.9825 15.269 32.9813 15.2696 32.9807C15.2721 32.9837 15.2747 32.9874 15.2778 32.9899C15.325 33.0353 15.3716 33.0801 15.4195 33.1254C15.4503 33.1549 15.495 33.1629 15.5316 33.1481C15.5763 33.1297 15.6002 33.0893 15.6002 33.0488C15.6002 33.0193 15.5876 32.9936 15.5656 32.9727C15.4579 32.8696 15.3509 32.7672 15.2432 32.6641C15.2337 32.6555 15.2243 32.6463 15.2136 32.6396C15.1708 32.6126 15.116 32.6181 15.0826 32.6512C15.026 32.7083 14.9687 32.7647 14.9114 32.8218C14.8572 32.8752 14.8037 32.9285 14.7496 32.9819C14.7156 33.0156 14.7074 33.061 14.7294 33.1003C14.7489 33.1359 14.7792 33.158 14.8213 33.1604C14.8534 33.1623 14.8799 33.1506 14.9026 33.1291C14.9485 33.0837 14.9945 33.0383 15.0404 32.9923C15.0436 32.9893 15.0467 32.9862 15.0512 32.9819C15.0512 32.9844 15.0512 32.9856 15.0512 32.9862C15.053 33.2119 15.0556 33.4371 15.0574 33.6628C15.0574 33.6708 15.0574 33.6794 15.06 33.6874C15.0606 33.6911 15.0619 33.6941 15.0631 33.6978C14.7817 33.653 14.5651 33.4168 14.5626 33.1297C14.5594 32.8089 14.8251 32.5457 15.1544 32.5427C15.4837 32.5396 15.7538 32.7985 15.757 33.1193V33.1199Z",
    fill: "url(#paint107_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6775 50.0664C16.6762 50.5719 17.0968 50.9835 17.6156 50.9854C18.1344 50.9866 18.5569 50.5768 18.5588 50.0713C18.5601 49.5658 18.1395 49.1542 17.6207 49.1523C17.1019 49.1505 16.6794 49.5609 16.6775 50.0664ZM18.4178 50.0713C18.4165 50.4553 18.1294 50.7731 17.7542 50.8363C17.7586 50.8222 17.7617 50.8081 17.7617 50.7927C17.7623 50.4928 17.7636 50.1928 17.7642 49.8928V49.8799C17.7642 49.8799 17.7667 49.8787 17.7674 49.8781C17.7712 49.8824 17.7743 49.8873 17.7781 49.891C17.8404 49.9523 17.9027 50.0137 17.9657 50.0744C18.0066 50.1143 18.0664 50.1259 18.1156 50.1063C18.176 50.0824 18.2087 50.029 18.2094 49.9738C18.2094 49.9339 18.1936 49.8995 18.1647 49.8713C18.0224 49.7321 17.8801 49.5922 17.7378 49.4536C17.7258 49.4413 17.7132 49.429 17.6987 49.4198C17.6421 49.3824 17.5684 49.3891 17.5231 49.4333C17.4456 49.5088 17.3682 49.5842 17.2907 49.6591C17.2177 49.7296 17.1447 49.8002 17.0716 49.8713C17.0257 49.9161 17.0143 49.9762 17.0427 50.0302C17.0679 50.0781 17.1082 50.1081 17.1648 50.1124C17.2076 50.1155 17.2435 50.1001 17.2737 50.0713C17.3361 50.0112 17.3984 49.9511 17.4607 49.8903C17.4652 49.8861 17.4696 49.8818 17.4752 49.8768C17.4752 49.8805 17.4752 49.8818 17.4752 49.8824C17.4746 50.1842 17.4733 50.4866 17.4727 50.7885C17.4727 50.7995 17.4727 50.8105 17.4752 50.8216C17.4765 50.8265 17.4777 50.8308 17.4796 50.8357C17.1037 50.7719 16.8166 50.4517 16.8179 50.067C16.8192 49.6376 17.1787 49.2885 17.6194 49.2898C18.0602 49.291 18.4184 49.6413 18.4172 50.0707L18.4178 50.0713Z",
    fill: "url(#paint108_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5916 26.9355H26.4858V27.1006H26.5916V26.9355Z",
    fill: "url(#paint109_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5916 26.6396H26.4858V26.8047H26.5916V26.6396Z",
    fill: "url(#paint110_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5916 26.3447H26.4858V26.5097H26.5916V26.3447Z",
    fill: "url(#paint111_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5916 27.8252H26.4858V27.9902H26.5916V27.8252Z",
    fill: "url(#paint112_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5916 27.5283H26.4858V27.6933H26.5916V27.5283Z",
    fill: "url(#paint113_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5916 27.2334H26.4858V27.3984H26.5916V27.2334Z",
    fill: "url(#paint114_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5916 28.7148H26.4858V28.8799H26.5916V28.7148Z",
    fill: "url(#paint115_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5916 28.418H26.4858V28.583H26.5916V28.418Z",
    fill: "url(#paint116_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5916 28.123H26.4858V28.2881H26.5916V28.123Z",
    fill: "url(#paint117_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5916 29.6045H26.4858V29.7695H26.5916V29.6045Z",
    fill: "url(#paint118_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5916 29.3076H26.4858V29.4726H26.5916V29.3076Z",
    fill: "url(#paint119_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5916 29.0127H26.4858V29.1777H26.5916V29.0127Z",
    fill: "url(#paint120_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5916 30.1973H26.4858V30.3623H26.5916V30.1973Z",
    fill: "url(#paint121_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5916 29.9023H26.4858V30.0674H26.5916V29.9023Z",
    fill: "url(#paint122_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.591 30.6582V30.4932H26.4858V30.6582H26.0281L26.5381 31.5219L27.0487 30.6582H26.591Z",
    fill: "url(#paint123_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8898 31.7212L16.7205 31.7227L16.7214 31.8257L16.8908 31.8242L16.8898 31.7212Z",
    fill: "url(#paint124_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5849 31.7232L16.4155 31.7246L16.4165 31.8277L16.5858 31.8262L16.5849 31.7232Z",
    fill: "url(#paint125_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2824 31.7251L16.113 31.7266L16.114 31.8296L16.2834 31.8281L16.2824 31.7251Z",
    fill: "url(#paint126_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8027 31.7124L17.6333 31.7139L17.6343 31.8169L17.8036 31.8154L17.8027 31.7124Z",
    fill: "url(#paint127_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4982 31.7154L17.3289 31.7168L17.3298 31.8199L17.4991 31.8184L17.4982 31.7154Z",
    fill: "url(#paint128_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.196 31.7173L17.0266 31.7188L17.0276 31.8218L17.1969 31.8203L17.196 31.7173Z",
    fill: "url(#paint129_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.715 31.7046L18.5457 31.7061L18.5466 31.8091L18.716 31.8076L18.715 31.7046Z",
    fill: "url(#paint130_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4111 31.7075L18.2417 31.709L18.2426 31.812L18.412 31.8106L18.4111 31.7075Z",
    fill: "url(#paint131_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1088 31.7094L17.9395 31.7109L17.9404 31.814L18.1098 31.8125L18.1088 31.7094Z",
    fill: "url(#paint132_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6279 31.6967L19.4585 31.6982L19.4595 31.8013L19.6288 31.7998L19.6279 31.6967Z",
    fill: "url(#paint133_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3239 31.6997L19.1545 31.7012L19.1555 31.8042L19.3248 31.8028L19.3239 31.6997Z",
    fill: "url(#paint134_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0217 31.7016L18.8523 31.7031L18.8533 31.8062L19.0226 31.8047L19.0217 31.7016Z",
    fill: "url(#paint135_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2363 31.6919L20.0669 31.6934L20.0678 31.7964L20.2372 31.795L20.2363 31.6919Z",
    fill: "url(#paint136_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9333 31.6939L19.7639 31.6953L19.7648 31.7984L19.9342 31.7969L19.9333 31.6939Z",
    fill: "url(#paint137_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.4286 31.7317L20.5377 31.2422L20.5414 31.6882L20.3721 31.6894L20.3733 31.7925L20.5427 31.7906L20.5421 31.7403L20.5465 32.2366L21.4286 31.7317Z",
    fill: "url(#paint138_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5998 30.5117H16.5249V30.6295H16.5998V30.5117Z",
    fill: "url(#paint139_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5998 30.3008H16.5249V30.4186H16.5998V30.3008Z",
    fill: "url(#paint140_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5998 30.0908H16.5249V30.2086H16.5998V30.0908Z",
    fill: "url(#paint141_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5998 31.1445H16.5249V31.2623H16.5998V31.1445Z",
    fill: "url(#paint142_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5998 30.9336H16.5249V31.0514H16.5998V30.9336Z",
    fill: "url(#paint143_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5998 30.7236H16.5249V30.8408H16.5998V30.7236Z",
    fill: "url(#paint144_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5998 31.7783H16.5249V31.8961H16.5998V31.7783Z",
    fill: "url(#paint145_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5998 31.5664H16.5249V31.6836H16.5998V31.5664Z",
    fill: "url(#paint146_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5998 31.3574H16.5249V31.4752H16.5998V31.3574Z",
    fill: "url(#paint147_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5998 32.4111H16.5249V32.5289H16.5998V32.4111Z",
    fill: "url(#paint148_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5998 32.2002H16.5249V32.318H16.5998V32.2002Z",
    fill: "url(#paint149_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5998 31.9902H16.5249V32.108H16.5998V31.9902Z",
    fill: "url(#paint150_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5998 32.833H16.5249V32.9508H16.5998V32.833Z",
    fill: "url(#paint151_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5998 32.623H16.5249V32.7408H16.5998V32.623Z",
    fill: "url(#paint152_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5999 33.1608V33.043H16.525V33.1608H16.1995L16.5621 33.7754L16.9261 33.1608H16.5999Z",
    fill: "url(#paint153_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4097 39.5167L19.304 39.5176L19.3054 39.6826L19.4112 39.6817L19.4097 39.5167Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4131 39.8125L19.3074 39.8135L19.3089 39.9785L19.4147 39.9776L19.4131 39.8125Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4158 40.1084L19.3101 40.1094L19.3116 40.2744L19.4174 40.2735L19.4158 40.1084Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4017 38.627L19.2959 38.6279L19.2974 38.7929L19.4031 38.792L19.4017 38.627Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4048 38.9229L19.2991 38.9238L19.3006 39.0888L19.4064 39.0879L19.4048 38.9229Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4075 39.2178L19.3018 39.2188L19.3033 39.3838L19.4091 39.3828L19.4075 39.2178Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3939 37.7374L19.2881 37.7383L19.2896 37.9033L19.3953 37.9024L19.3939 37.7374Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3965 38.0332L19.2908 38.0342L19.2923 38.1992L19.3981 38.1983L19.3965 38.0332Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4 38.3282L19.2942 38.3291L19.2957 38.4941L19.4015 38.4932L19.4 38.3282Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3858 36.8487L19.28 36.8496L19.2815 37.0146L19.3873 37.0137L19.3858 36.8487Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.389 37.1446L19.2832 37.1455L19.2847 37.3105L19.3905 37.3096L19.389 37.1446Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3912 37.4395L19.2854 37.4404L19.2869 37.6054L19.3927 37.6045L19.3912 37.4395Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.3805 36.1229L19.3786 35.9579L19.3257 35.9585L19.8363 35.9542L19.3181 35.0947L18.8157 35.9628L19.2734 35.9591L19.2747 36.1241L19.3805 36.1229Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3799 36.255L19.2742 36.2559L19.2756 36.4209L19.3814 36.42L19.3799 36.255Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3829 36.5508L19.2771 36.5518L19.2786 36.7168L19.3844 36.7158L19.3829 36.5508Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.59943 38.3184L5.49365 38.3193L5.49513 38.4844L5.6009 38.4835L5.59943 38.3184Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.6026 38.6153L5.49683 38.6162L5.49836 38.7812L5.60414 38.7803L5.6026 38.6153Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.60528 38.9102L5.49951 38.9111L5.50102 39.0761L5.60679 39.0752L5.60528 38.9102Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.59137 37.4298L5.4856 37.4307L5.48707 37.5957L5.59285 37.5948L5.59137 37.4298Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.5943 37.7256L5.48853 37.7266L5.49006 37.8916L5.59584 37.8906L5.5943 37.7256Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.59601 38.0206L5.49023 38.0215L5.49171 38.1865L5.59749 38.1856L5.59601 38.0206Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.58282 36.5411L5.47705 36.542L5.47853 36.707L5.5843 36.7061L5.58282 36.5411Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.586 36.837L5.48022 36.8379L5.48176 37.0029L5.58753 37.002L5.586 36.837Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.58868 37.1319L5.48291 37.1328L5.48445 37.2978L5.59022 37.2969L5.58868 37.1319Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.57501 35.6514L5.46924 35.6523L5.47072 35.8174L5.57649 35.8165L5.57501 35.6514Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.5777 35.9473L5.47192 35.9482L5.47346 36.1133L5.57923 36.1123L5.5777 35.9473Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.58038 36.2422L5.47461 36.2432L5.47615 36.4082L5.58192 36.4072L5.58038 36.2422Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.56903 34.9266L5.56777 34.7616H5.51425L6.02551 34.7573L5.50733 33.8984L5.00488 34.7665L5.46199 34.7622L5.46388 34.9272L5.56903 34.9266Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.57013 35.0577L5.46436 35.0586L5.46589 35.2236L5.57167 35.2227L5.57013 35.0577Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.57208 35.3526L5.46631 35.3535L5.46785 35.5185L5.57362 35.5176L5.57208 35.3526Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.61457 23.0498H3.50879V23.2148H3.61457V23.0498Z",
    fill: "url(#paint154_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.61457 22.7529H3.50879V22.918H3.61457V22.7529Z",
    fill: "url(#paint155_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.61457 22.458H3.50879V22.623H3.61457V22.458Z",
    fill: "url(#paint156_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.61457 23.9385H3.50879V24.1035H3.61457V23.9385Z",
    fill: "url(#paint157_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.61457 23.6426H3.50879V23.8076H3.61457V23.6426Z",
    fill: "url(#paint158_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.61457 23.3477H3.50879V23.5127H3.61457V23.3477Z",
    fill: "url(#paint159_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.61457 24.8281H3.50879V24.9931H3.61457V24.8281Z",
    fill: "url(#paint160_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.61457 24.5322H3.50879V24.6972H3.61457V24.5322Z",
    fill: "url(#paint161_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.61457 24.2363H3.50879V24.4014H3.61457V24.2363Z",
    fill: "url(#paint162_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.61457 25.7178H3.50879V25.8828H3.61457V25.7178Z",
    fill: "url(#paint163_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.61457 25.4209H3.50879V25.5859H3.61457V25.4209Z",
    fill: "url(#paint164_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.61457 25.126H3.50879V25.291H3.61457V25.126Z",
    fill: "url(#paint165_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.61457 26.3105H3.50879V26.4756H3.61457V26.3105Z",
    fill: "url(#paint166_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.61457 26.0156H3.50879V26.1806H3.61457V26.0156Z",
    fill: "url(#paint167_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.61464 26.7715V26.6064H3.50887V26.7715H3.05176L3.56176 27.6352L4.07238 26.7715H3.61464Z",
    fill: "url(#paint168_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.967 52.2798L13.9668 52.3516L14.0852 52.3519L14.0854 52.2801L13.967 52.2798Z",
    fill: "url(#paint169_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7533 52.2769L13.7532 52.3486L13.8715 52.3489L13.8717 52.2771L13.7533 52.2769Z",
    fill: "url(#paint170_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5422 52.2798L13.542 52.3516L13.6604 52.3519L13.6606 52.2801L13.5422 52.2798Z",
    fill: "url(#paint171_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6052 52.2817L14.605 52.3535L14.7233 52.3538L14.7235 52.282L14.6052 52.2817Z",
    fill: "url(#paint172_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3933 52.2808L14.3931 52.3525L14.5114 52.3528L14.5116 52.2811L14.3933 52.2808Z",
    fill: "url(#paint173_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1811 52.2808L14.1809 52.3525L14.2993 52.3528L14.2995 52.2811L14.1811 52.2808Z",
    fill: "url(#paint174_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2436 52.2837L15.2434 52.3555L15.3618 52.3558L15.362 52.284L15.2436 52.2837Z",
    fill: "url(#paint175_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0314 52.2837L15.0312 52.3555L15.1496 52.3558L15.1498 52.284L15.0314 52.2837Z",
    fill: "url(#paint176_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8193 52.2827L14.8191 52.3545L14.9375 52.3548L14.9377 52.283L14.8193 52.2827Z",
    fill: "url(#paint177_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8818 52.2847L15.8816 52.3564L16 52.3567L16.0002 52.285L15.8818 52.2847Z",
    fill: "url(#paint178_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6696 52.2847L15.6694 52.3564L15.7878 52.3567L15.788 52.285L15.6696 52.2847Z",
    fill: "url(#paint179_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4575 52.2837L15.4573 52.3555L15.5756 52.3558L15.5758 52.284L15.4575 52.2837Z",
    fill: "url(#paint180_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3078 52.2866L16.3076 52.3584L16.426 52.3587L16.4262 52.2869L16.3078 52.2866Z",
    fill: "url(#paint181_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0957 52.2856L16.0955 52.3574L16.2138 52.3577L16.214 52.2859L16.0957 52.2856Z",
    fill: "url(#paint182_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.2586 52.3243L16.6396 51.9746L16.639 52.2862H16.52V52.358L16.6384 52.3586V52.3224L16.6378 52.6703L17.2586 52.3243Z",
    fill: "url(#paint183_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2846 47.749H16.2109V47.8644H16.2846V47.749Z",
    fill: "url(#paint184_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2846 47.543H16.2109V47.6583H16.2846V47.543Z",
    fill: "url(#paint185_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2846 47.3359H16.2109V47.4513H16.2846V47.3359Z",
    fill: "url(#paint186_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2846 48.3711H16.2109V48.4864H16.2846V48.3711Z",
    fill: "url(#paint187_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2846 48.1641H16.2109V48.2794H16.2846V48.1641Z",
    fill: "url(#paint188_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2846 47.958H16.2109V48.0733H16.2846V47.958Z",
    fill: "url(#paint189_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2846 48.9932H16.2109V49.1085H16.2846V48.9932Z",
    fill: "url(#paint190_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2846 48.7861H16.2109V48.9015H16.2846V48.7861Z",
    fill: "url(#paint191_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2846 48.5801H16.2109V48.6954H16.2846V48.5801Z",
    fill: "url(#paint192_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2846 49.6152H16.2109V49.7306H16.2846V49.6152Z",
    fill: "url(#paint193_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2846 49.4082H16.2109V49.5235H16.2846V49.4082Z",
    fill: "url(#paint194_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2846 49.2021H16.2109V49.3175H16.2846V49.2021Z",
    fill: "url(#paint195_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2846 50.0303H16.2109V50.1456H16.2846V50.0303Z",
    fill: "url(#paint196_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2846 49.8232H16.2109V49.9386H16.2846V49.8232Z",
    fill: "url(#paint197_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2845 50.3532V50.2373H16.2109V50.3532H15.8904L16.2474 50.9569L16.6044 50.3532H16.2845Z",
    fill: "url(#paint198_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1032 46.5593L19.103 46.6084L19.1843 46.6086L19.1844 46.5595L19.1032 46.5593Z",
    fill: "url(#paint199_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2496 46.5603L19.2495 46.6094L19.3307 46.6096L19.3309 46.5605L19.2496 46.5603Z",
    fill: "url(#paint200_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3944 46.5593L19.3943 46.6084L19.4755 46.6086L19.4756 46.5595L19.3944 46.5593Z",
    fill: "url(#paint201_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6669 46.5583L18.6667 46.6074L18.748 46.6076L18.7481 46.5586L18.6669 46.5583Z",
    fill: "url(#paint202_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8121 46.5583L18.812 46.6074L18.8932 46.6076L18.8934 46.5586L18.8121 46.5583Z",
    fill: "url(#paint203_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9574 46.5583L18.9573 46.6074L19.0385 46.6076L19.0386 46.5586L18.9574 46.5583Z",
    fill: "url(#paint204_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2294 46.5564L18.2292 46.6055L18.3105 46.6057L18.3106 46.5566L18.2294 46.5564Z",
    fill: "url(#paint205_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.373 46.5535L18.3728 46.6025L18.454 46.6028L18.4542 46.5537L18.373 46.5535Z",
    fill: "url(#paint206_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5199 46.5574L18.5198 46.6064L18.601 46.6067L18.6011 46.5576L18.5199 46.5574Z",
    fill: "url(#paint207_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7919 46.5554L17.7917 46.6045L17.873 46.6047L17.8731 46.5556L17.7919 46.5554Z",
    fill: "url(#paint208_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9379 46.5564L17.9377 46.6055L18.019 46.6057L18.0191 46.5566L17.9379 46.5564Z",
    fill: "url(#paint209_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0824 46.5564L18.0823 46.6055L18.1635 46.6057L18.1636 46.5566L18.0824 46.5564Z",
    fill: "url(#paint210_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3544 46.5544L17.3542 46.6035L17.4355 46.6037L17.4356 46.5546L17.3544 46.5544Z",
    fill: "url(#paint211_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5004 46.5544L17.5002 46.6035L17.5815 46.6037L17.5816 46.5546L17.5004 46.5544Z",
    fill: "url(#paint212_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6449 46.5554L17.6448 46.6045L17.726 46.6047L17.7261 46.5556L17.6449 46.5554Z",
    fill: "url(#paint213_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9287 46.5747L17.3524 46.8146L17.3537 46.3379L16.9287 46.5747Z",
    fill: "url(#paint214_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9914 15.4902H13.9189V15.6037H13.9914V15.4902Z",
    fill: "url(#paint215_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9914 15.2871H13.9189V15.4006H13.9914V15.2871Z",
    fill: "url(#paint216_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9914 15.084H13.9189V15.1975H13.9914V15.084Z",
    fill: "url(#paint217_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9914 16.1025H13.9189V16.216H13.9914V16.1025Z",
    fill: "url(#paint218_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9914 15.8984H13.9189V16.0119H13.9914V15.8984Z",
    fill: "url(#paint219_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9914 15.6953H13.9189V15.8088H13.9914V15.6953Z",
    fill: "url(#paint220_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9914 16.7139H13.9189V16.8274H13.9914V16.7139Z",
    fill: "url(#paint221_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9914 16.5107H13.9189V16.6242H13.9914V16.5107Z",
    fill: "url(#paint222_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9914 16.3076H13.9189V16.4211H13.9914V16.3076Z",
    fill: "url(#paint223_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9914 17.3252H13.9189V17.4387H13.9914V17.3252Z",
    fill: "url(#paint224_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9914 17.1221H13.9189V17.2356H13.9914V17.1221Z",
    fill: "url(#paint225_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9914 16.9189H13.9189V17.0324H13.9914V16.9189Z",
    fill: "url(#paint226_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9914 17.7334H13.9189V17.8469H13.9914V17.7334Z",
    fill: "url(#paint227_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9914 17.5303H13.9189V17.6438H13.9914V17.5303Z",
    fill: "url(#paint228_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9915 18.051V17.9375H13.9191V18.051H13.6042L13.9549 18.6448L14.3057 18.051H13.9915Z",
    fill: "url(#paint229_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8225 15.6998L13.8223 15.7949L13.9784 15.7953L13.9787 15.7002L13.8225 15.6998Z",
    fill: "url(#paint230_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.103 15.7008L14.1028 15.7959L14.2589 15.7963L14.2592 15.7012L14.103 15.7008Z",
    fill: "url(#paint231_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3818 15.7008L14.3816 15.7959L14.5377 15.7963L14.538 15.7012L14.3818 15.7008Z",
    fill: "url(#paint232_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9814 15.6979L12.9812 15.793L13.1373 15.7933L13.1376 15.6983L12.9814 15.6979Z",
    fill: "url(#paint233_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2615 15.6979L13.2612 15.793L13.4174 15.7934L13.4176 15.6983L13.2615 15.6979Z",
    fill: "url(#paint234_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.541 15.6989L13.5408 15.7939L13.6969 15.7943L13.6972 15.6993L13.541 15.6989Z",
    fill: "url(#paint235_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1397 15.6959L12.1394 15.791L12.2956 15.7914L12.2958 15.6963L12.1397 15.6959Z",
    fill: "url(#paint236_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4199 15.6959L12.4197 15.791L12.5758 15.7914L12.5761 15.6963L12.4199 15.6959Z",
    fill: "url(#paint237_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.699 15.6969L12.6987 15.792L12.8549 15.7924L12.8551 15.6973L12.699 15.6969Z",
    fill: "url(#paint238_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2976 15.693L11.2974 15.7881L11.4535 15.7885L11.4538 15.6934L11.2976 15.693Z",
    fill: "url(#paint239_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5784 15.694L11.5781 15.7891L11.7343 15.7895L11.7345 15.6944L11.5784 15.694Z",
    fill: "url(#paint240_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8574 15.694L11.8572 15.7891L12.0133 15.7895L12.0136 15.6944L11.8574 15.694Z",
    fill: "url(#paint241_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7363 15.692L10.7361 15.7871L10.8922 15.7875L10.8925 15.6924L10.7363 15.692Z",
    fill: "url(#paint242_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0154 15.692L11.0151 15.7871L11.1713 15.7875L11.1715 15.6924L11.0154 15.692Z",
    fill: "url(#paint243_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4579 15.2803L9.6394 15.7367L10.4554 16.1974L10.456 15.7864L10.6122 15.787L10.6128 15.6919L10.4567 15.6913L10.4579 15.2803Z",
    fill: "url(#paint244_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.306628 44.588C0.306628 44.8322 0.18574 45.0487 0 45.1855V47.2468C0.00755552 47.2455 0.015111 47.2449 0.0226666 47.2437L0.0875181 47.524C0.103888 47.5952 0.176296 47.64 0.249332 47.624L0.265703 47.6204C0.338739 47.6044 0.384702 47.5339 0.368332 47.4621L0.30348 47.1805L0.271999 47.1873C0.355739 47.1646 0.437591 47.1376 0.518183 47.1075L0.494887 47.1173L0.610108 47.3829C0.639071 47.4504 0.719034 47.4817 0.787663 47.4529L0.802774 47.4467C0.872033 47.4185 0.904144 47.3406 0.874552 47.2737L0.75933 47.0081L0.672442 47.0437C0.753663 47.0075 0.832996 46.9676 0.909811 46.9241L1.06407 47.1596C1.10437 47.221 1.18811 47.2394 1.2517 47.2001L1.26555 47.1915C1.32851 47.1523 1.3474 47.0707 1.30711 47.0087L1.15159 46.7701C1.21203 46.7272 1.27122 46.6824 1.32788 46.6351L1.52244 46.8382C1.57344 46.8916 1.6597 46.8946 1.71447 46.8443L1.72644 46.8333C1.78121 46.7836 1.78436 46.6995 1.73273 46.6462L1.53566 46.4407C1.57847 46.3965 1.62003 46.3505 1.66033 46.3033L1.89266 46.4732C1.95247 46.5173 2.03747 46.5051 2.08281 46.4468L2.09288 46.4339C2.13758 46.3756 2.12562 46.2928 2.06581 46.2487L1.83221 46.0775C1.86747 46.026 1.90147 45.9726 1.93295 45.918L2.19488 46.0493C2.26162 46.0824 2.34347 46.0573 2.37747 45.9922L2.38503 45.9781C2.41903 45.9131 2.39321 45.8333 2.32647 45.8002L2.06329 45.6683L2.05384 45.6861C2.08344 45.6223 2.10988 45.5567 2.13444 45.4904L2.13255 45.4959L2.41525 45.5818C2.48703 45.6033 2.56258 45.5646 2.58525 45.4947L2.59029 45.4794C2.61232 45.4094 2.57266 45.3358 2.50088 45.3137L2.21818 45.2279L2.19866 45.2898C2.22825 45.1843 2.25092 45.0757 2.26729 44.9653L2.25784 45.0377L2.55125 45.0739C2.62554 45.0831 2.69354 45.0315 2.70299 44.9592L2.70488 44.9432C2.71432 44.8708 2.66143 44.8046 2.58714 44.7954L2.29373 44.7592L2.2761 44.8966C2.28555 44.8193 2.29184 44.7408 2.29436 44.661C2.29625 44.5886 2.29436 44.5175 2.29121 44.4469L2.29688 44.558L2.59217 44.5432C2.6671 44.5396 2.7244 44.477 2.72062 44.4046V44.3886C2.71558 44.3156 2.65199 44.2598 2.57706 44.2635L2.28177 44.2782L2.28743 44.3788C2.27988 44.2837 2.26729 44.1899 2.25029 44.0979L2.53173 44.0341C2.60477 44.0175 2.6501 43.9463 2.6331 43.8752L2.62932 43.8592C2.61232 43.7881 2.53929 43.7439 2.46625 43.7605L2.18355 43.8243C2.17095 43.7813 2.1571 43.739 2.14199 43.6973L2.41336 43.5918C2.48262 43.5648 2.51662 43.4875 2.48892 43.42L2.48262 43.4053C2.45492 43.3372 2.37558 43.3047 2.30632 43.3316L2.03307 43.4378C2.00347 43.377 1.97262 43.3169 1.93862 43.2586L2.18292 43.1102C2.24651 43.0715 2.26603 42.99 2.22636 42.928L2.21755 42.9145C2.17788 42.8525 2.09414 42.8335 2.03055 42.8722L1.78436 43.0218C1.7447 42.9673 1.70251 42.9151 1.65907 42.8636L1.87377 42.6728C1.92918 42.6237 1.93295 42.5403 1.88258 42.4863L1.87125 42.4746C1.82088 42.4207 1.73525 42.417 1.67984 42.4661L1.46451 42.6575C1.41477 42.6102 1.36377 42.5648 1.31088 42.5213L1.32788 42.5341L1.50922 42.3066C1.55518 42.2489 1.54447 42.1661 1.48529 42.1213L1.47207 42.1115C1.41288 42.0667 1.32788 42.0771 1.28192 42.1348L1.10059 42.3624L1.11948 42.3765C1.05148 42.3299 0.981588 42.2857 0.909181 42.2446L1.04329 41.99C1.07729 41.925 1.05085 41.8452 0.984737 41.8121L0.970255 41.8047C0.903515 41.7716 0.821663 41.7974 0.787663 41.8624L0.653553 42.1176C0.593109 42.0912 0.531405 42.0673 0.469072 42.0452L0.554701 41.7735C0.576738 41.7035 0.536442 41.6299 0.464665 41.6084L0.448924 41.6035C0.377147 41.5821 0.301591 41.6213 0.279554 41.6913L0.193925 41.9636C0.130962 41.9483 0.0667405 41.9354 0.00188888 41.9244V43.9893C0.187629 44.1261 0.308517 44.3426 0.308517 44.5868L0.306628 44.588ZM1.22777 44.1224C1.49033 44.1224 1.70377 44.3297 1.70377 44.5862C1.70377 44.8426 1.49096 45.05 1.22777 45.05C0.964589 45.05 0.751775 44.8426 0.751775 44.5862C0.751775 44.3297 0.964589 44.1224 1.22777 44.1224Z",
    fill: "url(#paint245_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.17819 50.3345C1.98946 50.5388 1.1955 51.6436 1.40516 52.8018C1.41712 52.8693 1.43287 52.9356 1.45112 53H1.79301C1.76531 52.9184 1.74264 52.8337 1.7269 52.746C1.68346 52.5061 1.69164 52.2693 1.7439 52.0454L2.71605 52.3902C2.7129 52.4503 2.71605 52.5123 2.72738 52.5742C2.7576 52.7411 2.83756 52.8865 2.94964 53H4.16608C4.34552 52.8172 4.43745 52.557 4.38896 52.289C4.37826 52.2295 4.36063 52.173 4.33859 52.1196L5.07904 51.5142C5.19363 51.6976 5.27674 51.9049 5.31703 52.1295C5.37181 52.4313 5.34474 52.7288 5.25155 53H5.66522C5.74959 52.7037 5.76911 52.3847 5.71118 52.062C5.50151 50.9038 4.36756 50.1302 3.17882 50.3345H3.17819ZM3.63026 52.8325C3.4036 52.8717 3.18701 52.7239 3.14671 52.5024C3.10641 52.281 3.25815 52.0706 3.48545 52.0313C3.71212 51.992 3.92871 52.1399 3.969 52.3614C4.0093 52.5822 3.85756 52.7932 3.63026 52.8325ZM4.04015 51.7577C3.86323 51.6375 3.63971 51.5829 3.41115 51.6221C3.18512 51.6608 2.99686 51.7841 2.87282 51.9522L1.90949 51.6105C2.16323 51.1418 2.6279 50.7878 3.20527 50.6884C3.79837 50.5866 4.37448 50.7768 4.77996 51.1522L4.04015 51.7571V51.7577Z",
    fill: "#42A100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.37975 52.808L7.02968 52.7546C7.03598 52.689 7.04102 52.6227 7.04353 52.5565L7.39801 52.5491C7.51198 52.5466 7.60264 52.4546 7.60012 52.3436C7.59761 52.2325 7.50316 52.1442 7.3892 52.1467L7.03409 52.154C7.03094 52.116 7.02716 52.0773 7.02213 52.0393L7.37157 51.9792C7.48364 51.9602 7.55857 51.8553 7.53905 51.7461C7.51953 51.6369 7.41187 51.5633 7.29979 51.5829L6.95035 51.643C6.93524 51.5811 6.91824 51.5197 6.89998 51.459L7.23368 51.3406C7.34072 51.3025 7.39613 51.1872 7.35709 51.0829C7.31805 50.9786 7.19968 50.9246 7.09265 50.9627L6.75957 51.0811C6.73376 51.0234 6.70668 50.9664 6.67835 50.9099L6.98498 50.7369C7.08383 50.6811 7.1172 50.5584 7.06053 50.4621C7.00324 50.3658 6.87731 50.3333 6.77846 50.3885L6.47183 50.5609C6.43594 50.5081 6.3988 50.4572 6.36039 50.4069L6.63176 50.1848C6.71928 50.113 6.73061 49.9867 6.65694 49.9014C6.58391 49.8161 6.45357 49.8051 6.36606 49.8769L6.09469 50.0989C6.04998 50.0535 6.00465 50.0087 5.95806 49.9652L6.18535 49.7008C6.25839 49.6155 6.24706 49.4885 6.15954 49.4174C6.07202 49.3462 5.94169 49.3573 5.86865 49.4425L5.64073 49.7069C5.5891 49.6695 5.53621 49.6333 5.48206 49.599L5.65898 49.3002C5.71565 49.2039 5.68228 49.0812 5.58343 49.0254C5.48458 48.9695 5.35865 49.0027 5.30136 49.099L5.12506 49.3965C5.06714 49.3683 5.00858 49.3419 4.94939 49.3168L5.07028 48.9935C5.10932 48.8892 5.05391 48.7739 4.94688 48.7358C4.83984 48.6978 4.72147 48.7518 4.68243 48.8561L4.56217 49.1787C4.50047 49.1609 4.43814 49.1438 4.37517 49.129L4.43625 48.7916C4.45577 48.6824 4.38084 48.5782 4.26877 48.5585C4.15669 48.5395 4.04966 48.6125 4.02951 48.7217L3.96844 49.0591C3.90421 49.0518 3.83999 49.0462 3.77514 49.0425V48.7002C3.77514 48.5892 3.68259 48.499 3.56862 48.499C3.45466 48.499 3.36211 48.5892 3.36211 48.7002V49.0425C3.30103 49.0462 3.23933 49.0511 3.17762 49.0579L3.11781 48.7205C3.09829 48.6113 2.99125 48.5377 2.87918 48.5567C2.76711 48.5757 2.69155 48.68 2.71107 48.7892L2.77089 49.1254C2.69722 49.1419 2.62544 49.1616 2.55366 49.1824L2.43152 48.8622C2.39185 48.7579 2.27285 48.7051 2.16581 48.7438C2.05878 48.7824 2.00463 48.8984 2.0443 49.0027L2.16581 49.3217C2.11041 49.3456 2.05563 49.3701 2.00211 49.3965L1.82707 49.1027C1.76978 49.0064 1.64322 48.9738 1.545 49.0297C1.44678 49.0855 1.41278 49.2088 1.47008 49.3045L1.64511 49.5983C1.58782 49.6352 1.53241 49.6738 1.47826 49.7137L1.25285 49.4548C1.17919 49.3701 1.04886 49.3597 0.961967 49.4315C0.875079 49.5033 0.864375 49.6302 0.938041 49.7149L1.16282 49.9738C1.1093 50.0235 1.0583 50.0744 1.00793 50.1271L0.73845 49.9124C0.650302 49.8419 0.519969 49.8548 0.447562 49.9407C0.375155 50.0265 0.388377 50.1535 0.476525 50.2241L0.746005 50.4388C0.708228 50.4891 0.672339 50.5406 0.637709 50.5934L0.334229 50.4277C0.234748 50.3731 0.108823 50.4075 0.0527859 50.5044C-0.00325093 50.6014 0.0320082 50.724 0.131489 50.7786L0.43434 50.9443C0.406636 50.9995 0.380822 51.0553 0.356266 51.1118L0.02886 50.9995C0.0194156 50.9964 0.00934161 50.9946 -0.000732422 50.9927V51.416L0.217748 51.4909C0.19697 51.5614 0.178711 51.632 0.162341 51.7037L-0.000732422 51.6786V52.0859L0.0987486 52.1013C0.0924524 52.1675 0.0874154 52.2338 0.0848968 52.3006L-0.000732422 52.3025V52.7049L0.0937116 52.7031C0.0968598 52.7417 0.100638 52.7804 0.105675 52.819L-0.000732422 52.8374V53H0.634561C0.630154 52.9779 0.625117 52.9564 0.620709 52.935C0.334229 51.351 1.41908 49.8413 3.04477 49.5615C4.67047 49.2824 6.21998 50.3394 6.50709 51.9234C6.57383 52.2914 6.56565 52.6546 6.4945 53H7.55416C7.55101 52.9055 7.47987 52.8227 7.38038 52.808H7.37975Z",
    fill: "#42A100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6297 19.7999C20.6297 19.7244 20.5667 19.6631 20.4893 19.6631C20.4118 19.6631 20.3489 19.7244 20.3489 19.7999V20.1385H20.6297V19.7999Z",
    fill: "#42A100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1622 25.4649C26.2397 25.4649 26.3026 25.4035 26.3026 25.3281C26.3026 25.2526 26.2397 25.1913 26.1622 25.1913H25.8147V25.1999C25.8121 25.1029 25.8071 25.0066 25.7989 24.9109V24.9146L26.1452 24.8784C26.2227 24.8704 26.2781 24.8029 26.2699 24.7275C26.2617 24.652 26.1924 24.5981 26.115 24.606L25.7693 24.6416C25.7561 24.5441 25.7404 24.4471 25.7215 24.3514L26.0608 24.2791C26.1364 24.2631 26.1849 24.1901 26.1679 24.1159C26.1515 24.0423 26.0766 23.995 26.0004 24.0116L25.6617 24.084C25.6428 24.0085 25.6214 23.9337 25.5993 23.8594L25.9292 23.7552C26.0029 23.7318 26.0438 23.6545 26.0199 23.5828C25.996 23.511 25.9167 23.4711 25.843 23.4944L25.5131 23.5987C25.4784 23.503 25.4419 23.4085 25.4016 23.3159L25.7171 23.1773C25.7876 23.146 25.8191 23.065 25.7876 22.9963C25.7555 22.9276 25.6724 22.8969 25.6018 22.9276L25.2858 23.0669C25.2511 22.9969 25.2146 22.9282 25.1768 22.8601L25.4778 22.6914C25.5452 22.654 25.5685 22.5699 25.5294 22.5043C25.491 22.4387 25.4048 22.416 25.3374 22.454L25.0358 22.6227C24.9665 22.5123 24.8916 22.4049 24.8142 22.3L24.8601 22.3608L25.1403 22.1602C25.2027 22.1154 25.2159 22.0295 25.1699 21.9688C25.124 21.908 25.0358 21.8945 24.9735 21.9399L24.6933 22.1405L24.7273 22.1853C24.6461 22.0816 24.5604 21.981 24.4717 21.8835L24.5428 21.9602L24.8016 21.7338C24.8595 21.6835 24.8639 21.597 24.8123 21.5406C24.7607 21.4841 24.6719 21.4798 24.614 21.5301L24.3552 21.7565L24.4074 21.8129C24.3023 21.7019 24.1927 21.5952 24.0781 21.4933L24.1184 21.5277L24.3483 21.2737C24.3999 21.2173 24.3942 21.1308 24.3357 21.0805C24.2777 21.0302 24.189 21.0357 24.1373 21.0927L23.9075 21.3467L24.0429 21.4633C23.927 21.362 23.8074 21.2657 23.6827 21.1743L23.7211 21.2013L23.9245 20.9265C23.9698 20.8651 23.956 20.7799 23.893 20.7351C23.8301 20.6909 23.7425 20.7044 23.6966 20.7658L23.4932 21.0406L23.6431 21.1461C23.4643 21.0179 23.2773 20.9007 23.0827 20.7952L23.2496 20.8878L23.4221 20.5934C23.4605 20.5277 23.4372 20.4443 23.3698 20.4069C23.3024 20.3695 23.2168 20.3922 23.1784 20.4578L23.0059 20.7523L23.0248 20.7627C22.9033 20.6989 22.7786 20.64 22.652 20.5854L22.7459 20.6253L22.885 20.3149C22.9159 20.2455 22.8837 20.1646 22.8126 20.1345C22.7414 20.1044 22.6583 20.1357 22.6275 20.2051L22.4883 20.5155L22.5293 20.5326C22.4103 20.4848 22.2887 20.4412 22.1653 20.4014L22.2654 20.4333L22.3725 20.1112C22.3964 20.0394 22.3561 19.9621 22.2824 19.9388C22.2088 19.9155 22.1294 19.9548 22.1055 20.0272L21.9985 20.3492L22.0426 20.3633C21.9022 20.3216 21.7592 20.286 21.6138 20.2554L21.712 20.275L21.7825 19.9431C21.7983 19.8689 21.7498 19.7965 21.6736 19.7812C21.5974 19.7658 21.5231 19.8131 21.5074 19.8873L21.4369 20.2192L21.525 20.237C21.3682 20.2069 21.2089 20.183 21.0471 20.1664L21.1479 20.1762L21.1819 19.8388C21.1894 19.7634 21.1327 19.6965 21.0559 19.6891C20.9785 19.6818 20.9099 19.737 20.9023 19.8118L20.8683 20.1492L21.0175 20.1633C20.8437 20.1468 20.6675 20.1376 20.4893 20.1376C20.3111 20.1376 20.1323 20.1468 19.9572 20.1633L20.0649 20.1523L20.0284 19.8155C20.0202 19.7401 19.9509 19.6861 19.8735 19.694C19.796 19.702 19.7406 19.7695 19.7488 19.845L19.786 20.1817L19.9258 20.167C19.7595 20.1842 19.5952 20.2087 19.434 20.24L19.4888 20.2284L19.4145 19.8977C19.3981 19.8241 19.3232 19.7769 19.247 19.7934C19.1708 19.81 19.123 19.8824 19.14 19.9566L19.2143 20.2873L19.3553 20.2572C19.2143 20.2873 19.0751 20.3216 18.9385 20.3621L18.9838 20.348L18.8768 20.0259C18.8529 19.9542 18.7735 19.9143 18.6999 19.9376C18.6262 19.9609 18.5853 20.0382 18.6092 20.11L18.7162 20.432L18.8157 20.4008C18.6803 20.4443 18.5475 20.4915 18.4172 20.5455L18.4266 20.5412L18.2837 20.2327C18.2516 20.164 18.1685 20.1333 18.0979 20.164C18.0274 20.1952 17.9959 20.2762 18.0274 20.3449L18.1704 20.6535L18.2484 20.6191C17.9279 20.7639 17.6251 20.9388 17.3437 21.14L17.445 21.067L17.2391 20.794C17.1932 20.7332 17.105 20.7204 17.0427 20.7651C16.9804 20.8099 16.9671 20.8958 17.0131 20.9565L17.219 21.2295L17.2801 21.186C17.1629 21.2719 17.0502 21.3627 16.9413 21.4577L17.0345 21.3762L16.8022 21.124C16.7505 21.0676 16.6618 21.0633 16.6038 21.1136C16.5459 21.1639 16.5415 21.2504 16.5931 21.3068L16.8255 21.559L16.8865 21.5056C16.772 21.608 16.6624 21.7148 16.5572 21.8264L16.5906 21.7896L16.33 21.5657C16.272 21.5154 16.1832 21.5209 16.1316 21.578C16.08 21.6344 16.0857 21.7209 16.1442 21.7712L16.4049 21.9957L16.5006 21.8902C16.4087 21.9915 16.3205 22.0957 16.2368 22.2031L16.2563 22.1767L15.9742 21.9786C15.9113 21.9344 15.8237 21.9479 15.7778 22.0092C15.7324 22.0706 15.7463 22.1559 15.8093 22.2006L16.0913 22.3988L16.1379 22.3362C16.0668 22.4344 15.9981 22.5338 15.9339 22.6362L15.6323 22.4687C15.565 22.4313 15.4793 22.454 15.4409 22.5196C15.4025 22.5853 15.4258 22.6687 15.4932 22.7061L15.7948 22.8736C15.7488 22.957 15.706 23.0417 15.6644 23.1276L15.3458 22.9926C15.2747 22.9626 15.1916 22.9938 15.1607 23.0632C15.1299 23.1325 15.162 23.2135 15.2331 23.2435L15.5517 23.3785C15.5221 23.4503 15.4932 23.5227 15.4667 23.5957L15.1368 23.4914C15.0631 23.4681 14.9838 23.5073 14.9599 23.5791C14.936 23.6509 14.9763 23.7282 15.0499 23.7515L15.3798 23.8558C15.3521 23.9478 15.327 24.041 15.3043 24.1349L14.9643 24.0662C14.8881 24.0508 14.8138 24.0981 14.7981 24.1723C14.7823 24.2465 14.8308 24.3189 14.907 24.3343L15.247 24.403C15.23 24.4962 15.2149 24.5895 15.2029 24.6845L14.8566 24.6514C14.7792 24.6441 14.7106 24.6993 14.703 24.7741C14.6954 24.8496 14.7521 24.9164 14.8289 24.9238L15.1752 24.9569V24.9526C15.1696 25.0336 15.1658 25.1158 15.1633 25.198V25.1894H14.8157C14.7383 25.1894 14.6753 25.2508 14.6753 25.3262C14.6753 25.4017 14.7383 25.463 14.8157 25.463H15.1633V25.4612C15.1658 25.5544 15.1708 25.6471 15.1777 25.7397L14.8321 25.7753C14.7546 25.7833 14.6992 25.8507 14.7074 25.9262C14.7156 26.0016 14.7848 26.0556 14.8623 26.0477L15.2073 26.0121C15.2205 26.1096 15.2363 26.2065 15.2545 26.3022L14.9164 26.374C14.8409 26.39 14.7924 26.463 14.8094 26.5372C14.8258 26.6108 14.9007 26.6581 14.9769 26.6415L15.3144 26.5697C15.3333 26.6452 15.354 26.72 15.3767 26.7942L15.048 26.8979C14.9744 26.9212 14.9334 26.9985 14.9574 27.0703C14.9813 27.1421 15.0606 27.1819 15.1343 27.1586L15.4623 27.055C15.497 27.1507 15.5335 27.2451 15.5738 27.3384L15.2602 27.4764C15.1897 27.5077 15.1582 27.5887 15.1897 27.6574C15.2218 27.7261 15.3049 27.7568 15.3754 27.7261L15.6884 27.5881C15.723 27.658 15.7595 27.7273 15.7973 27.7954L15.4995 27.9623C15.4321 27.9997 15.4088 28.0837 15.4478 28.1494C15.4863 28.215 15.5725 28.2377 15.6399 28.1997L15.9383 28.0328C15.9944 28.1224 16.0535 28.2089 16.1152 28.2948L15.8376 28.4941C15.7753 28.5389 15.762 28.6248 15.808 28.6855C15.854 28.7463 15.9421 28.7598 16.0044 28.7144L16.2827 28.515C16.3318 28.5763 16.3816 28.6365 16.4332 28.6954L16.1763 28.9199C16.1184 28.9702 16.114 29.0567 16.1656 29.1131C16.2172 29.1696 16.306 29.1739 16.364 29.1236L16.6208 28.8984C16.697 28.9769 16.7764 29.0536 16.8576 29.1278L16.6297 29.3794C16.578 29.4358 16.5837 29.5223 16.6422 29.5726C16.7002 29.6229 16.789 29.6174 16.8406 29.5603L17.0685 29.3088C17.1296 29.3585 17.1919 29.407 17.2549 29.4542L17.0534 29.726C17.0081 29.7873 17.0219 29.8726 17.0849 29.9174C17.1478 29.9615 17.2354 29.948 17.2813 29.8867L17.4822 29.6155C17.5621 29.6689 17.6434 29.7205 17.7265 29.7701L17.5571 30.0597C17.5187 30.1253 17.542 30.2088 17.6094 30.2462C17.6767 30.2836 17.7624 30.2609 17.8008 30.1953L17.9708 29.9051C18.0564 29.9499 18.1433 29.9922 18.2314 30.0321L18.0942 30.3382C18.0633 30.4075 18.0954 30.4885 18.1666 30.5186C18.2377 30.5486 18.3208 30.5173 18.3517 30.448L18.4889 30.1419C18.5626 30.1707 18.6369 30.199 18.7125 30.2247L18.6067 30.5425C18.5828 30.6143 18.6231 30.6916 18.6967 30.7149C18.7704 30.7382 18.8497 30.6989 18.8736 30.6271L18.9794 30.3094C19.0739 30.3364 19.1696 30.3609 19.2665 30.383L19.1966 30.7106C19.1809 30.7848 19.2294 30.8572 19.3056 30.8725C19.3818 30.8879 19.4561 30.8406 19.4718 30.7664L19.5417 30.4388C19.6374 30.4554 19.7337 30.4695 19.8307 30.4818L19.7973 30.8149C19.7898 30.8903 19.8464 30.9572 19.9232 30.9646C20.0007 30.9719 20.0693 30.9167 20.0769 30.8419L20.1102 30.5081C20.1896 30.5137 20.2689 30.5173 20.3489 30.5192V30.8547C20.3489 30.9302 20.4118 30.9915 20.4893 30.9915C20.5667 30.9915 20.6297 30.9302 20.6297 30.8547V30.5192C20.7247 30.5167 20.8198 30.5118 20.9136 30.5045L20.9502 30.8376C20.9583 30.913 21.0276 30.967 21.105 30.959C21.1825 30.9511 21.2379 30.8836 21.2297 30.8081L21.1932 30.475C21.2933 30.4621 21.3928 30.4468 21.4916 30.4284L21.5647 30.7547C21.581 30.8284 21.656 30.8756 21.7322 30.859C21.8077 30.8431 21.8562 30.7701 21.8392 30.6959L21.7662 30.3695C21.8436 30.3511 21.9204 30.3302 21.9966 30.3088L22.1024 30.6265C22.1263 30.6983 22.2056 30.7382 22.2793 30.7149C22.353 30.6916 22.3939 30.6143 22.37 30.5425L22.2648 30.2247C22.363 30.191 22.46 30.1554 22.5557 30.1161L22.6961 30.4198C22.7282 30.4885 22.8113 30.5192 22.8819 30.4885C22.9524 30.4572 22.9839 30.3762 22.9524 30.3075L22.8113 30.0039C22.8831 29.9701 22.9543 29.9345 23.0241 29.8977L23.1948 30.1867C23.2332 30.2523 23.3194 30.275 23.3868 30.237C23.4542 30.1996 23.4775 30.1155 23.4384 30.0499L23.2678 29.7603C23.3597 29.7057 23.4485 29.6474 23.5367 29.5879L23.7407 29.8579C23.7866 29.9186 23.8748 29.9315 23.9371 29.8867C23.9994 29.8419 24.0127 29.756 23.9667 29.6953L23.7621 29.4248C23.825 29.3769 23.8867 29.3278 23.9472 29.2775L24.1776 29.5272C24.2293 29.5836 24.3187 29.5879 24.376 29.5376C24.4339 29.4873 24.4383 29.4008 24.3867 29.3444L24.1562 29.0941C24.2368 29.0193 24.3155 28.9426 24.3911 28.8634L24.6498 29.0861C24.7078 29.1364 24.7965 29.1309 24.8482 29.0739C24.8998 29.0174 24.8941 28.9309 24.8356 28.8806L24.5774 28.6586C24.6284 28.599 24.6782 28.5383 24.7267 28.477L25.0062 28.6739C25.0692 28.7181 25.1567 28.7046 25.2027 28.6432C25.248 28.5819 25.2341 28.4966 25.1712 28.4518L24.8922 28.2555C24.947 28.1776 24.9999 28.0985 25.0503 28.0175L25.3487 28.1831C25.4161 28.2205 25.5017 28.1978 25.5401 28.1322C25.5785 28.0666 25.5552 27.9831 25.4879 27.9457L25.1888 27.7795C25.2348 27.696 25.2776 27.6114 25.3191 27.5255L25.6352 27.6598C25.7064 27.6899 25.7895 27.6586 25.8203 27.5893C25.8512 27.52 25.8191 27.439 25.7479 27.4089L25.4318 27.2746C25.4614 27.2028 25.4898 27.1304 25.5168 27.0568L25.8449 27.1605C25.9185 27.1838 25.9979 27.1445 26.0218 27.0721C26.0457 27.0004 26.0054 26.9231 25.9318 26.8998L25.6037 26.7961C25.6314 26.7041 25.6566 26.6108 25.6793 26.517L26.018 26.5857C26.0942 26.601 26.1685 26.5538 26.1842 26.4795C26.2 26.4053 26.1515 26.3329 26.0753 26.3176L25.7366 26.2489C25.7536 26.1556 25.7681 26.0618 25.78 25.9673L26.1251 26.0004C26.2025 26.0078 26.2711 25.9526 26.2787 25.8777C26.2862 25.8023 26.2296 25.7354 26.1528 25.728L25.8071 25.6949C25.8128 25.6176 25.8165 25.5391 25.8184 25.4612V25.463H26.166L26.1622 25.4649ZM15.995 25.2134C15.995 22.7951 18.0073 20.8345 20.4893 20.8345C21.5577 20.8345 22.5387 21.1982 23.31 21.805L22.4978 22.6295C22.2409 22.4411 21.9783 22.3049 21.7095 22.2221C21.3204 22.1019 20.9508 22.0878 20.6001 22.1792C20.2494 22.2706 19.9434 22.4485 19.6827 22.7135C19.3729 23.0282 19.2011 23.3472 19.1671 23.6711C19.1331 23.995 19.1771 24.2956 19.2974 24.5729C19.4044 24.8195 19.5562 25.1011 19.7513 25.4176L18.9693 26.2115C18.9624 26.182 18.9568 26.1519 18.9536 26.1213C18.9284 25.9072 18.987 25.7127 19.1293 25.5379L17.8304 24.3232C17.5571 24.6404 17.3871 24.998 17.3197 25.3968C17.2524 25.7949 17.2964 26.1998 17.4526 26.6108C17.5483 26.8636 17.6862 27.104 17.8637 27.3335L17.1094 28.0991C16.4156 27.3286 15.9944 26.3194 15.9944 25.214L15.995 25.2134ZM20.1423 26.8028C20.0334 26.9133 19.8999 26.9611 19.7425 26.9458C19.7142 26.9433 19.6852 26.9372 19.6563 26.9304L20.2418 26.336C20.3035 26.5163 20.2714 26.6715 20.1423 26.8028ZM20.8375 24.3146C20.7745 24.1281 20.8072 23.9693 20.9363 23.838C21.0452 23.7275 21.1718 23.6791 21.3166 23.692C21.3537 23.695 21.3909 23.703 21.428 23.7147L20.8375 24.314V24.3146ZM20.4886 29.5922C19.5045 29.5922 18.5947 29.2831 17.8543 28.7604L18.5784 28.0255C18.8258 28.207 19.0814 28.342 19.3459 28.4285C19.7293 28.5543 20.0964 28.5763 20.4465 28.4954C20.7965 28.4144 21.105 28.2389 21.3714 27.9684C21.6818 27.6433 21.8549 27.3151 21.8914 26.9832C21.928 26.6513 21.8883 26.3495 21.7724 26.0765C21.6711 25.8366 21.5244 25.5538 21.3342 25.2268L22.0589 24.4907C22.0722 24.6815 22.0123 24.8643 21.8789 25.0385L23.0934 26.174C23.5146 25.6563 23.7117 25.1085 23.6846 24.5318C23.6645 24.1079 23.5064 23.7042 23.2111 23.3202L24.0164 22.5025C24.6203 23.2478 24.9817 24.1889 24.9817 25.2127C24.9817 27.631 22.9694 29.5916 20.4874 29.5916L20.4886 29.5922Z",
    fill: "#42A100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7133 20.8972L17.957 20.761L17.7838 20.4672C17.7454 20.4016 17.6592 20.3789 17.5918 20.4169C17.5244 20.4543 17.5011 20.5384 17.5402 20.604L17.7133 20.8978V20.8972Z",
    fill: "#42A100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.86825 43.5693L7.56226 43.8368C7.50433 43.8871 7.49992 43.9736 7.55155 44.03L7.57611 44.0564C7.62774 44.1129 7.71651 44.1172 7.77444 44.0669L8.08044 43.7994L7.86825 43.5693Z",
    fill: "#42A100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.295 45.6684C10.2711 45.7402 10.3108 45.8175 10.3851 45.8414L10.4197 45.8525C10.4934 45.8758 10.5727 45.8371 10.5973 45.7647L10.7251 45.3844L10.4235 45.2881L10.295 45.6684Z",
    fill: "#42A100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8579 40.2765L18.4518 40.2342C18.4618 40.1121 18.4681 39.99 18.4706 39.8673L18.8786 39.8636C18.9561 39.863 19.0184 39.8011 19.0178 39.7256V39.69C19.0165 39.6146 18.9536 39.5538 18.8755 39.5544L18.4681 39.5581C18.465 39.4704 18.4599 39.3833 18.4524 39.2956L18.8572 39.2532C18.9347 39.2453 18.9901 39.1778 18.9819 39.1023L18.9781 39.0667C18.9699 38.9913 18.9007 38.9373 18.8232 38.9453L18.419 38.9876C18.4045 38.8821 18.3882 38.7766 18.368 38.6711L18.764 38.5876C18.8396 38.5717 18.8881 38.4987 18.8717 38.4251L18.8642 38.3901C18.8478 38.3165 18.7729 38.2692 18.6973 38.2852L18.3013 38.3692C18.2755 38.2656 18.2459 38.1625 18.2138 38.0594L18.5985 37.9349C18.6721 37.911 18.7118 37.8337 18.6872 37.7619L18.6759 37.7282C18.6513 37.6564 18.572 37.6178 18.4983 37.6417L18.1136 37.7662C18.0828 37.684 18.0507 37.6018 18.0161 37.5208L18.3863 37.3601C18.4574 37.3294 18.4889 37.2484 18.4574 37.1791L18.4423 37.1466C18.4108 37.0773 18.3277 37.0466 18.2566 37.0773L17.8863 37.238C17.8385 37.1399 17.7875 37.0436 17.7333 36.9472L18.0841 36.7485C18.1514 36.7104 18.1741 36.6264 18.1351 36.5614L18.1168 36.5307C18.0778 36.4651 17.9915 36.443 17.9248 36.481L17.5734 36.6804C17.5155 36.5896 17.4551 36.5 17.3921 36.4117L17.7195 36.1767C17.7818 36.1319 17.7951 36.0461 17.7491 35.9853L17.7277 35.9565C17.6817 35.8958 17.5936 35.8829 17.5312 35.9277L17.2032 36.1626C17.1484 36.0939 17.0911 36.0258 17.0326 35.959L17.3354 35.6933C17.3933 35.643 17.3978 35.5565 17.3461 35.5001L17.3216 35.4737C17.2699 35.4173 17.1812 35.413 17.1232 35.4633L16.8204 35.7283C16.7461 35.6522 16.6705 35.578 16.5937 35.5068L16.8657 35.2118C16.9174 35.1553 16.9129 35.0688 16.855 35.0185L16.8279 34.9946C16.77 34.9443 16.6812 34.9486 16.6296 35.005L16.3576 35.2995C16.2707 35.2271 16.1826 35.1572 16.0925 35.0903L16.3293 34.7695C16.3746 34.7081 16.3601 34.6222 16.2972 34.5787L16.2676 34.5578C16.2046 34.5136 16.1165 34.5277 16.0711 34.5891L15.8344 34.9099C15.7595 34.8602 15.6839 34.813 15.6077 34.767L15.8111 34.4253C15.8501 34.3597 15.8275 34.2762 15.7601 34.2382L15.7286 34.2204C15.6612 34.1824 15.5756 34.2045 15.5366 34.2701L15.3332 34.6118C15.23 34.5572 15.1261 34.5044 15.0203 34.456L15.1834 34.0953C15.2148 34.0259 15.1821 33.945 15.1116 33.9149L15.0782 33.9008C15.0071 33.8701 14.924 33.902 14.8931 33.9707L14.73 34.3314C14.6463 34.2983 14.5625 34.267 14.4775 34.2376L14.6035 33.8628C14.6274 33.791 14.5877 33.7137 14.5134 33.6898L14.4788 33.6787C14.4051 33.6554 14.3258 33.6941 14.3013 33.7664L14.1747 34.1419C14.0582 34.1081 13.9411 34.0787 13.8227 34.0523L13.9052 33.664C13.921 33.5898 13.8718 33.5174 13.7963 33.502L13.7604 33.4947C13.6842 33.4793 13.6099 33.5272 13.5942 33.6008L13.5117 33.9897C13.4229 33.9744 13.3341 33.9609 13.2454 33.9493L13.2888 33.5542C13.297 33.4787 13.241 33.4112 13.1641 33.4033L13.1276 33.3996C13.0502 33.3916 12.9809 33.4462 12.9727 33.5211L12.9293 33.9167C12.804 33.9069 12.6787 33.9008 12.5528 33.8983L12.549 33.5008C12.5484 33.4254 12.4848 33.3646 12.4073 33.3652H12.3708C12.2934 33.3665 12.231 33.4278 12.2317 33.5039L12.2354 33.9008C12.1454 33.9039 12.056 33.9094 11.966 33.9161L11.9225 33.5211C11.9143 33.4456 11.8451 33.3916 11.7676 33.3996L11.7311 33.4033C11.6537 33.4112 11.5983 33.4787 11.6064 33.5542L11.6499 33.9486C11.5416 33.9627 11.4333 33.9793 11.3256 33.9989L11.2394 33.6118C11.223 33.5382 11.1481 33.491 11.0725 33.5069L11.0366 33.5143C10.9611 33.5303 10.9126 33.6033 10.929 33.6769L11.0152 34.0646C10.9088 34.0897 10.803 34.1186 10.6979 34.1499L10.5695 33.7732C10.5449 33.7014 10.4656 33.6628 10.3919 33.6867L10.3573 33.6977C10.2836 33.7217 10.2439 33.799 10.2685 33.8707L10.3976 34.248C10.3132 34.2781 10.2295 34.3094 10.1457 34.3431L9.98012 33.9799C9.94864 33.9106 9.86553 33.8799 9.79438 33.9106L9.76101 33.9253C9.68986 33.956 9.65838 34.037 9.68986 34.1063L9.85608 34.4695C9.75597 34.5161 9.65649 34.5664 9.55827 34.6185L9.35238 34.2744C9.31335 34.2087 9.22709 34.1867 9.16035 34.2247L9.12887 34.2425C9.0615 34.2805 9.03883 34.3646 9.07787 34.4296L9.28375 34.7744C9.19057 34.8308 9.09864 34.8897 9.00798 34.951L8.76494 34.6296C8.71898 34.5688 8.63083 34.556 8.5685 34.6007L8.5389 34.6216C8.47657 34.6664 8.46335 34.7523 8.50931 34.813L8.75298 35.1351C8.68183 35.1891 8.61194 35.2449 8.54268 35.3025L8.54457 35.3013L8.27005 35.0032C8.21843 34.9467 8.12965 34.9424 8.07172 34.9928L8.04465 35.0167C7.98672 35.067 7.98231 35.1535 8.03394 35.2099L8.30846 35.5081L8.31602 35.5013C8.23417 35.5768 8.15483 35.6534 8.07865 35.732L8.0818 35.7289L7.77643 35.4608C7.7185 35.4105 7.62972 35.4148 7.57809 35.4713L7.55354 35.4976C7.50191 35.5541 7.50632 35.6406 7.56424 35.6909L7.86961 35.9583C7.79532 36.043 7.72417 36.1289 7.65554 36.2166L7.32247 35.9835C7.2595 35.9393 7.17136 35.9534 7.12602 36.0148L7.10461 36.0436C7.05928 36.105 7.07376 36.1908 7.13673 36.2344L7.4698 36.4675C7.41943 36.5399 7.37032 36.6135 7.32372 36.6884L6.96862 36.4878C6.90125 36.4497 6.81562 36.4718 6.77658 36.5374L6.75832 36.5681C6.71928 36.6338 6.74195 36.7172 6.80932 36.7552L7.16443 36.9558C7.10839 37.0564 7.05424 37.1577 7.0045 37.2607L6.62988 37.1C6.55873 37.0693 6.47562 37.1012 6.44477 37.1699L6.43028 37.2024C6.3988 37.2718 6.43154 37.3527 6.50206 37.3828L6.87732 37.5435C6.84332 37.6245 6.81121 37.7067 6.78099 37.7889L6.39125 37.6644C6.31758 37.6411 6.23825 37.6797 6.21369 37.7521L6.20236 37.7858C6.17843 37.8576 6.2181 37.9349 6.2924 37.9588L6.68276 38.0834C6.63995 38.2239 6.60343 38.3662 6.57195 38.5085L6.58958 38.4251L6.18725 38.3441C6.11106 38.3288 6.03677 38.3766 6.02103 38.4502L6.01347 38.4852C5.99773 38.5594 6.04684 38.6318 6.1224 38.6471L6.52473 38.7281L6.53795 38.6668C6.50962 38.8115 6.48758 38.9576 6.47058 39.1042L6.48317 38.9876L6.07455 38.9453C5.9971 38.9373 5.92784 38.9919 5.91966 39.0667L5.91588 39.1023C5.90769 39.1778 5.96373 39.2453 6.04055 39.2532L6.44917 39.2956L6.45862 39.2097C6.44225 39.3796 6.4328 39.5502 6.43154 39.7207V39.6618L6.01977 39.6655C5.94232 39.6661 5.87999 39.7281 5.88062 39.8035V39.8391C5.88188 39.9146 5.94484 39.9753 6.02292 39.9747L6.43406 39.971L6.43217 39.7722C6.43217 39.9434 6.43973 40.1145 6.45547 40.2851L6.4498 40.2329L6.04117 40.2753C5.96373 40.2832 5.90832 40.3507 5.91651 40.4262L5.92029 40.4618C5.92847 40.5372 5.99773 40.5912 6.07517 40.5832L6.4838 40.5409L6.46177 40.3391C6.48632 40.582 6.52662 40.8237 6.58202 41.0623L6.53606 40.8568L6.13436 40.9421C6.0588 40.958 6.01032 41.0311 6.02669 41.1047L6.03425 41.1396C6.05062 41.2132 6.12554 41.2605 6.2011 41.2445L6.6028 41.1593L6.59777 41.136C6.63428 41.2838 6.67773 41.4298 6.72621 41.5752L6.68969 41.4684L6.29995 41.5948C6.22628 41.6187 6.18662 41.696 6.21117 41.7678L6.22251 41.8016C6.24706 41.8733 6.3264 41.912 6.40006 41.8881L6.79043 41.7617L6.77469 41.7151C6.82317 41.8488 6.87732 41.9813 6.9365 42.112L6.88802 42.0058L6.51277 42.1684C6.44162 42.1991 6.41014 42.2801 6.44162 42.3494L6.45673 42.3819C6.48821 42.4512 6.57132 42.4819 6.64247 42.4512L7.01773 42.2886L6.99632 42.242C7.06684 42.3886 7.14365 42.5328 7.22739 42.6745L7.1701 42.5788L6.81499 42.78C6.74762 42.8181 6.72495 42.9021 6.76399 42.9671L6.78225 42.9978C6.82128 43.0628 6.90754 43.0855 6.97428 43.0475L7.32939 42.8463L7.27839 42.7604C7.37095 42.9119 7.47043 43.0604 7.57872 43.2045L7.51072 43.115L7.17954 43.3524C7.11721 43.3972 7.10336 43.4831 7.14995 43.5438L7.17136 43.5726C7.21732 43.6334 7.30547 43.6462 7.3678 43.6015L7.69898 43.364L7.59887 43.2309C7.71598 43.3855 7.84128 43.5364 7.97539 43.6824C8.11076 43.829 8.25242 43.9677 8.39913 44.0984L8.30846 44.0186L8.03331 44.3161C7.98169 44.3726 7.98609 44.4591 8.04402 44.5094L8.07109 44.5333C8.12902 44.5836 8.2178 44.5793 8.26942 44.5229L8.54457 44.2253L8.42683 44.1223C8.56724 44.2456 8.71205 44.3615 8.86127 44.4695L8.81027 44.4333L8.57039 44.7584C8.52505 44.8198 8.53954 44.9057 8.6025 44.9492L8.63209 44.9701C8.69505 45.0143 8.7832 45.0001 8.8279 44.9388L9.06779 44.6137L8.93557 44.521C9.06779 44.6137 9.20253 44.7014 9.34042 44.7824L9.29383 44.756L9.08731 45.1026C9.04827 45.1682 9.07094 45.2517 9.13831 45.2897L9.16979 45.3075C9.23716 45.3455 9.32279 45.3234 9.36183 45.2578L9.56835 44.9112L9.46635 44.8535C9.60612 44.9314 9.74716 45.0044 9.89197 45.0707L9.88127 45.0664L9.71568 45.4332C9.6842 45.5026 9.71694 45.5835 9.78746 45.6136L9.82083 45.6277C9.89197 45.6584 9.97508 45.6265 10.0059 45.5578L10.1715 45.1909L10.0802 45.1517C10.4473 45.305 10.8276 45.4216 11.2148 45.5001L11.0757 45.4719L10.9926 45.8639C10.9768 45.9381 11.0259 46.0105 11.1015 46.0259L11.1374 46.0332C11.2136 46.0485 11.2879 46.0007 11.3036 45.9271L11.3867 45.5351L11.303 45.5185C11.4654 45.5492 11.6291 45.5731 11.7928 45.5903L11.6524 45.5756L11.609 45.9737C11.6008 46.0492 11.6568 46.1166 11.7336 46.1246L11.7702 46.1283C11.8476 46.1363 11.9169 46.0817 11.925 46.0068L11.9685 45.6087L11.8766 45.5989C12.0516 45.6154 12.2266 45.624 12.4023 45.6259H12.345L12.3488 46.0271C12.3494 46.1025 12.413 46.1633 12.4904 46.1627H12.527C12.6044 46.1614 12.6667 46.1001 12.6661 46.024L12.6623 45.6234L12.4993 45.6246C12.656 45.6234 12.8122 45.6173 12.969 45.6044L12.9318 45.6081L12.9753 46.0062C12.9834 46.0817 13.0527 46.1357 13.1301 46.1277L13.1667 46.124C13.2441 46.116 13.2995 46.0486 13.2913 45.9731L13.2479 45.575L13.1591 45.5842C13.297 45.5682 13.4349 45.5498 13.5721 45.5247L13.659 45.9154C13.6754 45.9897 13.7503 46.0363 13.8259 46.0203L13.8618 46.013C13.9373 45.997 13.9858 45.924 13.9694 45.8504L13.8826 45.4596C13.989 45.4345 14.0947 45.4056 14.1999 45.375L14.3296 45.7547C14.3541 45.8265 14.4335 45.8651 14.5071 45.8412L14.5418 45.8302C14.6154 45.8062 14.6551 45.7289 14.6305 45.6572L14.5008 45.2774C14.5852 45.248 14.669 45.2167 14.7521 45.183L14.9189 45.548C14.9504 45.6173 15.0335 45.648 15.1047 45.6173L15.138 45.6026C15.2092 45.5719 15.2407 45.4909 15.2092 45.4216L15.0423 45.0566C15.1424 45.01 15.2419 44.9603 15.3401 44.9081L15.5467 45.2541C15.5857 45.3198 15.6719 45.3418 15.7387 45.3038L15.7702 45.286C15.8375 45.248 15.8602 45.1639 15.8212 45.0989L15.6147 44.7529C15.7078 44.6971 15.7998 44.6382 15.8904 44.5762L16.1341 44.8989C16.1801 44.9597 16.2682 44.9725 16.3305 44.9278L16.3601 44.9069C16.4225 44.8621 16.4363 44.7762 16.3897 44.7155L16.1461 44.3928L16.1417 44.3959C16.2166 44.3394 16.2896 44.2812 16.3627 44.2204L16.3551 44.2272L16.6296 44.5253C16.6812 44.5818 16.77 44.5861 16.8279 44.5358L16.855 44.5118C16.9129 44.4615 16.9174 44.375 16.8657 44.3186L16.5912 44.0204L16.5893 44.0217C16.668 43.9493 16.7442 43.8751 16.8185 43.7996L17.1239 44.0671C17.1818 44.1174 17.2706 44.1131 17.3222 44.0566L17.3468 44.0303C17.3984 43.9738 17.394 43.8873 17.3361 43.837L17.0313 43.5702C17.1056 43.4855 17.1774 43.3996 17.246 43.3119L17.5785 43.5444C17.6414 43.5886 17.7296 43.5745 17.7743 43.5131L17.7957 43.4843C17.841 43.4229 17.8265 43.337 17.7636 43.2935L17.4318 43.0616C17.4828 42.9892 17.5312 42.9156 17.5785 42.8408L17.9317 43.0401C17.9991 43.0782 18.0847 43.0561 18.1237 42.9904L18.142 42.9598C18.181 42.8941 18.1583 42.8107 18.091 42.7727L17.7384 42.5733C17.7944 42.4727 17.8486 42.3715 17.8983 42.2684L18.2704 42.4279C18.3416 42.4586 18.4247 42.4267 18.4555 42.358L18.47 42.3255C18.5015 42.2561 18.4688 42.1752 18.3982 42.1451L18.0261 41.9856C18.0601 41.9046 18.0922 41.8224 18.1225 41.7402L18.509 41.8635C18.5827 41.8868 18.662 41.8482 18.6866 41.7758L18.6979 41.7421C18.7219 41.6703 18.6822 41.593 18.6079 41.5691L18.2213 41.4458C18.2559 41.3323 18.2862 41.2182 18.3139 41.1034L18.7137 41.1838C18.7899 41.1991 18.8642 41.1513 18.8799 41.0777L18.8875 41.0427C18.9032 40.9685 18.8541 40.8961 18.7785 40.8808L18.3787 40.8004C18.3945 40.7139 18.4083 40.6274 18.4203 40.5409L18.8264 40.5832C18.9038 40.5912 18.9731 40.5366 18.9813 40.4618L18.985 40.4262C18.9932 40.3507 18.9372 40.2832 18.8604 40.2753L18.8579 40.2765ZM8.95635 36.1731C11.0417 34.3468 14.2521 34.513 16.1265 36.5448C16.8701 37.3509 17.2907 38.3288 17.3984 39.3299L16.2178 39.2925C16.1876 38.9526 16.1108 38.641 15.9855 38.3594C15.8042 37.9509 15.546 37.6337 15.2117 37.4079C14.8774 37.1822 14.4933 37.0626 14.0582 37.0485C13.5438 37.0399 13.1295 37.146 12.816 37.3668C12.5024 37.5877 12.272 37.8484 12.124 38.1484C11.9943 38.4122 11.8602 38.7465 11.7223 39.149L10.5399 39.1115C10.6947 38.9563 10.8975 38.8674 11.1481 38.8447L11.2104 36.9926C10.4454 37.0386 9.8246 37.2908 9.34735 37.749C8.99727 38.0858 8.76872 38.5202 8.66042 39.052L7.34702 39.0103C7.53402 37.9527 8.07235 36.946 8.95509 36.1731H8.95635ZM14.4593 39.2367L13.5048 39.206C13.6137 39.0189 13.7724 38.9281 13.9827 38.9349C14.1602 38.9404 14.3019 39.0134 14.4083 39.1539C14.4278 39.179 14.4442 39.2072 14.4599 39.2361L14.4593 39.2367ZM11.3124 40.2458C11.1997 40.4384 11.0379 40.5317 10.8263 40.5249C10.6494 40.5194 10.5115 40.4526 10.4133 40.3237C10.3881 40.2912 10.3667 40.255 10.3491 40.2151L11.3118 40.2458H11.3124ZM15.745 43.5315C13.6597 45.3578 10.4492 45.1915 8.57416 43.1598C7.76698 42.285 7.3401 41.2071 7.28091 40.1176L8.60502 40.1599C8.63713 40.5121 8.71772 40.8304 8.84931 41.1133C9.03946 41.5224 9.30642 41.8359 9.6502 42.0537C9.99397 42.2721 10.378 42.388 10.8037 42.4015C11.3093 42.4175 11.7141 42.3169 12.0189 42.0997C12.3236 41.8825 12.5496 41.62 12.6976 41.3114C12.8292 41.0372 12.9576 40.7004 13.0829 40.3016L14.3579 40.3421C14.3378 40.3697 14.3157 40.3973 14.2924 40.4231C14.1262 40.6053 13.9147 40.7041 13.6565 40.7194L13.5904 42.7003C14.0702 42.6843 14.5071 42.5537 14.9019 42.3077C15.2967 42.0623 15.6121 41.72 15.8489 41.282C15.9943 41.0126 16.0982 40.7182 16.1612 40.3992L17.3915 40.4384C17.2511 41.5887 16.6989 42.6954 15.7456 43.5309L15.745 43.5315Z",
    fill: "#42A100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5568 29.6494L15.1929 29.615L15.1753 29.7905C15.1841 29.6917 15.1897 29.5917 15.1897 29.4905C15.1897 29.3991 15.1847 29.3083 15.1778 29.2187L15.1897 29.3592L15.5543 29.3304C15.655 29.3224 15.73 29.2365 15.7218 29.1384C15.7136 29.0402 15.6254 28.9672 15.5247 28.9752L15.1601 29.004L15.1708 29.1316C15.1583 29.0114 15.1387 28.893 15.1129 28.7764L15.458 28.6881C15.5555 28.6629 15.6141 28.5654 15.5883 28.4703C15.5625 28.3752 15.4624 28.3182 15.3648 28.3433L15.0178 28.4323C15.0002 28.3783 14.9807 28.3249 14.9599 28.2722L15.2911 28.1323C15.3837 28.093 15.4265 27.9881 15.3862 27.898C15.3459 27.8078 15.2382 27.7661 15.1457 27.8053L14.8126 27.9458C14.7729 27.8697 14.7314 27.7943 14.686 27.7213L14.9826 27.5299C15.067 27.4753 15.0896 27.3649 15.0336 27.2827C14.9775 27.2005 14.8642 27.1784 14.7798 27.233L14.4808 27.4262C14.4285 27.3587 14.3731 27.2931 14.3158 27.2299L14.574 26.987C14.6464 26.9189 14.6489 26.806 14.5784 26.7348C14.5085 26.6643 14.3926 26.6618 14.3196 26.7305L14.0608 26.9741C13.9966 26.9158 13.9292 26.86 13.8606 26.8066L13.8826 26.8226L14.0986 26.5348C14.1584 26.4551 14.1401 26.3441 14.0589 26.2858C13.9771 26.2275 13.8631 26.2453 13.8033 26.3244L13.5873 26.6121L13.6119 26.6299C13.5237 26.5729 13.4331 26.5189 13.3393 26.4698L13.4954 26.1508C13.5388 26.0619 13.5004 25.9557 13.4091 25.9134C13.3179 25.8711 13.2089 25.9085 13.1655 25.9975L13.0093 26.3171C12.9319 26.2858 12.8526 26.2576 12.7726 26.2318L12.8683 25.8932C12.8954 25.7981 12.8381 25.6999 12.7405 25.6742C12.6429 25.6484 12.5422 25.7036 12.5157 25.7987L12.42 26.1373C12.3312 26.1183 12.2406 26.103 12.1493 26.0907L12.1801 25.7441C12.1889 25.6459 12.114 25.5594 12.0139 25.5515C11.9132 25.5429 11.8244 25.6159 11.8156 25.7134L11.7847 26.0606C11.745 26.0594 11.7054 26.0576 11.6657 26.0576C11.6305 26.0576 11.5952 26.0594 11.5599 26.06L11.5297 25.7146C11.5209 25.6165 11.4327 25.5435 11.332 25.5521C11.2313 25.5607 11.1563 25.6466 11.1652 25.7447L11.1954 26.0882C11.123 26.0974 11.0512 26.1085 10.9807 26.122L10.8944 25.7919C10.8692 25.6969 10.7698 25.6392 10.6722 25.6631C10.5746 25.6877 10.5154 25.7846 10.5399 25.8797L10.6262 26.2085C10.5406 26.2343 10.4575 26.2637 10.375 26.2956L10.2314 25.9895C10.1892 25.8999 10.0809 25.8607 9.98901 25.9018C9.89709 25.9429 9.85679 26.0484 9.89898 26.1379L10.0425 26.4434C9.97579 26.4772 9.91031 26.5121 9.84672 26.5496L9.65531 26.2747C9.59864 26.1931 9.48468 26.1723 9.40094 26.2275C9.3172 26.2827 9.29579 26.3937 9.35246 26.4753L9.54387 26.7502C9.46768 26.806 9.39465 26.8655 9.3235 26.9268L9.08613 26.6925C9.01498 26.6226 8.89913 26.622 8.82735 26.6913C8.75557 26.7606 8.75494 26.8735 8.82609 26.9434L9.06346 27.1771C9.00616 27.2385 8.95139 27.3023 8.8985 27.3679L8.62524 27.1796C8.54276 27.1225 8.4288 27.1416 8.37024 27.2219C8.31169 27.3023 8.33121 27.4133 8.41369 27.4704L8.68694 27.6587C8.64539 27.7231 8.60446 27.7888 8.56732 27.8556L8.26824 27.7164C8.17695 27.674 8.06802 27.7115 8.02395 27.8004C7.9805 27.8894 8.01891 27.9955 8.11021 28.0384L8.40991 28.1783C8.37843 28.2519 8.35009 28.3274 8.32428 28.4041L8.00695 28.3176C7.90935 28.2912 7.80861 28.3464 7.78154 28.4409C7.75447 28.536 7.81113 28.6341 7.9081 28.6605L8.22669 28.7476C8.20843 28.8292 8.19206 28.912 8.18009 28.9961L7.85395 28.9654C7.75321 28.9556 7.6638 29.0273 7.65436 29.1255C7.64428 29.2236 7.71795 29.3108 7.81869 29.32L8.14672 29.3506C8.14484 29.3973 8.14295 29.4439 8.14295 29.4905C8.14295 29.5291 8.14484 29.5678 8.14609 29.6058L7.81995 29.6316C7.71921 29.6396 7.64428 29.7255 7.65247 29.8236C7.66065 29.9218 7.7488 29.9948 7.84954 29.9868L8.17695 29.961C8.18891 30.0445 8.20339 30.1273 8.22102 30.2089L7.90621 30.2892C7.80861 30.3144 7.75006 30.4119 7.77587 30.507C7.80169 30.6021 7.9018 30.6591 7.99939 30.634L8.31609 30.553C8.33435 30.607 8.35387 30.661 8.37465 30.7137L8.07621 30.8401C7.98365 30.8794 7.94084 30.9843 7.98113 31.0745C8.02143 31.1646 8.12909 31.2064 8.22165 31.1671L8.52261 31.0401C8.56228 31.1162 8.60383 31.1904 8.64854 31.2628L8.37717 31.4382C8.2928 31.4928 8.27013 31.6033 8.32617 31.6855C8.38221 31.7677 8.49554 31.7898 8.57991 31.7352L8.85443 31.5579C8.90983 31.6296 8.96902 31.699 9.03009 31.7664L8.79398 31.9885C8.72157 32.0566 8.71906 32.1695 8.78957 32.2406C8.85946 32.3112 8.97531 32.3136 9.04835 32.2449L9.28698 32.021C9.34679 32.0744 9.40913 32.1259 9.47272 32.175L9.27816 32.4345C9.21835 32.5143 9.23661 32.6253 9.31783 32.6836C9.39968 32.7418 9.51364 32.7241 9.57346 32.6449L9.77053 32.3824C9.85301 32.4339 9.93738 32.4817 10.0236 32.5265L9.88072 32.8185C9.83727 32.9075 9.87568 33.0136 9.96698 33.0559C10.0583 33.0983 10.1672 33.0608 10.2106 32.9719L10.3555 32.6762C10.4348 32.7075 10.5154 32.7363 10.5972 32.7615L10.5085 33.0762C10.4814 33.1713 10.5387 33.2694 10.6363 33.2952C10.7339 33.3216 10.8346 33.2657 10.861 33.1707L10.9511 32.8523C11.0411 32.8707 11.133 32.8842 11.2262 32.8958L11.1973 33.2253C11.1885 33.3234 11.2634 33.4099 11.3635 33.4185C11.4636 33.4271 11.553 33.3541 11.5612 33.2565L11.5908 32.9222C11.6166 32.9222 11.6424 32.924 11.6682 32.924C11.7224 32.924 11.7753 32.9222 11.8288 32.9204L11.859 33.27C11.8678 33.3682 11.956 33.4412 12.0567 33.4326C12.1574 33.424 12.2324 33.3381 12.2236 33.24L12.1927 32.8866C12.2639 32.8762 12.335 32.8633 12.4049 32.8492L12.4949 33.1927C12.5201 33.2878 12.6196 33.3455 12.7172 33.3216C12.8148 33.297 12.874 33.2001 12.8494 33.105L12.7587 32.7596L12.7191 32.7695C12.8249 32.7376 12.9281 32.7001 13.0289 32.659L12.9999 32.6719L13.1523 32.9958C13.1944 33.0854 13.3027 33.1246 13.3947 33.0835C13.4866 33.0424 13.5269 32.9369 13.4847 32.8474L13.3323 32.5235L13.2234 32.5719C13.3254 32.5228 13.4243 32.4695 13.5206 32.4118L13.7189 32.6971C13.7756 32.7787 13.8896 32.7995 13.9733 32.7443C14.057 32.6891 14.0784 32.5781 14.0218 32.4965L13.8209 32.2075C13.8958 32.1511 13.9695 32.0922 14.0394 32.0296L14.2868 32.2738C14.358 32.3437 14.4738 32.3443 14.5456 32.275C14.6174 32.2057 14.618 32.0928 14.5469 32.0229L14.2963 31.7756C14.3492 31.718 14.4002 31.6579 14.4493 31.5965L14.7421 31.7983C14.8245 31.8554 14.9385 31.8364 14.9971 31.756C15.0556 31.6756 15.0361 31.5646 14.9536 31.5076L14.659 31.3045C14.7018 31.2376 14.7427 31.1689 14.7811 31.0984L15.1091 31.2511C15.2004 31.2935 15.3094 31.256 15.3534 31.1671C15.3969 31.0781 15.3585 30.972 15.2672 30.9291L14.9373 30.7751L14.9259 30.7984C14.9605 30.7162 14.992 30.6322 15.0204 30.5475L15.0185 30.5542L15.3704 30.6506C15.468 30.6769 15.5688 30.6217 15.5958 30.5273C15.6229 30.4322 15.5662 30.334 15.4693 30.3076L15.1173 30.2113L15.0947 30.2905C15.128 30.1549 15.1532 30.0169 15.1696 29.8758L15.1601 29.9684L15.5241 30.0027C15.6248 30.0119 15.7142 29.9408 15.7237 29.8426C15.7337 29.7445 15.6601 29.6574 15.5593 29.6482L15.5568 29.6494ZM14.1338 29.4905C14.1338 29.9862 13.9796 30.4469 13.7164 30.8291L13.3374 30.5125C13.4369 30.3678 13.508 30.2199 13.5508 30.0684C13.6125 29.8494 13.6138 29.6426 13.5546 29.4488C13.4954 29.2549 13.3814 29.0875 13.2127 28.947C13.0106 28.7838 12.8104 28.6973 12.6133 28.6875C12.4162 28.6777 12.2387 28.7102 12.0813 28.7838C11.9434 28.8482 11.7797 28.9408 11.5939 29.058L11.1349 28.6746C11.2476 28.6611 11.3572 28.6887 11.4649 28.7574L12.0964 28.0391C11.7765 27.8194 11.4466 27.7268 11.1066 27.7605C10.8566 27.7857 10.6237 27.8881 10.4065 28.066L9.99342 27.7213C10.4335 27.3262 11.0203 27.0845 11.6663 27.0845C13.0295 27.0845 14.1351 28.1611 14.1351 29.4899L14.1338 29.4905ZM12.2846 29.6347C12.3892 29.5942 12.4823 29.6071 12.5636 29.6752C12.6322 29.7328 12.6649 29.8058 12.6611 29.8948C12.6605 29.9107 12.6567 29.9267 12.6536 29.9426L12.284 29.6347H12.2846ZM10.6973 29.0556L11.0707 29.3672C10.9624 29.4089 10.868 29.3954 10.7855 29.3273C10.7169 29.2703 10.6841 29.2003 10.6866 29.1187C10.6873 29.0979 10.691 29.077 10.6967 29.0556H10.6973ZM9.19694 29.4905C9.19694 28.9948 9.3512 28.5341 9.61438 28.1519L10.0205 28.4906C9.91786 28.6409 9.84546 28.793 9.80516 28.9464C9.74724 29.1684 9.75038 29.3764 9.81587 29.5703C9.88135 29.7641 9.99657 29.9297 10.1615 30.0678C10.3573 30.2316 10.5519 30.3174 10.7446 30.3254C10.9372 30.334 11.1135 30.2997 11.2735 30.223C11.4151 30.1549 11.5776 30.0598 11.757 29.9402L12.2519 30.353C12.2343 30.3579 12.2173 30.3616 12.199 30.3647C12.0731 30.3855 11.9566 30.3592 11.8483 30.2849L11.1727 31.0536C11.3692 31.1965 11.5864 31.2806 11.8237 31.3051C12.0611 31.3303 12.2991 31.2922 12.5371 31.191C12.6832 31.1291 12.8211 31.0438 12.9508 30.9364L13.3374 31.2591C12.8973 31.6542 12.3104 31.8959 11.6645 31.8959C10.3013 31.8959 9.19568 30.8193 9.19568 29.4905H9.19694Z",
    fill: "#42A100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5985 43.5379L25.2547 43.5128C25.2566 43.4269 25.2547 43.3404 25.2503 43.2545L25.5903 43.2183C25.6684 43.2103 25.7244 43.1416 25.7156 43.0662L25.7093 43.0116C25.7011 42.9355 25.6306 42.8809 25.5532 42.8895L25.2138 42.9257C25.2012 42.8496 25.1848 42.7742 25.1666 42.6993L25.4921 42.6067C25.567 42.5852 25.6105 42.5085 25.5884 42.4355L25.5727 42.3828C25.5507 42.3098 25.472 42.2674 25.397 42.2889L25.0715 42.3815C25.0476 42.3147 25.0224 42.2484 24.9934 42.1834L25.295 42.0405C25.3655 42.0073 25.3945 41.9245 25.3605 41.8558L25.336 41.8067C25.302 41.738 25.217 41.7098 25.1464 41.7429L24.8442 41.8865C24.8071 41.8215 24.7674 41.7583 24.7252 41.6957L24.9953 41.5049C25.0589 41.4601 25.0728 41.3736 25.0268 41.3123L24.9941 41.2681C24.9481 41.2062 24.8593 41.1927 24.7964 41.2374L24.525 41.4288C24.4746 41.3687 24.4224 41.3092 24.367 41.2522L24.5974 41.0197C24.6516 40.9651 24.6503 40.8773 24.5936 40.8246L24.5533 40.7865C24.4973 40.7338 24.4073 40.735 24.3531 40.7902L24.1214 41.0246C24.088 40.9964 24.054 40.9681 24.0188 40.9411C23.9898 40.9191 23.9602 40.8976 23.9306 40.8767L24.1151 40.608C24.1586 40.5448 24.1416 40.459 24.0761 40.4166L24.0295 40.386C23.9646 40.3436 23.8765 40.3602 23.833 40.424L23.6479 40.6933C23.5787 40.6534 23.5088 40.616 23.4376 40.5817L23.5705 40.2872C23.602 40.2173 23.5692 40.1363 23.4981 40.1056L23.4464 40.0835C23.3747 40.0528 23.2916 40.0847 23.2601 40.1541L23.1266 40.4504C23.0756 40.432 23.0246 40.4148 22.973 40.3988L23.0586 40.0884C23.0787 40.0148 23.034 39.9394 22.9585 39.9191L22.9043 39.905C22.8288 39.8854 22.7513 39.9289 22.7306 40.0025L22.6443 40.3154C22.565 40.2995 22.485 40.286 22.405 40.2761L22.4334 39.9553C22.4403 39.8792 22.3824 39.8124 22.3043 39.8062L22.2483 39.8013C22.1702 39.7946 22.1016 39.851 22.0953 39.9271L22.0669 40.251C21.9813 40.2492 21.8957 40.251 21.81 40.2553L21.7779 39.9326C21.7704 39.8565 21.7011 39.8013 21.623 39.8087L21.567 39.8142C21.4889 39.8216 21.4323 39.8891 21.4398 39.9651L21.4719 40.2903C21.3976 40.3019 21.3233 40.316 21.2497 40.3326L21.1609 40.0185C21.1401 39.9449 21.062 39.9019 20.9865 39.9222L20.9323 39.9369C20.8568 39.9571 20.8127 40.0332 20.8335 40.1068L20.9229 40.424C20.8373 40.4528 20.7523 40.4847 20.6692 40.5203L20.5212 40.2258C20.4866 40.1571 20.4022 40.1289 20.3317 40.1627L20.2813 40.1866C20.2108 40.2203 20.1818 40.3025 20.2165 40.3712L20.3657 40.6688C20.2964 40.7068 20.2291 40.7473 20.1623 40.7908L19.9627 40.5246C19.9168 40.4633 19.828 40.4498 19.765 40.4945L19.7197 40.5271C19.6567 40.5718 19.6429 40.6583 19.6888 40.7197L19.8909 40.989C19.8255 41.0424 19.7619 41.0994 19.7002 41.1583L19.4508 40.9289C19.3942 40.8767 19.3041 40.8792 19.2506 40.9344L19.2122 40.9743C19.1587 41.0295 19.1612 41.1172 19.2179 41.1693L19.4704 41.4018C19.4552 41.4196 19.4389 41.4374 19.4244 41.4558C19.3935 41.4939 19.3639 41.5325 19.335 41.5718L19.0334 41.3767C18.9679 41.3344 18.8804 41.3515 18.8369 41.4153L18.8061 41.4607C18.7627 41.5239 18.7803 41.6098 18.8458 41.6521L19.1505 41.8497C19.1171 41.9061 19.0856 41.9638 19.0561 42.0214L18.7224 41.8754C18.6512 41.8442 18.5675 41.8754 18.5354 41.9448L18.5121 41.9951C18.4799 42.0644 18.5121 42.146 18.5832 42.1773L18.9182 42.3233L18.9339 42.2895C18.8968 42.3828 18.8647 42.4772 18.8376 42.5723L18.8445 42.5441L18.4881 42.4582C18.4119 42.4398 18.3358 42.4852 18.3169 42.5588L18.3037 42.6122C18.2848 42.6864 18.3314 42.7613 18.4069 42.7791L18.7633 42.865L18.7897 42.7594C18.7677 42.86 18.7501 42.9607 18.7381 43.0625L18.3824 43.0361C18.3043 43.0306 18.2363 43.0876 18.2306 43.1631L18.2262 43.2177C18.2205 43.2938 18.2791 43.36 18.3565 43.3655L18.7161 43.3919C18.7148 43.4778 18.7161 43.5637 18.7224 43.6496L18.3698 43.687C18.2917 43.695 18.2357 43.7637 18.2445 43.8391L18.2508 43.8937C18.2589 43.9698 18.3295 44.0244 18.4069 44.0158L18.7639 43.9778C18.7765 44.0489 18.7916 44.1195 18.8092 44.1894L18.4629 44.2882C18.388 44.3097 18.3446 44.3863 18.3666 44.4593L18.3824 44.5121C18.4044 44.5851 18.4831 44.6274 18.558 44.606L18.9062 44.5072C18.9314 44.5765 18.9591 44.6446 18.9893 44.7121L18.6607 44.8679C18.5901 44.901 18.5612 44.9839 18.5952 45.0526L18.6197 45.1016C18.6537 45.1703 18.7387 45.1986 18.8092 45.1654L19.1392 45.0084L19.1285 44.9869C19.1694 45.0593 19.2141 45.1299 19.2613 45.1992L19.2575 45.1937L18.9597 45.4035C18.8961 45.4482 18.8823 45.5347 18.9282 45.5961L18.961 45.6403C19.0069 45.7022 19.0957 45.7157 19.1587 45.6709L19.4565 45.4611L19.4105 45.3992C19.4924 45.501 19.5805 45.5985 19.6769 45.6912L19.6133 45.6317L19.3583 45.8893C19.3041 45.9439 19.3054 46.0316 19.3621 46.0844L19.4024 46.1224C19.4584 46.1752 19.5484 46.174 19.6026 46.1187L19.8576 45.8611L19.7367 45.7476C19.8053 45.8108 19.8765 45.8721 19.952 45.9304C20.0206 45.9832 20.0905 46.0323 20.1623 46.0789L20.0509 46.0059L19.8462 46.3034C19.8028 46.3666 19.8198 46.4525 19.8853 46.4948L19.9319 46.5255C19.9967 46.5678 20.0849 46.5512 20.1283 46.4874L20.3329 46.1899L20.2316 46.1237C20.3292 46.1838 20.4286 46.2384 20.53 46.2881L20.3852 46.6083C20.3537 46.6782 20.3865 46.7592 20.4576 46.7899L20.5092 46.812C20.581 46.8426 20.6641 46.8107 20.6956 46.7414L20.841 46.4193C20.8914 46.4378 20.9424 46.4549 20.9934 46.4709L20.8996 46.8126C20.8795 46.8862 20.9242 46.9616 20.9997 46.9819L21.0539 46.996C21.1294 47.0156 21.2069 46.9721 21.2276 46.8985L21.3221 46.5549C21.402 46.5709 21.482 46.585 21.5626 46.5948L21.5324 46.9426C21.5255 47.0187 21.5834 47.0856 21.6615 47.0917L21.7175 47.0966C21.7956 47.1034 21.8642 47.0469 21.8705 46.9708L21.9013 46.6206C21.9819 46.6224 22.0625 46.6206 22.1431 46.6175L22.1777 46.9678C22.1853 47.0439 22.2546 47.0991 22.3326 47.0917L22.3887 47.0862C22.4667 47.0788 22.5234 47.0113 22.5159 46.9353L22.4812 46.5844C22.5618 46.5721 22.6424 46.5574 22.7217 46.5396L22.6972 46.5463L22.7948 46.8911C22.8156 46.9647 22.8936 47.0077 22.9692 46.9874L23.0233 46.9727C23.0989 46.9524 23.143 46.8764 23.1222 46.8028L23.0246 46.4574L22.9969 46.4647C23.0901 46.4353 23.1826 46.4022 23.2733 46.3641L23.4339 46.6831C23.4685 46.7518 23.5529 46.7801 23.6234 46.7463L23.6737 46.7224C23.7443 46.6887 23.7732 46.6065 23.7386 46.5377L23.578 46.2181C23.646 46.1813 23.7128 46.1414 23.7783 46.0997L23.9923 46.385C24.0383 46.4463 24.1271 46.4598 24.19 46.4151L24.2354 46.3825C24.2983 46.3378 24.3122 46.2513 24.2662 46.1899L24.0521 45.9047C24.1176 45.8525 24.1812 45.7979 24.2429 45.7402L24.5042 45.9807C24.5609 46.0329 24.6509 46.0304 24.7044 45.9752L24.7428 45.9353C24.7964 45.8801 24.7938 45.7924 24.7372 45.7402L24.4753 45.4992C24.4992 45.4715 24.5231 45.4446 24.5464 45.4163C24.5666 45.3912 24.5861 45.3654 24.6056 45.3403L24.904 45.5335C24.9689 45.5758 25.057 45.5587 25.1005 45.4949L25.1313 45.4495C25.1748 45.3863 25.1571 45.3004 25.0917 45.2581L24.7945 45.0661C24.8291 45.0096 24.8625 44.9526 24.8927 44.8943L25.2144 45.0348C25.2856 45.0661 25.3693 45.0348 25.4014 44.9654L25.4247 44.9151C25.4568 44.8458 25.4247 44.7642 25.3536 44.7329L25.0331 44.5931C25.0633 44.5176 25.0898 44.4415 25.1137 44.3649L25.4524 44.4465C25.5286 44.4649 25.6054 44.4195 25.6237 44.3458L25.6369 44.2925C25.6558 44.2182 25.6092 44.144 25.5337 44.1256L25.1955 44.0446C25.2088 43.9784 25.2207 43.9115 25.2295 43.8447L25.5733 43.8698C25.6514 43.8753 25.7194 43.8183 25.7251 43.7428L25.7295 43.6882C25.7351 43.6121 25.6766 43.5459 25.5991 43.5404L25.5985 43.5379ZM23.4099 41.6871C23.7795 41.973 24.0339 42.3478 24.1674 42.7551L23.6807 42.8472C23.6278 42.6877 23.556 42.549 23.4647 42.4319C23.3325 42.2625 23.1751 42.1448 22.9931 42.0797C22.8112 42.0141 22.621 42 22.4227 42.0374C22.1872 42.0816 22.0109 42.1699 21.8938 42.3012C21.7767 42.4325 21.7005 42.5772 21.6652 42.7349C21.6344 42.8748 21.6117 43.0441 21.5972 43.2404L21.0054 43.352C21.0117 43.3373 21.0167 43.3226 21.0249 43.3085C21.0816 43.2073 21.1691 43.1398 21.2862 43.106L21.103 42.1846C20.8832 42.2411 20.6956 42.3466 20.5395 42.5006C20.3839 42.6545 20.275 42.8447 20.2133 43.0717C20.1755 43.2109 20.1592 43.3576 20.1642 43.5115L19.7008 43.5993C19.6599 43.06 19.8185 42.5049 20.1906 42.0478C20.977 41.0822 22.4183 40.9215 23.4087 41.6877L23.4099 41.6871ZM22.8691 43.0005L22.4208 43.0852C22.4523 42.9846 22.5171 42.9251 22.6153 42.9067C22.6978 42.8913 22.7683 42.9079 22.8275 42.957C22.8426 42.9692 22.8565 42.984 22.8691 43.0005ZM21.5204 43.7901C21.4902 43.8876 21.4272 43.9459 21.3296 43.9643C21.2472 43.9796 21.1735 43.9606 21.1093 43.9066C21.0979 43.8968 21.0879 43.8851 21.0778 43.8735L21.5204 43.7901ZM20.5615 45.1826C20.1919 44.8967 19.9369 44.5219 19.8041 44.1146L20.2599 44.0287C20.3109 44.1821 20.3789 44.3189 20.4671 44.436C20.5949 44.606 20.7485 44.7262 20.9273 44.7961C21.1061 44.8661 21.2963 44.882 21.499 44.844C21.7376 44.7949 21.9171 44.7035 22.0386 44.5698C22.1595 44.4354 22.2382 44.2913 22.2735 44.1379C22.3049 44.0023 22.3307 43.8348 22.3509 43.6342L22.9006 43.5306C22.8458 43.6177 22.762 43.6802 22.6487 43.7158L22.82 44.5777C23.1681 44.4777 23.4276 44.298 23.5988 44.0373C23.7241 43.8459 23.7827 43.622 23.7751 43.3649L24.2706 43.2711C24.3116 43.8103 24.1529 44.3655 23.7808 44.8225C22.9944 45.7881 21.5532 45.9488 20.5628 45.1826H20.5615Z",
    fill: "#42A100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.18423 50.827C9.28938 50.8319 9.37941 50.7527 9.38445 50.6503C9.38949 50.5478 9.30826 50.4601 9.20312 50.4552L8.73216 50.4325C8.73279 50.3834 8.73467 50.3344 8.73467 50.2853C8.73467 50.265 8.73467 50.2448 8.73405 50.2246H9.19682C9.3026 50.2246 9.38823 50.1411 9.38823 50.0381C9.38823 49.935 9.3026 49.8516 9.19682 49.8516H8.72586C8.72271 49.7816 8.71956 49.7123 8.71516 49.643L9.17101 49.6185C9.27615 49.6129 9.35738 49.5252 9.35108 49.4221C9.34541 49.3197 9.25538 49.2406 9.1496 49.2461L8.68556 49.2712C8.67864 49.2019 8.67171 49.1332 8.66353 49.0645L9.10364 49.0412C9.20878 49.0357 9.29001 48.9479 9.28371 48.8449C9.27804 48.7424 9.18801 48.6633 9.08223 48.6694L8.61316 48.6946C8.60245 48.6253 8.59112 48.5566 8.57916 48.4878L9.03753 48.4063C9.14141 48.3878 9.21004 48.2909 9.19115 48.1897C9.17227 48.0885 9.07278 48.0216 8.9689 48.04L8.50864 48.1216C8.49542 48.0584 8.48156 47.9952 8.46708 47.932L8.89586 47.8388C8.99912 47.8161 9.06397 47.7167 9.04067 47.6161C9.01738 47.5155 8.91538 47.4523 8.81212 47.475L8.37579 47.5701C8.35816 47.5057 8.34053 47.4419 8.32227 47.3781L8.75923 47.2419C8.85997 47.2106 8.91538 47.1057 8.88264 47.0076C8.85053 46.9094 8.74286 46.8554 8.64212 46.8873L8.21145 47.0217C8.19005 46.9573 8.16864 46.8928 8.14597 46.829L8.58482 46.6745C8.68431 46.6395 8.7353 46.5327 8.70004 46.4358C8.66416 46.3389 8.5546 46.2892 8.45512 46.3236L8.01501 46.4781C7.97723 46.3812 7.93757 46.2849 7.89727 46.1892L7.93568 46.2659L8.36068 46.0634C8.45575 46.018 8.49479 45.9064 8.44819 45.8144C8.4016 45.7217 8.28701 45.6837 8.19257 45.7291L7.78016 45.926C7.7512 45.8635 7.72223 45.8009 7.69201 45.7395L8.07483 45.5193C8.16549 45.4672 8.19634 45.3531 8.1422 45.2641C8.08868 45.1758 7.97157 45.1457 7.88027 45.1985L7.52138 45.4046C7.48549 45.3365 7.44835 45.269 7.4112 45.2021L7.8129 45.0206C7.9086 44.977 7.95016 44.8666 7.90546 44.7733C7.86075 44.6801 7.74742 44.6396 7.65172 44.6832L7.22294 44.8776L7.22609 44.8844C7.16124 44.777 7.09513 44.6715 7.0265 44.5666L7.4049 44.3451C7.49557 44.2924 7.52453 44.1777 7.47038 44.0893C7.41624 44.001 7.2985 43.9728 7.20783 44.0255L6.81494 44.2556C6.76835 44.1893 6.72113 44.1237 6.67265 44.0587L7.02524 43.8065C7.11024 43.7458 7.1285 43.6292 7.06616 43.5464C7.00383 43.4636 6.8842 43.4458 6.7992 43.5065L6.44346 43.7605C6.39876 43.7047 6.35343 43.6489 6.30809 43.5936L6.64872 43.317C6.72994 43.2513 6.74065 43.1336 6.67328 43.0544C6.60591 42.9753 6.48502 42.9649 6.4038 43.0305L6.06317 43.3072C6.01595 43.2544 5.96872 43.2023 5.92087 43.1501L6.23757 42.8649C6.31502 42.7949 6.32005 42.6771 6.24828 42.6017C6.1765 42.5262 6.05561 42.5213 5.97817 42.5913L5.65958 42.8777C5.60921 42.8274 5.55884 42.7771 5.50721 42.7274L5.7962 42.4367C5.86987 42.363 5.86798 42.2446 5.79243 42.1735C5.71687 42.1017 5.59535 42.1036 5.52232 42.1772L5.23143 42.4692C5.17917 42.4219 5.12691 42.3753 5.07339 42.3293L5.34476 42.0563C5.41843 41.9827 5.41654 41.8643 5.34098 41.7931C5.26543 41.7214 5.14391 41.7232 5.07087 41.7968L4.78376 42.0851C4.7271 42.0391 4.66917 41.9937 4.61125 41.9483L4.85491 41.633C4.9185 41.5508 4.90151 41.4343 4.81714 41.3723C4.73277 41.3103 4.61314 41.3269 4.54954 41.4091L4.3084 41.7214C4.25425 41.6821 4.2001 41.6441 4.14532 41.606L4.35562 41.3097C4.41543 41.2251 4.39403 41.1091 4.30714 41.0509C4.22025 40.9926 4.10125 41.0134 4.04143 41.0981L3.83051 41.395C3.77195 41.357 3.71277 41.3195 3.65358 41.2827L3.83995 40.9619C3.89221 40.8723 3.85947 40.7588 3.76755 40.7079C3.67562 40.657 3.55914 40.6889 3.50688 40.7785L3.32618 41.0889C3.26573 41.0539 3.20403 41.0202 3.14296 40.9864L3.31673 40.6601C3.36522 40.5687 3.3287 40.4564 3.23488 40.4092C3.14107 40.3619 3.02585 40.3975 2.97737 40.4889L2.80611 40.8104C2.73433 40.7742 2.66192 40.7392 2.58951 40.7042L2.72614 40.3601C2.76455 40.2644 2.71544 40.1564 2.61722 40.119C2.519 40.0816 2.40818 40.1294 2.36977 40.2251L2.24259 40.5454C2.17648 40.5165 2.10974 40.4883 2.04237 40.4613L2.16074 40.0791C2.19096 39.9804 2.13366 39.8767 2.03292 39.8472C1.93155 39.8178 1.82515 39.8736 1.79493 39.9718L1.68663 40.3227C1.60856 40.2938 1.52985 40.2656 1.45052 40.238L1.57644 39.8301C1.60667 39.7313 1.54937 39.6276 1.44863 39.5982C1.34726 39.5687 1.24085 39.6246 1.21063 39.7227L1.08785 40.1196C1.01167 40.0963 0.935484 40.0736 0.85867 40.0521L0.955003 39.6012C0.97641 39.5006 0.910299 39.4019 0.80704 39.381C0.703782 39.3602 0.602412 39.4246 0.581004 39.5252L0.489708 39.9534C0.417301 39.9356 0.344265 39.9184 0.271228 39.9018L0.292006 39.4417C0.296413 39.3387 0.214561 39.2522 0.109414 39.2473C0.0691176 39.2454 0.0319696 39.2559 0.000488281 39.2755V40.5417C4.59614 41.5244 8.03579 45.5132 8.03579 50.2859C8.03579 51.2276 7.90168 52.1385 7.65172 53.0023H8.37705C8.40223 52.9097 8.4249 52.817 8.44756 52.7238L8.85493 52.8514C8.95567 52.8827 9.06334 52.8287 9.09545 52.7312C9.12756 52.633 9.07215 52.5281 8.97204 52.4968L8.52942 52.3582C8.55334 52.2385 8.57601 52.1183 8.59553 51.9981L9.02556 52.0852C9.12882 52.106 9.23019 52.0416 9.2516 51.941C9.27301 51.8404 9.20689 51.7416 9.10364 51.7208L8.64968 51.6288C8.65975 51.5496 8.66919 51.4699 8.67738 51.3895L9.1219 51.4386C9.22704 51.4502 9.32149 51.3766 9.33345 51.2742C9.34541 51.1717 9.26986 51.0797 9.16471 51.0681L8.71012 51.0178C8.71516 50.9472 8.7183 50.8767 8.72208 50.8061L9.18612 50.8288L9.18423 50.827Z",
    fill: "#42A100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.55713 18.1413L5.56343 18.2229L5.56154 18.3051L5.55776 18.4695L5.76868 18.4775L5.77309 18.3039L5.77435 18.2174L5.76805 18.1309L5.55713 18.1413Z",
    fill: "#42A100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.0456 11.0359H25.6176C24.5466 15.6105 20.3451 19.0238 15.3257 19.0238C10.8402 19.0238 7.00896 16.2982 5.4796 12.4543L8.59688 11.5353C8.8884 12.1825 9.25232 12.742 9.68991 13.2137C10.3239 13.8977 11.0461 14.3523 11.8552 14.5793C12.6643 14.805 13.4998 14.7916 14.3611 14.5382C15.3754 14.2223 16.1153 13.7462 16.5799 13.1107C17.044 12.4745 17.3191 11.815 17.4041 11.1304C17.4091 11.0881 17.4142 11.0445 17.4192 11.001H4.49486L4.5062 11.0366H3.55609C3.55609 11.0415 3.5542 11.0464 3.5542 11.0519C3.5542 11.1654 3.64864 11.258 3.76575 11.258H4.26694C4.27827 11.3059 4.29086 11.3531 4.30283 11.401L3.88601 11.4672C3.77079 11.4856 3.69272 11.5911 3.71161 11.7034C3.73049 11.8157 3.83879 11.8917 3.95401 11.8733L4.41175 11.8003C4.4256 11.8482 4.44008 11.8954 4.45457 11.9426L4.03649 12.0316C3.92253 12.0561 3.85012 12.1659 3.87531 12.277C3.90049 12.388 4.0132 12.4586 4.12716 12.434L4.58616 12.3365C4.60379 12.3868 4.62205 12.4365 4.64031 12.4862L4.22601 12.6046C4.11394 12.6365 4.04972 12.7512 4.08246 12.8604C4.1152 12.9696 4.23294 13.0321 4.34501 13.0002L4.79079 12.8733C4.80968 12.9193 4.82919 12.9647 4.84871 13.0101L4.47157 13.1555C4.36327 13.1972 4.30975 13.3168 4.35257 13.4229C4.39538 13.5284 4.51816 13.5806 4.62708 13.5389L5.01997 13.388C5.04579 13.4426 5.07223 13.4972 5.0993 13.5517L4.74734 13.7076C4.64094 13.7548 4.59371 13.8769 4.64219 13.9799C4.69068 14.0836 4.81597 14.1296 4.92238 14.0824L5.29071 13.9192C5.31841 13.9701 5.34675 14.021 5.37571 14.0713L5.01556 14.2738C4.91419 14.3308 4.87956 14.4566 4.93812 14.5554C4.99667 14.6541 5.12575 14.6879 5.22712 14.6308L5.58726 14.4284C5.61497 14.4738 5.6433 14.5192 5.67163 14.564L5.29701 14.7744C5.19564 14.8314 5.16101 14.9572 5.21956 15.056C5.27812 15.1547 5.40719 15.1885 5.50856 15.1314L5.90082 14.9106C5.93545 14.9609 5.97134 15.0106 6.0066 15.0602L5.64897 15.3013C5.55264 15.3658 5.52871 15.4946 5.59545 15.5878C5.66156 15.6811 5.79378 15.705 5.88949 15.64L6.25467 15.394C6.28993 15.4394 6.32519 15.4848 6.36108 15.5295L6.03619 15.7486C5.93986 15.813 5.91593 15.9418 5.98267 16.035C6.04878 16.1283 6.181 16.1522 6.27671 16.0872L6.62741 15.851C6.66204 15.8909 6.69667 15.9308 6.73193 15.97L6.42467 16.2246C6.33589 16.2982 6.32519 16.4283 6.40074 16.5148C6.4763 16.6013 6.60978 16.6117 6.69856 16.5381L7.014 16.2767C7.05493 16.3197 7.09648 16.3626 7.13804 16.405L6.84085 16.651C6.75207 16.7246 6.74137 16.8546 6.81693 16.9411C6.89248 17.0276 7.02596 17.038 7.11474 16.9644L7.43711 16.6976C7.47489 16.7332 7.51329 16.7687 7.5517 16.8037L7.27592 17.0724C7.19344 17.1528 7.19344 17.2834 7.27592 17.3638C7.35841 17.4442 7.49252 17.4442 7.575 17.3638L7.86588 17.0804C7.91059 17.1184 7.95529 17.1558 8.00062 17.1933L7.71163 17.4748C7.62914 17.5552 7.62914 17.6859 7.71163 17.7662C7.79411 17.8466 7.92822 17.8466 8.0107 17.7662L8.33055 17.4546C8.38281 17.4945 8.43507 17.5337 8.48859 17.573L8.24996 17.8337C8.17188 17.9184 8.18007 18.049 8.26696 18.1245C8.35385 18.2006 8.48796 18.1926 8.5654 18.1079L8.83299 17.8159C8.86951 17.8405 8.90603 17.865 8.94255 17.8895L8.71462 18.2061C8.64788 18.2993 8.67055 18.4275 8.76625 18.4932C8.86195 18.5588 8.99355 18.5361 9.06092 18.4429L9.29577 18.1159C9.33921 18.1423 9.38329 18.1687 9.42673 18.1944L9.21832 18.5465C9.15977 18.6453 9.1944 18.7711 9.29577 18.8281C9.39714 18.8852 9.52621 18.8514 9.58477 18.7527L9.79254 18.4024C9.83914 18.4282 9.88636 18.4533 9.93358 18.4785L9.76862 18.8324C9.72014 18.9361 9.76736 19.0582 9.87377 19.1048C9.98017 19.152 10.1055 19.106 10.1533 19.0024L10.3095 18.6674C10.3523 18.6883 10.3957 18.7079 10.4385 18.7281L10.3019 19.0938C10.2622 19.2005 10.3183 19.3189 10.4285 19.3575C10.538 19.3962 10.6595 19.3416 10.6992 19.2342L10.8245 18.8993C10.8837 18.9244 10.9429 18.949 11.0027 18.9729L10.878 19.3686C10.844 19.4772 10.9064 19.5925 11.0184 19.6256C11.1299 19.6588 11.2482 19.598 11.2822 19.4888L11.3975 19.122C11.451 19.141 11.5051 19.16 11.5586 19.1784L11.4447 19.5404C11.4107 19.6489 11.473 19.7643 11.5851 19.7974C11.6965 19.8305 11.8149 19.7698 11.8489 19.6606L11.9603 19.3072C12.012 19.3232 12.0642 19.3385 12.1165 19.3533L12.0529 19.7367C12.034 19.8489 12.1127 19.9544 12.2279 19.9728C12.3432 19.9906 12.4515 19.9146 12.4703 19.8023L12.5264 19.4624C12.5893 19.4778 12.6523 19.4931 12.7159 19.5072L12.651 19.8986C12.6328 20.0109 12.7109 20.1164 12.8261 20.1348C12.9413 20.1526 13.0496 20.0765 13.0685 19.9643L13.1296 19.5943C13.1888 19.6054 13.2473 19.6164 13.3065 19.6269L13.246 19.9937C13.2272 20.106 13.3059 20.2115 13.4211 20.2299C13.5363 20.2483 13.6446 20.1716 13.6635 20.0593L13.7239 19.6919C13.7793 19.6992 13.8354 19.7066 13.8914 19.714L13.8656 20.0937C13.858 20.2072 13.9462 20.3053 14.0627 20.3127C14.1792 20.3201 14.2799 20.2342 14.2875 20.1207L14.312 19.7581C14.3668 19.763 14.4222 19.7667 14.477 19.7704V20.171C14.477 20.2845 14.5714 20.3771 14.6885 20.3771C14.8056 20.3771 14.9001 20.2851 14.9001 20.171V19.7931C14.9681 19.7956 15.0367 19.798 15.1053 19.7992V20.1716C15.1053 20.2851 15.1998 20.3777 15.3169 20.3777C15.4334 20.3777 15.5284 20.2857 15.5284 20.1716V19.7999C15.5738 19.7992 15.6197 19.798 15.6651 19.7968L15.684 20.1814C15.6896 20.2949 15.7885 20.3826 15.905 20.3771C16.0214 20.3716 16.1115 20.2753 16.1058 20.1618L16.0869 19.7778C16.1612 19.7729 16.2355 19.7673 16.3092 19.7612L16.3256 20.0882C16.3312 20.2017 16.4301 20.2894 16.5466 20.2839C16.663 20.2783 16.7531 20.182 16.7474 20.0685L16.7304 19.7183C16.7789 19.7127 16.8267 19.7066 16.8752 19.7005L16.9319 20.0532C16.9501 20.1655 17.0584 20.2422 17.1737 20.2244C17.2889 20.2066 17.3676 20.1011 17.3493 19.9888L17.2927 19.6373C17.3563 19.6262 17.4198 19.6146 17.4834 19.6029L17.5615 19.9508C17.5867 20.0618 17.6994 20.1323 17.8134 20.1078C17.9273 20.0833 17.9997 19.9735 17.9745 19.8624L17.8971 19.517C17.9456 19.506 17.9934 19.4956 18.0419 19.4839L18.1395 19.8508C18.1691 19.9606 18.2843 20.0268 18.397 19.998C18.5097 19.9692 18.5777 19.8569 18.5488 19.7471L18.4505 19.3778C18.5097 19.3612 18.5689 19.344 18.6281 19.3269L18.7213 19.6772C18.7509 19.7876 18.8661 19.8532 18.9788 19.825C19.0915 19.7962 19.1595 19.6839 19.1305 19.5741L19.0311 19.2005C19.0884 19.1815 19.145 19.1619 19.2017 19.1422L19.2854 19.4557C19.315 19.5655 19.4302 19.6318 19.5429 19.6035C19.6563 19.5747 19.7236 19.4624 19.6947 19.3526L19.599 18.9938C19.6582 18.9705 19.7167 18.9465 19.7753 18.922L19.8968 19.2447C19.9371 19.3514 20.0586 19.4066 20.1682 19.3674C20.2777 19.3281 20.3344 19.2097 20.2941 19.103L20.1625 18.7533C20.2135 18.73 20.2645 18.7067 20.3149 18.6821L20.4622 18.9999C20.5101 19.1036 20.6353 19.1496 20.7418 19.103C20.8482 19.0563 20.8954 18.9343 20.8475 18.8306L20.6914 18.4932C20.7418 18.4668 20.7915 18.4398 20.8419 18.4128L20.998 18.7502C21.0459 18.8539 21.1712 18.8999 21.2776 18.8533C21.384 18.8067 21.4312 18.6846 21.3833 18.5809L21.2089 18.2049C21.2612 18.1742 21.3135 18.1429 21.3657 18.111L21.5584 18.4367C21.6169 18.5355 21.746 18.5692 21.8474 18.5122C21.9487 18.4551 21.9834 18.3294 21.9248 18.2306L21.7196 17.8846C21.758 17.8595 21.7958 17.8337 21.8335 17.8079L22.0495 18.1104C22.1162 18.2036 22.2478 18.2263 22.3435 18.1619C22.4392 18.0969 22.4632 17.9687 22.3964 17.8754L22.1754 17.5662C22.2296 17.5264 22.2831 17.4865 22.336 17.446L22.545 17.738C22.6117 17.8313 22.7433 17.8546 22.839 17.7895C22.9347 17.7245 22.958 17.5963 22.8919 17.5031L22.664 17.1847C22.7068 17.1497 22.749 17.1141 22.7912 17.0779L23.05 17.3534C23.1287 17.4374 23.2628 17.4429 23.3484 17.3662C23.434 17.2896 23.4403 17.1589 23.3616 17.0755L23.1041 16.8019C23.1419 16.7669 23.1803 16.7319 23.2174 16.697L23.4636 16.9589C23.5423 17.043 23.6764 17.0485 23.7621 16.9718C23.8483 16.8951 23.854 16.7644 23.7753 16.681L23.5159 16.405C23.5549 16.3657 23.5933 16.3258 23.6311 16.2859L23.8861 16.5344C23.9686 16.6148 24.1027 16.6148 24.1852 16.5344C24.2677 16.454 24.2677 16.3234 24.1852 16.243L23.9144 15.9792C23.9491 15.94 23.9837 15.9007 24.0177 15.8614L24.3281 16.1148C24.4175 16.1878 24.551 16.1767 24.6259 16.0896C24.7008 16.0025 24.6895 15.8725 24.5995 15.7995L24.2834 15.5412C24.3237 15.4909 24.3634 15.4406 24.4024 15.3903L24.7204 15.6498C24.8098 15.7228 24.9433 15.7117 25.0182 15.624C25.0931 15.5369 25.0818 15.4069 24.9917 15.3339L24.6511 15.0553C24.6857 15.0075 24.7197 14.959 24.7531 14.9106L25.0686 15.1124C25.1661 15.175 25.2971 15.1486 25.3613 15.0535C25.4255 14.9584 25.3985 14.8308 25.3009 14.7682L24.9823 14.5646C25.015 14.513 25.0471 14.4609 25.0793 14.4088L25.4142 14.5971C25.5156 14.6541 25.6447 14.6204 25.7032 14.5216C25.7618 14.4229 25.7271 14.2971 25.6258 14.2401L25.2896 14.0505C25.3141 14.0075 25.338 13.964 25.362 13.9204L25.7038 14.0904C25.8077 14.1419 25.9349 14.102 25.9884 14.0002C26.0413 13.899 26.0004 13.775 25.8959 13.7229L25.5527 13.5524C25.5741 13.5094 25.5949 13.4659 25.6157 13.4229L26.0615 13.572C26.1717 13.6088 26.2919 13.5517 26.3303 13.4438C26.3681 13.3364 26.3095 13.2193 26.1987 13.1824L25.7888 13.0456C25.8103 12.996 25.8317 12.9456 25.8524 12.8953L26.2365 13.0236C26.3467 13.0604 26.467 13.0033 26.5047 12.8953C26.5425 12.788 26.484 12.6708 26.3731 12.634L26.0029 12.5101C26.0212 12.4604 26.0394 12.4107 26.0577 12.3604L26.4462 12.4555C26.5595 12.4831 26.6741 12.4162 26.7024 12.3058C26.7308 12.1954 26.6621 12.0837 26.5488 12.0561L26.1893 11.9684C26.2063 11.915 26.222 11.861 26.2378 11.8071L26.6118 11.8985C26.7251 11.9261 26.8397 11.8592 26.868 11.7488C26.8964 11.6384 26.8277 11.5267 26.7144 11.4991L26.3467 11.4095C26.358 11.366 26.3694 11.3224 26.3794 11.2789L26.8315 11.347C26.9467 11.3641 27.055 11.2875 27.0727 11.1746C27.0802 11.1261 27.0689 11.0789 27.0456 11.0396V11.0359Z",
    fill: "#42A100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5864 11H20.4048L21.2693 12.0318C22.0336 11.4478 22.3214 11.3184 22.5858 11H22.5864Z",
    fill: "#42A100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0071 52.8986L10.8938 52.7876C10.9165 52.7483 10.9347 52.7072 10.9486 52.6631H11.1079C11.2011 52.6637 11.276 52.5907 11.2766 52.4999C11.2766 52.4097 11.2017 52.3361 11.1091 52.3355H10.9524C10.9398 52.2901 10.9221 52.2471 10.9001 52.2067L11.0103 52.0999C11.0764 52.0361 11.0764 51.9324 11.0103 51.868C10.9448 51.8036 10.8384 51.8036 10.7723 51.8674L10.6634 51.9729C10.6218 51.9496 10.5765 51.9312 10.5292 51.9183V51.7693C10.5292 51.6785 10.4537 51.6055 10.3611 51.6055C10.2686 51.6055 10.193 51.6791 10.193 51.7693V51.9183C10.1471 51.9312 10.103 51.949 10.0621 51.9711L9.95377 51.865C9.88829 51.8005 9.78188 51.8005 9.71577 51.8643C9.64966 51.9281 9.64966 52.0318 9.71577 52.0962L9.82532 52.2036C9.80266 52.2435 9.78503 52.2864 9.77181 52.3318H9.61503C9.52184 52.3312 9.44692 52.4042 9.44629 52.495C9.44629 52.5858 9.52121 52.6588 9.61377 52.6594H9.77307C9.78629 52.7036 9.80392 52.7453 9.82658 52.7845L9.71262 52.895C9.6824 52.9244 9.66666 52.9618 9.66414 53.0005H11.055C11.0518 52.9631 11.0367 52.9269 11.0071 52.8986ZM10.3611 52.833C10.1691 52.833 10.013 52.6809 10.013 52.4938C10.013 52.3067 10.1691 52.1545 10.3611 52.1545C10.5532 52.1545 10.7093 52.3067 10.7093 52.4938C10.7093 52.6809 10.5532 52.833 10.3611 52.833Z",
    fill: "url(#paint246_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1633 47.6855C18.14 47.699 18.118 47.7149 18.0953 47.729L17.96 47.818L18.0708 47.9726L18.1992 47.8886C18.2206 47.8751 18.2414 47.8597 18.2634 47.8468L18.3314 47.8113L18.2357 47.6475L18.164 47.6855H18.1633Z",
    fill: "url(#paint247_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6268 48.0719C17.606 48.0891 17.584 48.1051 17.5651 48.1241L17.5078 48.1811L17.6426 48.3167L17.6967 48.2627C17.715 48.2449 17.7357 48.2302 17.7553 48.2136L17.8743 48.1173L17.7521 47.9707L17.6262 48.0725L17.6268 48.0719Z",
    fill: "url(#paint248_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8313 47.1852C19.8042 47.1864 19.7772 47.1907 19.7501 47.1932L19.5876 47.2103L19.6116 47.3974L19.7658 47.3815C19.7916 47.379 19.8168 47.3754 19.8426 47.3741H19.9201L19.9132 47.1846L19.8313 47.1858V47.1852Z",
    fill: "url(#paint249_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1713 47.2825C19.1172 47.2911 19.0668 47.312 19.0139 47.3255L19.0681 47.5064C19.1178 47.4929 19.1657 47.4733 19.2167 47.4653L19.3684 47.4353L19.3306 47.25L19.1707 47.2819L19.1713 47.2825Z",
    fill: "url(#paint250_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4675 47.5256L18.5513 47.6962L18.8365 47.5796L18.7691 47.4023L18.4675 47.5256Z",
    fill: "url(#paint251_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4713 47.4665L21.319 47.4082L21.251 47.5849L21.3952 47.6401C21.4191 47.6493 21.4436 47.6579 21.4669 47.6683L21.5356 47.7027L21.6199 47.5327L21.5469 47.4965C21.5223 47.4855 21.4965 47.4769 21.4713 47.4665Z",
    fill: "url(#paint252_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7183 47.4362C20.8209 47.4497 20.9191 47.4823 21.0186 47.5086L21.0734 47.3277C20.9682 47.2994 20.8643 47.2657 20.756 47.251L20.7183 47.4362Z",
    fill: "url(#paint253_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1694 47.3706L20.4779 47.3957L20.5025 47.208L20.177 47.1816L20.1694 47.3706Z",
    fill: "url(#paint254_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9668 48.6126C22.8988 48.5298 22.8283 48.4488 22.7584 48.3672L22.6143 48.4929C22.6797 48.5709 22.7471 48.6469 22.8113 48.7254L22.9668 48.6126Z",
    fill: "url(#paint255_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3333 47.9746L22.2112 48.1212L22.3321 48.2157L22.4423 48.3218L22.5776 48.1863L22.4605 48.0746L22.3333 47.9746Z",
    fill: "url(#paint256_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7578 47.8132L22.0178 47.9764L22.1293 47.8218C22.0374 47.7641 21.9467 47.7059 21.8541 47.6494L21.7578 47.8132Z",
    fill: "url(#paint257_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.451 50.2099L23.6424 50.1804L23.5763 49.8682L23.3887 49.9142L23.451 50.2099Z",
    fill: "url(#paint258_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3181 49.6845L23.5025 49.6257C23.4748 49.5226 23.4282 49.4263 23.3867 49.3281L23.2085 49.4024C23.2475 49.4956 23.2916 49.5864 23.3181 49.6839V49.6845Z",
    fill: "url(#paint259_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9944 48.9896L23.0309 49.0559L23.1046 49.1884L23.2764 49.1019L23.199 48.9614L23.16 48.8914L23.114 48.8252L22.9509 48.927L22.9944 48.9896Z",
    fill: "url(#paint260_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3098 51.8136L23.493 51.8743L23.5831 51.5676L23.3948 51.5234L23.3098 51.8136Z",
    fill: "url(#paint261_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4655 51.1399C23.4636 51.1902 23.4491 51.2393 23.4409 51.289L23.6323 51.3203C23.6405 51.2681 23.6556 51.216 23.6575 51.1632L23.6714 51.0043L23.4781 50.9902L23.4655 51.1405V51.1399Z",
    fill: "url(#paint262_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4862 50.5263C23.4875 50.5515 23.4868 50.5766 23.4875 50.6018L23.4894 50.7527L23.6833 50.7539L23.6814 50.5944C23.6814 50.5681 23.6814 50.5411 23.6801 50.5147L23.6713 50.4355L23.478 50.4515L23.4862 50.5263Z",
    fill: "url(#paint263_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5851 52.9996H22.689L22.6323 52.9512C22.6166 52.9677 22.6008 52.9837 22.5845 52.9996H22.5851Z",
    fill: "url(#paint264_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7861 52.7651L22.9404 52.8792C23.0128 52.7994 23.0651 52.7049 23.1261 52.6172L22.9618 52.5166C22.9039 52.5994 22.8548 52.689 22.7861 52.7644V52.7651Z",
    fill: "url(#paint265_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1904 52.11C23.1797 52.1327 23.1671 52.1548 23.1557 52.1775L23.0852 52.3118L23.2565 52.4008L23.3314 52.259C23.3434 52.2351 23.3566 52.2118 23.3679 52.1879L23.3981 52.1137L23.2193 52.04L23.191 52.11H23.1904Z",
    fill: "url(#paint266_linear_4217_57369)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9312 48.9591L17.7736 48.6242L17.0382 48.085L16.9312 48.9591Z",
    fill: "url(#paint267_linear_4217_57369)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4217_57369",
    x1: 26.0581,
    y1: 18.6943,
    x2: 30.881,
    y2: 18.6943,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4217_57369",
    x1: 28.6321,
    y1: 14.8291,
    x2: 28.292,
    y2: 23.4845,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4217_57369",
    x1: 22.2383,
    y1: 19.2832,
    x2: 23.7129,
    y2: 19.2832,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4217_57369",
    x1: 13.8492,
    y1: 21.7367,
    x2: 15.3238,
    y2: 21.7367,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_4217_57369",
    x1: 10.1903,
    y1: 21.3353,
    x2: 11.6655,
    y2: 21.3353,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_4217_57369",
    x1: 26.6068,
    y1: 13.5674,
    x2: 28.0814,
    y2: 13.5674,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_4217_57369",
    x1: 22.2383,
    y1: 14.2148,
    x2: 23.7129,
    y2: 14.2148,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_4217_57369",
    x1: 16.6692,
    y1: 45.2123,
    x2: 18.4491,
    y2: 45.2123,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_4217_57369",
    x1: 8.92686,
    y1: 46.5742,
    x2: 10.4021,
    y2: 46.5742,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_4217_57369",
    x1: 2.96484,
    y1: 43.5029,
    x2: 4.43943,
    y2: 43.5029,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_4217_57369",
    x1: 2.38496,
    y1: 46.5541,
    x2: 6.43346,
    y2: 46.5541,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_4217_57369",
    x1: 4.98643,
    y1: 28.8229,
    x2: 7.45079,
    y2: 28.8229,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_4217_57369",
    x1: 6.85977,
    y1: 33.3757,
    x2: 9.09936,
    y2: 33.3757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_4217_57369",
    x1: 6.35285,
    y1: 19.1819,
    x2: 8.50554,
    y2: 19.1819,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_4217_57369",
    x1: 3.78656,
    y1: 40.0068,
    x2: 5.61815,
    y2: 40.0068,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_4217_57369",
    x1: 5.99823,
    y1: 48.618,
    x2: 7.25434,
    y2: 48.618,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_4217_57369",
    x1: 4.42489,
    y1: 23.8905,
    x2: 10.2489,
    y2: 23.8905,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_4217_57369",
    x1: 7.38738,
    y1: 24.2465,
    x2: 8.85126,
    y2: 24.2465,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_4217_57369",
    x1: 6.45668,
    y1: 24.7066,
    x2: 7.32179,
    y2: 24.7066,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_4217_57369",
    x1: 10.766,
    y1: 23.5328,
    x2: 14.5696,
    y2: 23.5328,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_4217_57369",
    x1: 5.06215,
    y1: 20.0592,
    x2: 5.40845,
    y2: 20.0592,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_4217_57369",
    x1: 5.32153,
    y1: 19.5026,
    x2: 5.63068,
    y2: 19.5026,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_4217_57369",
    x1: 5.48668,
    y1: 18.9162,
    x2: 5.74734,
    y2: 18.9162,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_4217_57369",
    x1: 3.8186,
    y1: 21.4124,
    x2: 4.22345,
    y2: 21.4124,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_4217_57369",
    x1: 4.30151,
    y1: 21.0287,
    x2: 4.69818,
    y2: 21.0287,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_4217_57369",
    x1: 4.71851,
    y1: 20.5758,
    x2: 5.09376,
    y2: 20.5758,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_4217_57369",
    x1: 2.11426,
    y1: 22.0589,
    x2: 2.48448,
    y2: 22.0589,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_4217_57369",
    x1: 2.71045,
    y1: 21.938,
    x2: 3.10334,
    y2: 21.938,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_4217_57369",
    x1: 3.28149,
    y1: 21.72,
    x2: 3.68446,
    y2: 21.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_4217_57369",
    x1: 0.256245,
    y1: 21.8567,
    x2: 0.654169,
    y2: 21.8567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_4217_57369",
    x1: 0.862061,
    y1: 22.0185,
    x2: 1.24236,
    y2: 22.0185,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_4217_57369",
    x1: 1.48901,
    y1: 22.0894,
    x2: 1.84538,
    y2: 22.0894,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_4217_57369",
    x1: 5.479,
    y1: 17.6981,
    x2: 5.74597,
    y2: 17.6981,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_4217_57369",
    x1: 5.30336,
    y1: 17.1141,
    x2: 5.6144,
    y2: 17.1141,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_4217_57369",
    x1: 4.8148,
    y1: 16.3223,
    x2: 5.45891,
    y2: 16.3223,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_4217_57369",
    x1: 5.99072,
    y1: 26.978,
    x2: 6.3408,
    y2: 26.978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_4217_57369",
    x1: 6.52295,
    y1: 27.1207,
    x2: 6.85728,
    y2: 27.1207,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_4217_57369",
    x1: 4.65479,
    y1: 26.0895,
    x2: 4.99667,
    y2: 26.0895,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_4217_57369",
    x1: 5.04443,
    y1: 26.4548,
    x2: 5.39702,
    y2: 26.4548,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_4217_57369",
    x1: 5.48975,
    y1: 26.7547,
    x2: 5.84549,
    y2: 26.7547,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_4217_57369",
    x1: 3.93569,
    y1: 24.6959,
    x2: 4.19069,
    y2: 24.6959,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_4217_57369",
    x1: 4.09312,
    y1: 25.1978,
    x2: 4.38401,
    y2: 25.1978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_4217_57369",
    x1: 4.33105,
    y1: 25.6664,
    x2: 4.65091,
    y2: 25.6664,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_4217_57369",
    x1: 3.92554,
    y1: 23.1061,
    x2: 4.17487,
    y2: 23.1061,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_4217_57369",
    x1: 3.86719,
    y1: 23.6312,
    x2: 4.07433,
    y2: 23.6312,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_4217_57369",
    x1: 3.86583,
    y1: 24.1689,
    x2: 4.07486,
    y2: 24.1689,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_4217_57369",
    x1: 4.62378,
    y1: 21.7011,
    x2: 4.96315,
    y2: 21.7011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_4217_57369",
    x1: 4.31226,
    y1: 22.1287,
    x2: 4.63022,
    y2: 22.1287,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_4217_57369",
    x1: 4.07739,
    y1: 22.5979,
    x2: 4.36639,
    y2: 22.5979,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_4217_57369",
    x1: 5.94727,
    y1: 20.7943,
    x2: 6.29734,
    y2: 20.7943,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_4217_57369",
    x1: 5.45508,
    y1: 21.0284,
    x2: 5.81145,
    y2: 21.0284,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_4217_57369",
    x1: 5.01172,
    y1: 21.3308,
    x2: 5.36494,
    y2: 21.3308,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_4217_57369",
    x1: 7.57935,
    y1: 20.5956,
    x2: 7.90297,
    y2: 20.5956,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_4217_57369",
    x1: 7.0316,
    y1: 20.5794,
    x2: 7.34452,
    y2: 20.5794,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_4217_57369",
    x1: 6.4813,
    y1: 20.6457,
    x2: 6.81753,
    y2: 20.6457,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_4217_57369",
    x1: 9.08423,
    y1: 21.1456,
    x2: 9.43934,
    y2: 21.1456,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_4217_57369",
    x1: 8.61133,
    y1: 20.8824,
    x2: 8.96644,
    y2: 20.8824,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_4217_57369",
    x1: 8.10767,
    y1: 20.7018,
    x2: 8.45081,
    y2: 20.7018,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_4217_57369",
    x1: 9.88501,
    y1: 21.8745,
    x2: 10.2175,
    y2: 21.8745,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_4217_57369",
    x1: 9.51367,
    y1: 21.4819,
    x2: 9.86186,
    y2: 21.4819,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_4217_57369",
    x1: 7.02148,
    y1: 27.2126,
    x2: 7.772,
    y2: 27.2126,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_4217_57369",
    x1: 32.0752,
    y1: 14.494,
    x2: 32.4838,
    y2: 14.494,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_4217_57369",
    x1: 32.7332,
    y1: 14.3596,
    x2: 33.1663,
    y2: 14.3596,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_4217_57369",
    x1: 30.0237,
    y1: 14.2692,
    x2: 30.4632,
    y2: 14.2692,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_4217_57369",
    x1: 30.6924,
    y1: 14.449,
    x2: 31.1123,
    y2: 14.449,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_4217_57369",
    x1: 31.385,
    y1: 14.5266,
    x2: 31.7779,
    y2: 14.5266,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_4217_57369",
    x1: 28.3452,
    y1: 13.1542,
    x2: 28.7746,
    y2: 13.1542,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_4217_57369",
    x1: 28.8345,
    y1: 13.6118,
    x2: 29.2784,
    y2: 13.6118,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_4217_57369",
    x1: 29.394,
    y1: 13.9893,
    x2: 29.8411,
    y2: 13.9893,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_4217_57369",
    x1: 27.4417,
    y1: 11.4023,
    x2: 27.7615,
    y2: 11.4023,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_4217_57369",
    x1: 27.64,
    y1: 12.0336,
    x2: 28.0052,
    y2: 12.0336,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_4217_57369",
    x1: 27.9385,
    y1: 12.6223,
    x2: 28.3408,
    y2: 12.6223,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_4217_57369",
    x1: 33.3632,
    y1: 14.0223,
    x2: 34.3876,
    y2: 14.0223,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear_4217_57369",
    x1: 33.6409,
    y1: 17.4844,
    x2: 33.9097,
    y2: 17.4844,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear_4217_57369",
    x1: 33.7319,
    y1: 18.1418,
    x2: 34.0543,
    y2: 18.1418,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear_4217_57369",
    x1: 33.8818,
    y1: 15.5083,
    x2: 34.2401,
    y2: 15.5083,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear_4217_57369",
    x1: 33.7024,
    y1: 16.1446,
    x2: 34.0141,
    y2: 16.1446,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint77_linear_4217_57369",
    x1: 33.6326,
    y1: 16.8032,
    x2: 33.8869,
    y2: 16.8032,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint78_linear_4217_57369",
    x1: 35.0316,
    y1: 13.8994,
    x2: 35.4736,
    y2: 13.8994,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint79_linear_4217_57369",
    x1: 34.5562,
    y1: 14.37,
    x2: 34.9818,
    y2: 14.37,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint80_linear_4217_57369",
    x1: 34.1665,
    y1: 14.9063,
    x2: 34.5657,
    y2: 14.9063,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint81_linear_4217_57369",
    x1: 35.5862,
    y1: 13.5051,
    x2: 36.0345,
    y2: 13.5051,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint82_linear_4217_57369",
    x1: 33.8152,
    y1: 19.0573,
    x2: 34.594,
    y2: 19.0573,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint83_linear_4217_57369",
    x1: 3.3689,
    y1: 36.542,
    x2: 3.75801,
    y2: 36.542,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint84_linear_4217_57369",
    x1: 3.67236,
    y1: 35.9352,
    x2: 4.02118,
    y2: 35.9352,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint85_linear_4217_57369",
    x1: 1.95996,
    y1: 38.0006,
    x2: 2.407,
    y2: 38.0006,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint86_linear_4217_57369",
    x1: 2.50132,
    y1: 37.5891,
    x2: 2.9408,
    y2: 37.5891,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint87_linear_4217_57369",
    x1: 2.97681,
    y1: 37.1025,
    x2: 3.39425,
    y2: 37.1025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint88_linear_4217_57369",
    x1: 0.0615234,
    y1: 38.6639,
    x2: 0.465114,
    y2: 38.6639,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint89_linear_4217_57369",
    x1: 0.721924,
    y1: 38.5447,
    x2: 1.15133,
    y2: 38.5447,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint90_linear_4217_57369",
    x1: 1.35864,
    y1: 38.3266,
    x2: 1.80379,
    y2: 38.3266,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint91_linear_4217_57369",
    x1: 3.64673,
    y1: 34.9333,
    x2: 4.52758,
    y2: 34.9333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint92_linear_4217_57369",
    x1: 9.79999,
    y1: 49.1463,
    x2: 15.9716,
    y2: 49.1463,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint93_linear_4217_57369",
    x1: 11.3708,
    y1: 49.1459,
    x2: 14.4,
    y2: 49.1459,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint94_linear_4217_57369",
    x1: 16.7177,
    y1: 14.6771,
    x2: 22.1344,
    y2: 14.6771,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint95_linear_4217_57369",
    x1: 23.0959,
    y1: 18.0828,
    x2: 23.3711,
    y2: 18.0828,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint96_linear_4217_57369",
    x1: 23.4333,
    y1: 18.0832,
    x2: 23.7085,
    y2: 18.0832,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint97_linear_4217_57369",
    x1: 15.4943,
    y1: 20.9754,
    x2: 15.9911,
    y2: 20.9754,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint98_linear_4217_57369",
    x1: 15.6077,
    y1: 20.8659,
    x2: 16.1051,
    y2: 20.8659,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint99_linear_4217_57369",
    x1: 10.434,
    y1: 24.9761,
    x2: 10.9358,
    y2: 24.9761,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint100_linear_4217_57369",
    x1: 10.5429,
    y1: 25.0904,
    x2: 11.0447,
    y2: 25.0904,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint101_linear_4217_57369",
    x1: 7.11394,
    y1: 49.7687,
    x2: 7.61071,
    y2: 49.7687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint102_linear_4217_57369",
    x1: 7.22778,
    y1: 49.6599,
    x2: 7.72456,
    y2: 49.6599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint103_linear_4217_57369",
    x1: 14.9164,
    y1: 46.2646,
    x2: 16.3816,
    y2: 46.2646,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint104_linear_4217_57369",
    x1: 26.395,
    y1: 24.7153,
    x2: 29.2151,
    y2: 24.7153,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint105_linear_4217_57369",
    x1: 14.6067,
    y1: 17.3716,
    x2: 17.4268,
    y2: 17.3716,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint106_linear_4217_57369",
    x1: 7.47036,
    y1: 14.975,
    x2: 9.57142,
    y2: 14.975,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint107_linear_4217_57369",
    x1: 14.458,
    y1: 33.1254,
    x2: 15.8621,
    y2: 33.1254,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint108_linear_4217_57369",
    x1: 16.6775,
    y1: 50.0689,
    x2: 18.5582,
    y2: 50.0689,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint109_linear_4217_57369",
    x1: 26.4858,
    y1: 27.0184,
    x2: 26.591,
    y2: 27.0184,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint110_linear_4217_57369",
    x1: 26.4858,
    y1: 26.7219,
    x2: 26.591,
    y2: 26.7219,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint111_linear_4217_57369",
    x1: 26.4858,
    y1: 26.4269,
    x2: 26.591,
    y2: 26.4269,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint112_linear_4217_57369",
    x1: 26.4858,
    y1: 27.908,
    x2: 26.591,
    y2: 27.908,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint113_linear_4217_57369",
    x1: 26.4858,
    y1: 27.6111,
    x2: 26.591,
    y2: 27.6111,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint114_linear_4217_57369",
    x1: 26.4858,
    y1: 27.3162,
    x2: 26.591,
    y2: 27.3162,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint115_linear_4217_57369",
    x1: 26.4858,
    y1: 28.7977,
    x2: 26.591,
    y2: 28.7977,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint116_linear_4217_57369",
    x1: 26.4858,
    y1: 28.5008,
    x2: 26.591,
    y2: 28.5008,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint117_linear_4217_57369",
    x1: 26.4858,
    y1: 28.2059,
    x2: 26.591,
    y2: 28.2059,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint118_linear_4217_57369",
    x1: 26.4858,
    y1: 29.6867,
    x2: 26.591,
    y2: 29.6867,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint119_linear_4217_57369",
    x1: 26.4858,
    y1: 29.3904,
    x2: 26.591,
    y2: 29.3904,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint120_linear_4217_57369",
    x1: 26.4858,
    y1: 29.0955,
    x2: 26.591,
    y2: 29.0955,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint121_linear_4217_57369",
    x1: 26.4858,
    y1: 30.2801,
    x2: 26.591,
    y2: 30.2801,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint122_linear_4217_57369",
    x1: 26.4858,
    y1: 29.9845,
    x2: 26.591,
    y2: 29.9845,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint123_linear_4217_57369",
    x1: 26.0281,
    y1: 31.0072,
    x2: 27.0487,
    y2: 31.0072,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint124_linear_4217_57369",
    x1: 16.7213,
    y1: 31.7727,
    x2: 16.8919,
    y2: 31.7727,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint125_linear_4217_57369",
    x1: 16.4175,
    y1: 31.7744,
    x2: 16.5875,
    y2: 31.7744,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint126_linear_4217_57369",
    x1: 16.1139,
    y1: 31.7768,
    x2: 16.2845,
    y2: 31.7768,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint127_linear_4217_57369",
    x1: 17.6342,
    y1: 31.764,
    x2: 17.8048,
    y2: 31.764,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint128_linear_4217_57369",
    x1: 17.3303,
    y1: 31.7664,
    x2: 17.5009,
    y2: 31.7664,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint129_linear_4217_57369",
    x1: 17.0275,
    y1: 31.7691,
    x2: 17.1981,
    y2: 31.7691,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint130_linear_4217_57369",
    x1: 18.5472,
    y1: 31.7563,
    x2: 18.7172,
    y2: 31.7563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint131_linear_4217_57369",
    x1: 18.2432,
    y1: 31.7584,
    x2: 18.4138,
    y2: 31.7584,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint132_linear_4217_57369",
    x1: 17.9404,
    y1: 31.7607,
    x2: 18.111,
    y2: 31.7607,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint133_linear_4217_57369",
    x1: 19.4595,
    y1: 31.748,
    x2: 19.6301,
    y2: 31.748,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint134_linear_4217_57369",
    x1: 19.156,
    y1: 31.751,
    x2: 19.326,
    y2: 31.751,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint135_linear_4217_57369",
    x1: 18.8532,
    y1: 31.753,
    x2: 19.0232,
    y2: 31.753,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint136_linear_4217_57369",
    x1: 20.0684,
    y1: 31.743,
    x2: 20.2384,
    y2: 31.743,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint137_linear_4217_57369",
    x1: 19.7654,
    y1: 31.7448,
    x2: 19.9354,
    y2: 31.7448,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint138_linear_4217_57369",
    x1: 20.3721,
    y1: 31.7391,
    x2: 21.4286,
    y2: 31.7391,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint139_linear_4217_57369",
    x1: 16.5249,
    y1: 30.5706,
    x2: 16.5998,
    y2: 30.5706,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint140_linear_4217_57369",
    x1: 16.5249,
    y1: 30.3591,
    x2: 16.5998,
    y2: 30.3591,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint141_linear_4217_57369",
    x1: 16.5249,
    y1: 30.1497,
    x2: 16.5998,
    y2: 30.1497,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint142_linear_4217_57369",
    x1: 16.5249,
    y1: 31.2034,
    x2: 16.5998,
    y2: 31.2034,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint143_linear_4217_57369",
    x1: 16.5249,
    y1: 30.9925,
    x2: 16.5998,
    y2: 30.9925,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint144_linear_4217_57369",
    x1: 16.5249,
    y1: 30.7825,
    x2: 16.5998,
    y2: 30.7825,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint145_linear_4217_57369",
    x1: 16.5249,
    y1: 31.8372,
    x2: 16.5998,
    y2: 31.8372,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint146_linear_4217_57369",
    x1: 16.5249,
    y1: 31.6253,
    x2: 16.5998,
    y2: 31.6253,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint147_linear_4217_57369",
    x1: 16.5249,
    y1: 31.4163,
    x2: 16.5998,
    y2: 31.4163,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint148_linear_4217_57369",
    x1: 16.5249,
    y1: 32.4694,
    x2: 16.5998,
    y2: 32.4694,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint149_linear_4217_57369",
    x1: 16.5249,
    y1: 32.2591,
    x2: 16.5998,
    y2: 32.2591,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint150_linear_4217_57369",
    x1: 16.5249,
    y1: 32.0491,
    x2: 16.5998,
    y2: 32.0491,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint151_linear_4217_57369",
    x1: 16.5249,
    y1: 32.8919,
    x2: 16.5998,
    y2: 32.8919,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint152_linear_4217_57369",
    x1: 16.5249,
    y1: 32.6813,
    x2: 16.5998,
    y2: 32.6813,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint153_linear_4217_57369",
    x1: 16.1995,
    y1: 33.4092,
    x2: 16.9261,
    y2: 33.4092,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint154_linear_4217_57369",
    x1: 3.50879,
    y1: 23.132,
    x2: 3.61457,
    y2: 23.132,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint155_linear_4217_57369",
    x1: 3.50879,
    y1: 22.8351,
    x2: 3.61457,
    y2: 22.8351,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint156_linear_4217_57369",
    x1: 3.50879,
    y1: 22.5402,
    x2: 3.61457,
    y2: 22.5402,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint157_linear_4217_57369",
    x1: 3.50879,
    y1: 24.0213,
    x2: 3.61457,
    y2: 24.0213,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint158_linear_4217_57369",
    x1: 3.50879,
    y1: 23.7248,
    x2: 3.61457,
    y2: 23.7248,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint159_linear_4217_57369",
    x1: 3.50879,
    y1: 23.4299,
    x2: 3.61457,
    y2: 23.4299,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint160_linear_4217_57369",
    x1: 3.50879,
    y1: 24.9109,
    x2: 3.61457,
    y2: 24.9109,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint161_linear_4217_57369",
    x1: 3.50879,
    y1: 24.6144,
    x2: 3.61457,
    y2: 24.6144,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint162_linear_4217_57369",
    x1: 3.50879,
    y1: 24.3191,
    x2: 3.61457,
    y2: 24.3191,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint163_linear_4217_57369",
    x1: 3.50879,
    y1: 25.8006,
    x2: 3.61457,
    y2: 25.8006,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint164_linear_4217_57369",
    x1: 3.50879,
    y1: 25.5037,
    x2: 3.61457,
    y2: 25.5037,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint165_linear_4217_57369",
    x1: 3.50879,
    y1: 25.2088,
    x2: 3.61457,
    y2: 25.2088,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint166_linear_4217_57369",
    x1: 3.50879,
    y1: 26.3934,
    x2: 3.61457,
    y2: 26.3934,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint167_linear_4217_57369",
    x1: 3.50879,
    y1: 26.0984,
    x2: 3.61457,
    y2: 26.0984,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint168_linear_4217_57369",
    x1: 3.05176,
    y1: 27.1205,
    x2: 4.07238,
    y2: 27.1205,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint169_linear_4217_57369",
    x1: 13.9677,
    y1: 52.3152,
    x2: 14.086,
    y2: 52.3152,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint170_linear_4217_57369",
    x1: 13.7512,
    y1: 52.3132,
    x2: 13.8702,
    y2: 52.3132,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint171_linear_4217_57369",
    x1: 13.5429,
    y1: 52.315,
    x2: 13.6612,
    y2: 52.315,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint172_linear_4217_57369",
    x1: 14.6052,
    y1: 52.3173,
    x2: 14.7236,
    y2: 52.3173,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint173_linear_4217_57369",
    x1: 14.3933,
    y1: 52.3169,
    x2: 14.5117,
    y2: 52.3169,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint174_linear_4217_57369",
    x1: 14.1818,
    y1: 52.3162,
    x2: 14.3002,
    y2: 52.3162,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint175_linear_4217_57369",
    x1: 15.2437,
    y1: 52.3201,
    x2: 15.3627,
    y2: 52.3201,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint176_linear_4217_57369",
    x1: 15.0315,
    y1: 52.3194,
    x2: 15.1499,
    y2: 52.3194,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint177_linear_4217_57369",
    x1: 14.8187,
    y1: 52.3184,
    x2: 14.9377,
    y2: 52.3184,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint178_linear_4217_57369",
    x1: 15.8818,
    y1: 52.3207,
    x2: 16.0008,
    y2: 52.3207,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint179_linear_4217_57369",
    x1: 15.6703,
    y1: 52.32,
    x2: 15.7887,
    y2: 52.32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint180_linear_4217_57369",
    x1: 15.4575,
    y1: 52.3196,
    x2: 15.5765,
    y2: 52.3196,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint181_linear_4217_57369",
    x1: 16.3079,
    y1: 52.3222,
    x2: 16.4269,
    y2: 52.3222,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint182_linear_4217_57369",
    x1: 16.0957,
    y1: 52.3217,
    x2: 16.2147,
    y2: 52.3217,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint183_linear_4217_57369",
    x1: 16.52,
    y1: 52.3224,
    x2: 17.2586,
    y2: 52.3224,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint184_linear_4217_57369",
    x1: 16.2109,
    y1: 47.8067,
    x2: 16.2846,
    y2: 47.8067,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint185_linear_4217_57369",
    x1: 16.2109,
    y1: 47.6006,
    x2: 16.2846,
    y2: 47.6006,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint186_linear_4217_57369",
    x1: 16.2109,
    y1: 47.3936,
    x2: 16.2846,
    y2: 47.3936,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint187_linear_4217_57369",
    x1: 16.2109,
    y1: 48.4288,
    x2: 16.2846,
    y2: 48.4288,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint188_linear_4217_57369",
    x1: 16.2109,
    y1: 48.2217,
    x2: 16.2846,
    y2: 48.2217,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint189_linear_4217_57369",
    x1: 16.2109,
    y1: 48.0157,
    x2: 16.2846,
    y2: 48.0157,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint190_linear_4217_57369",
    x1: 16.2109,
    y1: 49.0508,
    x2: 16.2846,
    y2: 49.0508,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint191_linear_4217_57369",
    x1: 16.2109,
    y1: 48.8438,
    x2: 16.2846,
    y2: 48.8438,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint192_linear_4217_57369",
    x1: 16.2109,
    y1: 48.6377,
    x2: 16.2846,
    y2: 48.6377,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint193_linear_4217_57369",
    x1: 16.2109,
    y1: 49.6729,
    x2: 16.2846,
    y2: 49.6729,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint194_linear_4217_57369",
    x1: 16.2109,
    y1: 49.4659,
    x2: 16.2846,
    y2: 49.4659,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint195_linear_4217_57369",
    x1: 16.2109,
    y1: 49.2598,
    x2: 16.2846,
    y2: 49.2598,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint196_linear_4217_57369",
    x1: 16.2109,
    y1: 50.0879,
    x2: 16.2846,
    y2: 50.0879,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint197_linear_4217_57369",
    x1: 16.2109,
    y1: 49.8815,
    x2: 16.2846,
    y2: 49.8815,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint198_linear_4217_57369",
    x1: 15.8904,
    y1: 50.5974,
    x2: 16.6044,
    y2: 50.5974,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint199_linear_4217_57369",
    x1: 19.1061,
    y1: 46.5823,
    x2: 19.1873,
    y2: 46.5823,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint200_linear_4217_57369",
    x1: 19.2526,
    y1: 46.5829,
    x2: 19.3338,
    y2: 46.5829,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint201_linear_4217_57369",
    x1: 19.3962,
    y1: 46.5825,
    x2: 19.478,
    y2: 46.5825,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint202_linear_4217_57369",
    x1: 18.6692,
    y1: 46.5818,
    x2: 18.7504,
    y2: 46.5818,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint203_linear_4217_57369",
    x1: 18.8151,
    y1: 46.582,
    x2: 18.8963,
    y2: 46.582,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint204_linear_4217_57369",
    x1: 18.9597,
    y1: 46.581,
    x2: 19.0409,
    y2: 46.581,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint205_linear_4217_57369",
    x1: 18.2317,
    y1: 46.5791,
    x2: 18.3129,
    y2: 46.5791,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint206_linear_4217_57369",
    x1: 18.3728,
    y1: 46.5781,
    x2: 18.4541,
    y2: 46.5781,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint207_linear_4217_57369",
    x1: 18.5228,
    y1: 46.5806,
    x2: 18.604,
    y2: 46.5806,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint208_linear_4217_57369",
    x1: 17.7948,
    y1: 46.5786,
    x2: 17.876,
    y2: 46.5786,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint209_linear_4217_57369",
    x1: 17.9402,
    y1: 46.5792,
    x2: 18.0214,
    y2: 46.5792,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint210_linear_4217_57369",
    x1: 18.0853,
    y1: 46.5801,
    x2: 18.1665,
    y2: 46.5801,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint211_linear_4217_57369",
    x1: 17.3573,
    y1: 46.5775,
    x2: 17.4385,
    y2: 46.5775,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint212_linear_4217_57369",
    x1: 17.5027,
    y1: 46.5778,
    x2: 17.5839,
    y2: 46.5778,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint213_linear_4217_57369",
    x1: 17.6478,
    y1: 46.579,
    x2: 17.729,
    y2: 46.579,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint214_linear_4217_57369",
    x1: 16.9287,
    y1: 46.5759,
    x2: 17.3537,
    y2: 46.5759,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint215_linear_4217_57369",
    x1: 13.9189,
    y1: 15.5473,
    x2: 13.9914,
    y2: 15.5473,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint216_linear_4217_57369",
    x1: 13.9189,
    y1: 15.3442,
    x2: 13.9914,
    y2: 15.3442,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint217_linear_4217_57369",
    x1: 13.9189,
    y1: 15.141,
    x2: 13.9914,
    y2: 15.141,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint218_linear_4217_57369",
    x1: 13.9189,
    y1: 16.1596,
    x2: 13.9914,
    y2: 16.1596,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint219_linear_4217_57369",
    x1: 13.9189,
    y1: 15.9555,
    x2: 13.9914,
    y2: 15.9555,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint220_linear_4217_57369",
    x1: 13.9189,
    y1: 15.7524,
    x2: 13.9914,
    y2: 15.7524,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint221_linear_4217_57369",
    x1: 13.9189,
    y1: 16.7709,
    x2: 13.9914,
    y2: 16.7709,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint222_linear_4217_57369",
    x1: 13.9189,
    y1: 16.5678,
    x2: 13.9914,
    y2: 16.5678,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint223_linear_4217_57369",
    x1: 13.9189,
    y1: 16.3647,
    x2: 13.9914,
    y2: 16.3647,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint224_linear_4217_57369",
    x1: 13.9189,
    y1: 17.3822,
    x2: 13.9914,
    y2: 17.3822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint225_linear_4217_57369",
    x1: 13.9189,
    y1: 17.1791,
    x2: 13.9914,
    y2: 17.1791,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint226_linear_4217_57369",
    x1: 13.9189,
    y1: 16.976,
    x2: 13.9914,
    y2: 16.976,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint227_linear_4217_57369",
    x1: 13.9189,
    y1: 17.7905,
    x2: 13.9914,
    y2: 17.7905,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint228_linear_4217_57369",
    x1: 13.9189,
    y1: 17.5873,
    x2: 13.9914,
    y2: 17.5873,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint229_linear_4217_57369",
    x1: 13.6042,
    y1: 18.2915,
    x2: 14.3057,
    y2: 18.2915,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint230_linear_4217_57369",
    x1: 13.8219,
    y1: 15.748,
    x2: 13.9787,
    y2: 15.748,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint231_linear_4217_57369",
    x1: 14.1024,
    y1: 15.7489,
    x2: 14.2592,
    y2: 15.7489,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint232_linear_4217_57369",
    x1: 14.3816,
    y1: 15.7488,
    x2: 14.5378,
    y2: 15.7488,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint233_linear_4217_57369",
    x1: 12.9818,
    y1: 15.7449,
    x2: 13.138,
    y2: 15.7449,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint234_linear_4217_57369",
    x1: 13.2608,
    y1: 15.7469,
    x2: 13.417,
    y2: 15.7469,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint235_linear_4217_57369",
    x1: 13.5404,
    y1: 15.7471,
    x2: 13.6972,
    y2: 15.7471,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint236_linear_4217_57369",
    x1: 12.1396,
    y1: 15.7441,
    x2: 12.2958,
    y2: 15.7441,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint237_linear_4217_57369",
    x1: 12.4199,
    y1: 15.744,
    x2: 12.5761,
    y2: 15.744,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint238_linear_4217_57369",
    x1: 12.6983,
    y1: 15.7449,
    x2: 12.8551,
    y2: 15.7449,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint239_linear_4217_57369",
    x1: 11.2976,
    y1: 15.7408,
    x2: 11.4544,
    y2: 15.7408,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint240_linear_4217_57369",
    x1: 11.5777,
    y1: 15.7423,
    x2: 11.7345,
    y2: 15.7423,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint241_linear_4217_57369",
    x1: 11.8574,
    y1: 15.7422,
    x2: 12.0136,
    y2: 15.7422,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint242_linear_4217_57369",
    x1: 10.7357,
    y1: 15.7401,
    x2: 10.8925,
    y2: 15.7401,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint243_linear_4217_57369",
    x1: 11.0154,
    y1: 15.74,
    x2: 11.1715,
    y2: 15.74,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint244_linear_4217_57369",
    x1: 9.6394,
    y1: 15.7391,
    x2: 10.6128,
    y2: 15.7391,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint245_linear_4217_57369",
    x1: 0,
    y1: 44.6132,
    x2: 2.71999,
    y2: 44.6132,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint246_linear_4217_57369",
    x1: 9.44566,
    y1: 52.3036,
    x2: 11.2766,
    y2: 52.3036,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint247_linear_4217_57369",
    x1: 17.9593,
    y1: 47.8106,
    x2: 18.3314,
    y2: 47.8106,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint248_linear_4217_57369",
    x1: 17.5078,
    y1: 48.1431,
    x2: 17.8743,
    y2: 48.1431,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint249_linear_4217_57369",
    x1: 19.5876,
    y1: 47.2907,
    x2: 19.9201,
    y2: 47.2907,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint250_linear_4217_57369",
    x1: 19.0139,
    y1: 47.3788,
    x2: 19.369,
    y2: 47.3788,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint251_linear_4217_57369",
    x1: 18.4675,
    y1: 47.5496,
    x2: 18.8365,
    y2: 47.5496,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint252_linear_4217_57369",
    x1: 21.251,
    y1: 47.5554,
    x2: 21.6199,
    y2: 47.5554,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint253_linear_4217_57369",
    x1: 20.7183,
    y1: 47.3804,
    x2: 21.0734,
    y2: 47.3804,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint254_linear_4217_57369",
    x1: 20.1694,
    y1: 47.2884,
    x2: 20.5025,
    y2: 47.2884,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint255_linear_4217_57369",
    x1: 22.6143,
    y1: 48.5463,
    x2: 22.9668,
    y2: 48.5463,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint256_linear_4217_57369",
    x1: 22.2112,
    y1: 48.1482,
    x2: 22.5776,
    y2: 48.1482,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint257_linear_4217_57369",
    x1: 21.7578,
    y1: 47.8126,
    x2: 22.1293,
    y2: 47.8126,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint258_linear_4217_57369",
    x1: 23.3887,
    y1: 50.0387,
    x2: 23.6424,
    y2: 50.0387,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint259_linear_4217_57369",
    x1: 23.2085,
    y1: 49.5066,
    x2: 23.5019,
    y2: 49.5066,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint260_linear_4217_57369",
    x1: 22.9509,
    y1: 49.0068,
    x2: 23.2764,
    y2: 49.0068,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint261_linear_4217_57369",
    x1: 23.3098,
    y1: 51.6989,
    x2: 23.5831,
    y2: 51.6989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint262_linear_4217_57369",
    x1: 23.4415,
    y1: 51.1546,
    x2: 23.672,
    y2: 51.1546,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint263_linear_4217_57369",
    x1: 23.4774,
    y1: 50.595,
    x2: 23.6827,
    y2: 50.595,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint264_linear_4217_57369",
    x1: 22.5851,
    y1: 52.9757,
    x2: 22.689,
    y2: 52.9757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint265_linear_4217_57369",
    x1: 22.7861,
    y1: 52.6982,
    x2: 23.1261,
    y2: 52.6982,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint266_linear_4217_57369",
    x1: 23.0846,
    y1: 52.2198,
    x2: 23.3969,
    y2: 52.2198,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint267_linear_4217_57369",
    x1: 16.9312,
    y1: 48.5217,
    x2: 17.7736,
    y2: 48.5217,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3AE21"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4217_57369"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 62,
    height: 42,
    fill: "white",
    transform: "translate(0 11)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrmLogo);
export default __webpack_public_path__ + "static/media/crm_logo.e6d1df92a5df9d6b05bd53c0281b5a42.svg";
export { ForwardRef as ReactComponent };